import { memo, React, useCallback, useEffect, useMemo, useRef, useState } from 'react';
import 'react-datepicker/dist/react-datepicker.css';
import { fetchGridLayout, getDecoder, getHyphenDDMMMYYYYHHMM, saveGridLayout, sortingDatesInGrid, readEximExcel, uploadBulkEximExcel, booleanData } from '../common/utils';
import RoutemapTransitAction from '../tracktrace/RoutemapTransitAction.js'
import moment from "moment";
import { Modal } from 'react-bootstrap';
import { AgGridReact } from 'ag-grid-react';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import SweetAlert from "react-bootstrap-sweetalert";
import redirectURL from "../redirectURL";
import MainCounters from './topLevelCounters.js'
import ViewMap from '../tracktrace/ViewMap';
import DrawMap from '../common/drawmap';
import RoutemapAction from '../tracktrace/routemapActionComponent.js';
import RouteNightDrivemap from '../tracktrace/routenightdrivemap.js';
import NoGPSMap from '../tracktrace/NoGPSMap.js';
import { useNavigate } from 'react-router-dom';
import ModelForceClose from '../tracktrace/modelForceClose.js';
import Filters from './filters.js';
import DeviationMap from '../tracktrace/DeviationMap.jsx';
import DeviationRouteMap from '../tracktrace/mapRouteDeviation.jsx';
import { ToggleSwitch } from './toggle.js';
import BulkUploadHL from './bulkupload.js';
import Legends from './Legends.js';
import DeliveredCounters from './deliveredConters.js';
import BulkForceClose from './bulkForceClose.js';
import ForceClosureModal from '../tracktrace/forceClosureModel.js';
import CheckList from './checkList.jsx'
import Select from 'react-select';
import * as XLSX from 'xlsx';
import Toast from '../../assets/toast.jsx';
import toastWarning from '../../assets/icons/toast_warning.png'
import toastError from '../../assets/icons/toast-error.png'
import Box from '../../assets/icons/box.svg'
import OtrView from './otrView.jsx';
var map = ''
function ActiveConsignments() {
    const user = useMemo(() => getDecoder(), []);
    const navigate = useNavigate();
    // const [visibleGroupID, setVisibleGroupID] = useState(null);
    const [toggle, setToggle] = useState(true);
    const gridApi = useRef();
    const gridApiConsignments = useRef();
    const columnApiConsignments = useRef(null);
    const reloadPage = useRef(false);
    var [rowData, setRowData] = useState([])
    var [filterToggle, setFilterToggle] = useState(false)
    // var [key, setKey] = useState('')
    const gridColumnState = useRef(null)
    const layoutApplied = useRef(false);
    const [overly, setOverlay] = useState("show-n")
    const [loadshow, setLoadShow] = useState("show-n")
    const [forcecloseModal, setForcecloseModal] = useState(false);
    const [filterCities, setFilterCities] = useState([]);
    const [filterStates, setFilterStates] = useState([]);
    const [filterTransporters, setFilterTransporters] = useState([]);
    const [filterConsigneeZones, setFilterConsigneeZones] = useState([]);
    const [filterConsigneeTypes, setFilterConsigneeTypes] = useState([]);
    const [filterPlantZones, setFilterPlantZones] = useState([]);
    const [searchCity, setSearchCity] = useState({ label: '', value: '' });
    const [searchState, setSearchStates] = useState({ label: '', value: '' });
    const [searchTransporters, setSearchTransporters] = useState({ label: '', value: '' });
    const [searchConsigner, setSearchConsigner] = useState([{ label: 'All', value: 'all' }]);
    const [consignersList, setConsignersList] = useState([]);
    const [consigneesList, setConsigneesList] = useState([]);
    const [startDate, setStartDate] = useState(new Date(moment.parseZone().subtract(10, "days")));
    const [endDate, setEndDate] = useState(new Date(moment.parseZone()));
    const topCounterAlt = useRef({ label: "Total Unique FOs", value: "uniqueFO" })
    const [middleCounter, setMiddleCounter] = useState({ label: "", value: "" });
    var [detailCellRendererParams, setdetailCellRendererParams] = useState(null);
    const [checklist, setChecklist] = useState(false);
    const [checklistData, setChecklistData] = useState([{}])
    const [otrData, setOtrData] = useState([])
    const [showOtr, setShowOtr] = useState(false)
    const [validData, setValidData] = useState([]);
    const [invalidData, setInvalidData] = useState([]);
    const [activeTab, setActiveTab] = useState('valid');
    const tabOptions = useMemo(() => [
        { label: "Active", value: "active" },
        { label: "Delivered", value: "completed" },
        { label: "All", value: "all" }
    ], []);
    const [tabName, setTabName] = useState(window.location.pathname == "/active-FOs" ? tabOptions[0] : (window.location.pathname == "/delivered-FOs" ? tabOptions[1] : tabOptions[2]));
    const all_rows_data = useRef([])
    var filterCardStyle1 = { minHeight: "244px" };
    const [rownode, setRownode] = useState([]);
    const [activeTopCounters, setActiveTopCounters] = useState({
        uniqueFO: 0,
        fo_deliveries: 0,
        hot_loads: 0,
        consent_pending: 0,
        consent_acquired: 0,
        GPS_data_acquired: 0,
    })
    const [CPCounterDate, setCPCounterDate] = useState({
        cp_oldest_fo: "N/A",
        cp_latest_fo: "N/A",
        cp_hot_loads_cp: 0,
    })
    const [activeTripsData, setActiveTripsData] = useState({
        total_unique_fo: [],
        total_fo_deliveries: [],
        total_hot_loads: [],
        GPS_data_acquired: [],
        gps_inside_plant: [],
        gps_in_transit: [],
        gps_transit_delays: [],
        gps_hot_loads: [],
        gps_overspeeding: [],
        gps_night_driving: [],
        gps_stoppages: [],
        gps_loading_delays: [],
        gps_unloading_delays: [],
        gps_deviated_routes: [],
        consent_acquired: [],
        sim_inside_plant: [],
        sim_in_transit: [],
        sim_transit_delays: [],
        sim_hot_loads: [],
        sim_overspeeding: [],
        sim_night_driving: [],
        sim_stoppages: [],
        sim_loading_delays: [],
        sim_unloading_delays: [],
        sim_deviated_routes: [],
        consent_pending: [],
        cp_latest_fo: [],
        cp_oldest_fo: [],
        cp_hot_loads: [],
        drop_total_hot_loads: [],
        drop_GPS_data_acquired: [],
        drop_gps_inside_plant: [],
        drop_gps_in_transit: [],
        drop_gps_transit_delays: [],
        drop_gps_hot_loads: [],
        drop_gps_overspeeding: [],
        drop_gps_night_driving: [],
        drop_gps_stoppages: [],
        drop_gps_loading_delays: [],
        drop_gps_unloading_delays: [],
        drop_gps_deviated_routes: [],
        drop_consent_acquired: [],
        drop_sim_inside_plant: [],
        drop_sim_in_transit: [],
        drop_sim_transit_delays: [],
        drop_sim_hot_loads: [],
        drop_sim_overspeeding: [],
        drop_sim_night_driving: [],
        drop_sim_stoppages: [],
        drop_sim_loading_delays: [],
        drop_sim_unloading_delays: [],
        drop_sim_deviated_routes: [],
        drop_consent_pending: [],
        drop_cp_oldest_fo: [],
        drop_cp_latest_fo: [],
        drop_cp_hot_loads: [],
    })
    const [activeTripsCounter, setActiveTripsCounters] = useState({
        inside_plant: 0,
        in_transit: 0,
        transit_delays: 0,
        hot_loads: 0,
        overspeeding: 0,
        night_driving: 0,
        stoppages: 0,
        loading_delays: 0,
        deviated_routes: 0,
    })
    const [deliveredTrips, setDeliveredTrips] = useState({
        total_unique_fo: [],
        total_hot_loads: [],
        total_fo_deliveries: [],
        fo_transit_delays: [],
        fo_on_time: [],
        fo_overspeeding: [],
        fo_night_driving: [],
        fo_stoppages: [],
        fo_loading_delays: [],
        fo_unloading_delays: [],
        fo_deviated_routes: [],
        fo_total_hot_loads: [],
        transit_delays: [],
        on_time: [],
        overspeeding: [],
        night_driving: [],
        stoppages: [],
        loading_delays: [],
        unloading_delays: [],
        deviated_routes: [],
    })
    const [deliveredTripsCounter, setDeliveredCounter] = useState({
        total_unique_fo: 0,
        total_hot_loads: 0,
        total_fo_deliveries: 0,
        transit_delays: 0,
        on_time: 0,
        overspeeding: 0,
        night_driving: 0,
        stoppages: 0,
        loading_delays: 0,
        unloading_delays: 0,
        deviated_routes: 0,
    })
    // const [allTrips, setAllTrips] = useState({
    //     all: [],
    //     transit_delay: [],
    //     overspeeding: [],
    //     night_driving: [],
    //     stoppages: [],
    //     accidents: [],
    //     deviation_identified: [],
    //     loading_delay: [],
    //     unloading_delay: [],
    //     no_gps_data: [],
    //     no_gps_data_lifetime: []
    // })
    const [modalloadData, setModalLoadData] = useState([])
    const [plantData, setPlantData] = useState([])
    const [transporters, setTransporters] = useState([])
    const [dealers, setDealers] = useState([])
    const [eximPlantData, setEximPlantData] = useState([])
    const [eximTransporters, setEximTransporters] = useState([])
    const [eximDealers, setEximDealers] = useState([])
    const [originOptions, setOriginOptions] = useState([]);
    const forceClosureReason = useRef({
        reasonMap: [],
        mainReason: new Map(),
    })
    const fileRef = useRef()
    const [show, setShow] = useState(false)
    const [feeds, setFeeds] = useState([])
    const [title, setTitle] = useState('')
    const [type, setType] = useState('default')
    // const [loader, setLoader] = useState(false)
    const [overly2, setOverly2] = useState("show-n")
    const [bulkUploadModal, setBulkUploadModal] = useState({
        overly: "show-n",
        bulkPrioritySlide: ""
    })
    const [openMap, setOpenMap] = useState({
        sliderRouteTranslate: "",
        showDiv: 'show-n',
        mapinfo: [],
        dealer: "",
        consignment_code: "",
        maptruckno: "",
        geofence_coordinates: [],
        parking_coordinates: [],
        routeTruck: { "truck_no": '', "startTime": '', "endTime": '' },
        loadshow: 'show-n',
        sidebarSubHeader: "",
        overly: 'show-m',
        rownode: {},
        leg_no: 0,
        tolls: []
    })
    const [openMap2, setOpenMap2] = useState({
        open: false,
        rownode: []
    })
    const [forceClosureData, setForceClosureData] = useState("")
    const [bulkType, setBulkType] = useState('')
    const [toast, setToast] = useState({
        toastMessage: '',
        toastTitle: "",
        showToast: false,
        toastImage: ''
    })
    const [consigneeDetails, setConsigneeDetails] = useState([])
    // const [countersActive, setCountersActive] = useState({
    //     consignments: 0,
    //     transit_delays: 0,
    //     overspeeding: 0,
    //     night_driving: 0,
    //     stoppages: 0,
    //     accidents: 0,
    //     deviation_identified: 0,
    //     loading_delay: 0,
    //     unloading_delay: 0,
    //     no_gps_data: 0,
    //     no_gps_data_lifetime: 0
    // })
    // const [countersCompleted, setCountersCompleted] = useState({
    //     consignments: 0,
    //     transit_delays: 0,
    //     overspeeding: 0,
    //     night_driving: 0,
    //     stoppages: 0,
    //     accidents: 0,
    //     deviation_identified: 0,
    //     loading_delay: 0,
    //     unloading_delay: 0,
    //     no_gps_data: 0,
    //     no_gps_data_lifetime: 0
    // })
    // const [countersAll, setCountersAll] = useState({
    //     consignments: 0,
    //     transit_delays: 0,
    //     overspeeding: 0,
    //     night_driving: 0,
    //     stoppages: 0,
    //     accidents: 0,
    //     deviation_identified: 0,
    //     loading_delay: 0,
    //     unloading_delay: 0,
    //     no_gps_data: 0,
    //     no_gps_data_lifetime: 0
    // })
    const transitdelaycols = useMemo(() => {
        return [
            {
                headerName: "", field: "_id",
                cellRendererSelector: function (param) {
                    try {
                        if (param.data._id != null && param.data._id != undefined) {
                            return {
                                component: RoutemapTransitAction,
                                params: {
                                    onShowTransitRouteMap: onShowTransitRouteMap
                                }
                            }
                        }
                    } catch (err) {
                        console.log(err);
                    }
                },
                width: 50,
                cellClass: function (params) {
                    if (params.data.leg_transit_delay == 0 && params.data.processed == 1) {
                        return 'green';
                    }
                    else if (params.data.processed == 1 && params.data.leg_transit_delay == 1) {
                        return 'lightred';
                    }
                    else {
                        return '';
                    }

                }
            },
            {
                headerName: "Vehicle No.", field: "truck_no", width: 120, resizable: true,
                cellClass: function (params) {
                    if (params.data.leg_transit_delay == 0 && params.data.processed == 1) {
                        return 'green';
                    }
                    else if (params.data.processed == 1 && params.data.leg_transit_delay == 1) {
                        return 'lightred';
                    }
                    else {
                        return '';
                    }
                }
            },
            {
                headerName: "Leg Start Time", field: "leg_start", width: 120, resizable: true,
                valueGetter: function (params) {
                    return getHyphenDDMMMYYYYHHMM(params.data.leg_start);
                },
                comparator: (date1, date2) => sortingDatesInGrid(date1, date2),
                cellClass: function (params) {
                    if (params.data.leg_transit_delay == 0 && params.data.processed == 1) {
                        return 'green';
                    }
                    else if (params.data.processed == 1 && params.data.leg_transit_delay == 1) {
                        return 'lightred';
                    }
                    else {
                        return '';
                    }

                }
            },
            {
                headerName: "Leg End Time", field: "leg_end_eta",
                width: 120, resizable: true,
                valueGetter: function (params) {
                    return getHyphenDDMMMYYYYHHMM(params.data.leg_end_eta);
                },
                comparator: (date1, date2) => sortingDatesInGrid(date1, date2),
                cellClass: function (params) {
                    if (params.data.leg_transit_delay == 0 && params.data.processed == 1) {
                        return 'green';
                    }
                    else if (params.data.processed == 1 && params.data.leg_transit_delay == 1) {
                        return 'lightred';
                    }
                    else {
                        return '';
                    }
                }
            },
            {
                headerName: "Exp. Leg Distance (KM)",
                field: "leg_expected_distance", width: 140, resizable: true,
                valueGetter: function (params) {
                    return Math.round(params.data.leg_expected_distance);
                },
                cellClass: function (params) {
                    if (params.data.leg_transit_delay == 0 && params.data.processed == 1) {
                        return 'green';
                    }
                    else if (params.data.processed == 1 && params.data.leg_transit_delay == 1) {
                        return 'lightred';
                    }
                    else {
                        return '';
                    }

                }
            },
            {
                headerName: "Actual Leg Distance Covered (KM)",
                field: "actual_leg_distance", width: 140, resizable: true,
                valueGetter: function (params) {
                    if (params.data.actual_leg_distance != '' && params.data.actual_leg_distance != undefined) {
                        return Math.round(params.data.actual_leg_distance);
                    }
                    else {
                        return 0;
                    }
                },
                cellClass: function (params) {
                    if (params.data.leg_transit_delay == 0 && params.data.processed == 1) {
                        return 'green';
                    }
                    else if (params.data.processed == 1 && params.data.leg_transit_delay == 1) {
                        return 'lightred';
                    }
                    else {
                        return '';
                    }

                }
            },
            {
                headerName: "Exp. Distance from Trip Start(KM)",
                field: "expected_distance_start_to_leg", width: 140, resizable: true,
                valueGetter: function (params) {
                    if (params.data.expected_distance_start_to_leg != '' && params.data.expected_distance_start_to_leg != undefined) {
                        return Math.round(params.data.expected_distance_start_to_leg);
                    }
                    else {
                        return 0;
                    }

                },
                cellClass: function (params) {
                    if (params.data.leg_transit_delay == 0 && params.data.processed == 1) {
                        return 'green';
                    }
                    else if (params.data.processed == 1 && params.data.leg_transit_delay == 1) {
                        return 'lightred';
                    }
                    else {
                        return '';
                    }

                }

            },
            {
                headerName: "Actual Distance from Trip Start (KM)",
                field: "actual_distance_traveled_start_to_leg", width: 140, resizable: true,
                valueGetter: function (params) {
                    if (params.data.actual_distance_traveled_start_to_leg != '' && params.data.actual_distance_traveled_start_to_leg != undefined) {
                        return Math.round(params.data.actual_distance_traveled_start_to_leg);
                    }
                    else {
                        return 0;
                    }

                },
                cellClass: function (params) {
                    if (params.data.leg_transit_delay == 0 && params.data.processed == 1) {
                        return 'green';
                    }
                    else if (params.data.processed == 1 && params.data.leg_transit_delay == 1) {
                        return 'lightred';
                    }
                    else {
                        return '';
                    }

                }


            },
            // {
            //     headerName: "Google Distance from Start (KM)",
            //     field: "actual_start_to_leg_google_distance",
            //     width: 140,
            //     resizable: true,
            //     cellClass: function (params) {
            //         if (params.data.leg_transit_delay == 0 && params.data.processed == 1) {
            //             return 'green';
            //         }
            //         else if (params.data.processed == 1 && params.data.leg_transit_delay == 1) {
            //             return 'lightred';
            //         }
            //         else {
            //             return '';
            //         }

            //     }


            // },
            {
                headerName: "GPS Data Available",
                field: "no_gps_data",
                width: 140,
                resizable: true,
                valueGetter: function (params) {
                    if (params.data.no_gps_data == 1) {
                        return "Not Available";
                    }
                    if (params.data.no_gps_data == 0) {
                        return "Available";
                    }

                },
                cellClass: function (params) {
                    if (params.data.leg_transit_delay == 0 && params.data.processed == 1) {
                        return 'green';
                    }
                    else if (params.data.processed == 1 && params.data.leg_transit_delay == 1) {
                        return 'lightred';
                    }
                    else {
                        return '';
                    }

                }


            },


            {
                headerName: "Trip Completed",
                field: "trip_completed",
                width: 140,
                resizable: true,
                valueGetter: function (params) {
                    if (params.data.trip_completed == 1) {
                        return "Yes";
                    }
                    if (params.data.trip_completed == 2) {
                        return "";
                    }
                    if (params.data.trip_completed == 0) {
                        return "";
                    }

                },
                cellClass: function (params) {
                    if (params.data.leg_transit_delay == 0 && params.data.processed == 1) {
                        return 'green';
                    }
                    else if (params.data.processed == 1 && params.data.leg_transit_delay == 1) {
                        return 'lightred';
                    }
                    else {
                        return '';
                    }

                }
            },
        ]
    }, []);
    const stoppagescols = useMemo(() => {
        return [
            // {
            //     headerName: "",
            //     field: "_id",
            //     cellRendererSelector: function (param) {
            //         try {
            //             if (param.data._id != null && param.data._id != undefined) {
            //                 return {
            //                     component: RoutemapenrouteAction,
            //                     params: {
            //                         onShowEnrouteRouteMap: onShowEnrouteRouteMap
            //                     }
            //                 }
            //             }
            //         } catch (err) {
            //             console.log(err);
            //         }
            //     },
            //     width: 50,
            //     suppressSizeToFit: true,
            // },
            {
                headerName: "Break Start",
                field: "stoppage_start_time",
                width: 150,
                resizable: true,
                valueGetter: function (params) {
                    if (params.data.stoppage_start_time != undefined) {
                        return getHyphenDDMMMYYYYHHMM(params.data.stoppage_start_time)
                    }
                    else {
                        return '';
                    }

                },
                comparator: (date1, date2) => sortingDatesInGrid(date1, date2),
            },
            {
                headerName: "Break End",
                field: "reset_datetime",
                width: 150,
                resizable: true,
                valueGetter: function (params) {
                    if (params.data.reset_datetime != undefined) {
                        return getHyphenDDMMMYYYYHHMM(params.data.reset_datetime)
                    }
                    else {
                        return '';
                    }
                },
                comparator: (date1, date2) => sortingDatesInGrid(date1, date2),
            },
            {
                headerName: "Exception Closed On",
                field: "modified_date",
                width: 220,
                resizable: true,
                valueGetter: function (params) {
                    if (params.data.exception_closed == 1) {

                        if (params.data.modified_date != undefined) {
                            return getHyphenDDMMMYYYYHHMM(params.data.modified_date)
                        }
                        else {
                            return '';
                        }
                    }
                    else {
                        return '';
                    }
                },
                comparator: (date1, date2) => sortingDatesInGrid(date1, date2),
            },
            {
                headerName: "Break Time",
                field: "elaped_time_from_last_moved_seconds",
                width: 180,
                resizable: true,
                valueGetter: function (params) {
                    if (params.data.exception_closed == 1) {
                        var sdate = moment.parseZone(params.data.stoppage_start_time).format("x");
                        if (typeof params.data.reset_datetime == 'undefined') {
                            var edate = moment.parseZone().format("x");
                        }
                        else {
                            var edate = moment.parseZone(params.data.reset_datetime).format("x");
                        }
                        var diff = (edate - sdate) / 1000;
                        return secondsToString(diff);
                    }
                    else {
                        return '';
                    }
                }
            }
        ]
    }, []);
    const overspeedcols = useMemo(() => {
        return [
            {
                headerName: "", field: "_id",
                width: 50,
                cellRendererSelector: function (param) {
                    try {
                        if (param.data._id != null && param.data._id != undefined) {
                            return {
                                component: RoutemapAction,
                                params: {
                                    onShowRouteMap: onShowRouteMap
                                }
                            }
                        }
                    } catch (err) {
                        console.log(err);
                    }
                },
                resizable: true
            },
            { headerName: "Vehicle No.", field: "truck_no", filter: true, resizable: true },
            { headerName: "Speed (km/h)", field: "speed", filter: true, resizable: true },
            {
                headerName: "Reported At", field: "first_instance", filter: true, resizable: true,
                valueGetter: function (params) {
                    return getHyphenDDMMMYYYYHHMM(params.data.first_instance);
                },
                comparator: (date1, date2) => sortingDatesInGrid(date1, date2),
            },
        ]
    }, []);
    const nightdrivingcols = useMemo(() => {
        return [
            {
                headerName: "", field: "_id",
                cellRendererSelector: function (param) {
                    try {
                        if (param.data._id != null && param.data._id != undefined) {
                            return {
                                component: RouteNightDrivemap,
                                params: {
                                    onShowNightDriveRouteMap: onShowNightDriveRouteMap
                                }
                            }
                        }
                    } catch (err) {
                        console.log(err);
                    }
                },
                width: 50,
                suppressSizeToFit: true
            },
            { headerName: "Vehicle No.", field: "truck_no", width: 122, resizable: true },
            {
                headerName: "Traveled From", field: "first_instance", width: 180, resizable: true,
                valueGetter: function (params) {
                    return getHyphenDDMMMYYYYHHMM(params.data.first_instance);
                },
                comparator: (date1, date2) => sortingDatesInGrid(date1, date2),
            },
            {
                headerName: "Traveled Until", field: "recent_instance", resizable: true,
                valueGetter: function (params) {
                    return getHyphenDDMMMYYYYHHMM(params.data.recent_instance);
                },
                comparator: (date1, date2) => sortingDatesInGrid(date1, date2),
            },
            {
                headerName: "Distance Traveled (km)", field: "distance_from_first_instance", width: 180,
                resizable: true,
                valueGetter: function (params) {
                    return Math.round(params.data.distance_from_first_instance)
                }
            }
        ]
    }, []);
    const deviationlogscols = useMemo(() => {
        return [
            {
                headerName: "", field: "_id",
                cellRendererSelector: function (param) {
                    try {
                        if (param.data._id != null && param.data._id != undefined) {
                            return {
                                component: DeviationMap,
                                params: {
                                    onShowDeviationRouteMap: onShowDeviationRouteMap
                                }
                            }
                        }
                    } catch (err) {
                        console.log(err);
                    }
                },
                width: 50,
                suppressSizeToFit: true
            },
            { headerName: "Vehicle No.", field: "truck_no", width: 122, resizable: true },
            {
                headerName: "Deviation On", field: "deviation_timestamp", width: 180, resizable: true,
                valueGetter: function (params) {
                    return getHyphenDDMMMYYYYHHMM(params.data.deviation_timestamp);
                },
                comparator: (date1, date2) => sortingDatesInGrid(date1, date2),
            },
            {
                headerName: "Deviation Address", field: "deviation_address", resizable: true
            },
            {
                headerName: "Lattitude", field: "deviation_lat", resizable: true
            },
            {
                headerName: "Longtitude", field: "deviation_lng", resizable: true
            }
        ]
    }, []);
    const unloadingcols = useMemo(() => {
        return [
            {
                headerName: "From Date",
                field: "from_date",
                width: 180,
                resizable: true,
                valueGetter: function (params) {
                    if (params.data.from_date != undefined) {
                        return getHyphenDDMMMYYYYHHMM(params.data.from_date);
                    }
                    else {
                        return "N/A"
                    }
                },
                comparator: (date1, date2) => sortingDatesInGrid(date1, date2),
            },
            {
                headerName: "To Date",
                field: "to_date",
                width: 180,
                resizable: true,
                valueGetter: function (params) {
                    if (params.data.to_date != undefined) {
                        return getHyphenDDMMMYYYYHHMM(params.data.to_date);
                    }
                    else {
                        return "N/A"
                    }
                },
                comparator: (date1, date2) => sortingDatesInGrid(date1, date2),
            },
            {
                headerName: "Unloading Time",
                field: "unloading_time",
                width: 180,
            }
        ]
    }, []);
    const fodetails = useMemo(() => {
        return [
            {
                headerName: "Type",
                field: "mobile_log_df",
                valueGetter: function (params) {
                    return params.data?.dealer_code && params.data?.dealer_name ? 'SFTP' : 'MOBILE'
                }
            },
            {
                headerName: "Truck No.",
                field: "truck_no"
            },
            {
                headerName: "Driver Mobile No.",
                field: 'driver_mobile_no'
            }, {
                headerName: 'Dealer Code',
                field: 'dealer_code'
            },
            {
                headerName: 'Driver Name',
                field: 'driver_name'
            },
            {
                headerName: 'Dealer Name',
                field: 'dealer_name'
            },
            {
                headerName: 'Created Date',
                field: 'created_date',
                valueGetter: function (params) {
                    return !['', null, undefined].includes(params.data.created_date) ? getHyphenDDMMMYYYYHHMM(params.data.created_date) : ''
                }
            },
            {
                headerName: 'Consent Initiated On',
                field: 'consent_initiated_at',
                valueGetter: function (params) {
                    return !['', null, undefined].includes(params.data.consent_initiated_at) ? getHyphenDDMMMYYYYHHMM(params.data.consent_initiated_at) : ''
                }
            },
            {
                headerName: 'Gate In Received On',
                field: 'gate_in_time',
                valueGetter: function (params) {
                    return !['', null, undefined].includes(params.data.gate_in_time) ? getHyphenDDMMMYYYYHHMM(params.data.gate_in_time) : ''
                }
            },
            {
                headerName: 'Gate Out Received On',
                field: 'gate_out_time',
                valueGetter: function (params) {
                    return !['', null, undefined].includes(params.data.gate_out_time) ? getHyphenDDMMMYYYYHHMM(params.data.gate_out_time) : ''
                }
            },
            {
                headerName: 'Gate In Done By',
                field: 'email'
            },

        ]
    }, [])
    const item_details = [{
        headerName: "Item ID",
        field: "item_id"
    },
    {
        headerName: 'Item Description',
        field: 'item_desc'
    },
    {
        headerName: 'Gross Weight Qty (Unit)',
        field: 'gross_wt_qty',
        valueGetter: function (params) {
            try {
                return [null, undefined, ''].includes(params?.data?.gross_wt_qty) ? '' : params.data.gross_wt_qty + ' ' + '(' + params.data.gross_wt_unit + ')'
            }
            catch (e) {
                return ''
            }

        }
    },
    {
        headerName: 'Gross Volume Qty (Unit)',
        field: 'gross_vol_qty',
        valueGetter: function (params) {
            try {
                return [null, undefined, ''].includes(params?.data?.gross_vol_qty) ? '' : params.data.gross_vol_qty + ' ' + '(' + params.data.gross_vol_unit + ')'
            }
            catch (e) {
                return ''
            }
        }

    },
    {
        headerName: 'Net Weight Qty (Unit)',
        field: 'net_wt_qty',
        valueGetter: function (params) {
            try {
                return [null, undefined, ''].includes(params?.data?.net_wt_qty) ? '' : params.data.net_wt_qty + ' ' + '(' + params.data.net_wt_unit + ')'
            }
            catch (e) {
                return ''
            }
        }

    },
    {
        headerName: 'Qty In Cases (Unit)',
        field: 'qty_in_cases',
        valueGetter: function (params) {
            try {
                return [null, undefined, ''].includes(params?.data?.qty_in_cases) ? '' : params.data.qty_in_cases + ' ' + '(' + params.data.qty_cases_unit + ')'
            }
            catch (e) {
                return ''
            }
        }
    },
    {
        headerName: "Material Code",
        field: 'material_code'
    },
    {
        headerName: "Price",
        field: 'price'
    }
    ]
    const defaultColDef = useMemo(() => {
        return {
            sortable: true,
            filter: true,
            autoSizeColumns: true,
            resizable: true,
            pivot: true,
        }
    }, []);
    const rowSelection = useMemo(() => {
        if (tabName.value == "completed")
            return {}
        return {
            mode: "multiRow",
            enableSelectionWithoutKeys: true,
            enableClickSelection: false,
            headerCheckboxSelectionFilteredOnly: true, // 👈 KEY PART
            headerCheckbox: true,
        };
    }, []);

    const validConsignmentColumnDef = useMemo(() => {
        return [
            {
                headerName: "Plant Location Code",
                field: "plant_code",
                width: 180,
                editable: false,
                cellStyle: params => {
                    const isInvalid = !params.data.plant_code || (plantData.length > 0 && !plantData.some(e => e.consigner_code === params.data.plant_code))
                    return {
                        "backgroundColor": isInvalid ? '#c85f62' : ''
                    };
                }
            },
            {
                headerName: "FO Number",
                field: "fo_number",
                editable: false,
                width: 128,
                cellStyle: params => {
                    const isInvalid = params.data.fo_number == undefined || params.data.fo_number == "" || !params.data.fo_number.startsWith('I30') || params.data.status == 'invalid';
                    return {
                        "backgroundColor": isInvalid ? '#c85f62' : ''
                    };
                }
            },
            {
                headerName: "Invoice Date",
                field: "invoice_date",
                width: 128,
                editable: false,
                cellStyle: params => {
                    const isInvalid = params.data.invoice_date == undefined || params.data.invoice_date == "" || (!moment(params.data.invoice_date, "DD/MM/YYYY HH:mm", false).isValid())
                    return {
                        "backgroundColor": isInvalid ? '#c85f62' : ''
                    };
                }
            },
            {
                headerName: "Vehicle No",
                field: "vehicle_no",
                width: 122,
                editable: false,
                cellStyle: params => {
                    const isInvalid = params.data.vehicle_no == undefined || params.data.vehicle_no == ""
                    return {
                        "backgroundColor": isInvalid ? '#c85f62' : ''
                    };
                }
            },
            {
                headerName: "Vehicle Type",
                field: "vehicle_type",
                editable: false,
                width: 128,
            },
            {
                headerName: "Driver Name",
                field: "driver_name",
                width: 150,
                editable: false,
                cellStyle: params => {
                    const isInvalid = params.data.driver_name == undefined || params.data.driver_name == ""
                    return {
                        "backgroundColor": isInvalid ? '#c85f62' : ''
                    };
                }
            },
            {
                headerName: "Driver No",
                field: "driver_number",
                width: 128,
                editable: false,
                cellStyle: params => {
                    if (params.data.driver_number == undefined || params.data.driver_number == "") {
                        return {
                            "backgroundColor": '#c85f62'
                        };
                    }
                    else if (!(/^[6-9]\d{9}$/.test(params.data.driver_number))) {
                        return {
                            "backgroundColor": '#c85f62'
                        };
                    }
                    else {
                        return {
                            "backgroundColor": ''
                        }
                    }
                }
            },
            {
                headerName: "Transporter Code",
                field: "transporter_code",
                editable: false,
                width: 158,
                cellStyle: params => {
                    const isInvalid = params.data.transporter_code == undefined || params.data.transporter_code == "" || (transporters.length > 0 && !transporters.some(e => e.transporter_code == params.data.transporter_code))
                    return {
                        "backgroundColor": isInvalid ? '#c85f62' : ''
                    };
                }
            },
            {
                headerName: "Transporter Name",
                field: "transporter_name",
                editable: false
            },
            {
                headerName: "Dealer Code",
                field: "dealer_code",
                editable: false,
                cellStyle: params => {
                    const isInvalid = params.data.dealer_code == undefined || params.data.dealer_code == "" || (dealers.length > 0 && !dealers.some(e => e.consignee_code == params.data.dealer_code))
                    return {
                        "backgroundColor": isInvalid ? '#c85f62' : ''
                    };
                }
            },
            {
                headerName: "Dealer Name",
                field: "dealer_name",
                editable: false
            },
            {
                headerName: "Dealer City",
                field: "dealer_city",
                editable: false
            },
            {
                headerName: "Expected Delivery Date",
                field: "expected_date",
                editable: false,
                cellStyle: params => {
                    const isInvalid = params.data.expected_date == undefined || params.data.expected_date == "" || (!moment(params.data.expected_date, "DD/MM/YYYY HH:mm", true).isValid())
                    return {
                        "backgroundColor": isInvalid ? '#c85f62' : ''
                    };
                }
            },
        ]
    }, [plantData, dealers, transporters])
    const columnDefs = useMemo(() => {
        return [
            {
                headerName: "Container No",
                field: "fo_number",
                editable: false,
                width: 150,
                cellStyle: params => {
                    const invalidFo = params.data.fo_number == undefined || params.data.status == 'invalid' || params.data.fo_number == ''
                    return {
                        backgroundColor: invalidFo ? '#c85f62' : ''
                    }
                }
            },
            {
                headerName: "Plant Code",
                field: "plant_code",
                width: 120,
                editable: false,
                cellStyle: params => {
                    const isInvalid = !params.data.plant_code || ((eximPlantData.length > 0 && !eximPlantData.includes(params.data.plant_code)) && (eximDealers.length > 0 && !eximDealers.includes(params.data.plant_code)));
                    return {
                        "backgroundColor": isInvalid ? '#c85f62' : ''
                    };
                }
            },
            {
                headerName: "Consignee Code",
                field: "dealer_code",
                editable: false,
                cellStyle: params => {
                    const isInvalid = params.data.dealer_code == undefined || params.data.dealer_code == "" || ((eximDealers.length > 0 && !eximDealers.includes(params.data.dealer_code)) && (eximPlantData.length > 0 && !eximPlantData.includes(params.data.dealer_code)));
                    return {
                        "backgroundColor": isInvalid ? '#c85f62' : ''
                    };

                }
            },
            {
                headerName: "Truck No",
                field: "vehicle_no",
                editable: false,
                width: 178,
                cellStyle: params => {
                    const inInvalid = params.data.vehicle_no == '' || params.data.vehicle_no == null || params.data.vehicle_no == undefined
                    return {
                        backgroundColor: inInvalid ? '#c85f62' : ''
                    }
                }
            },
            {
                headerName: "Transporter Code",
                field: "transporter_code",
                editable: false,
                width: 158,
                cellStyle: params => {
                    const isInValidTransporter = params.data.transporter_code == undefined || params.data.transporter_code == "" || (eximTransporters.length > 0 && !eximTransporters.includes(params.data.transporter_code))
                    return {
                        "backgroundColor": isInValidTransporter ? '#c85f62' : ''
                    }
                }
            },
            {
                headerName: "Date & Time Of Dispatch",
                field: "date_of_dispatch",
                editable: false,
                width: 200,
                cellStyle: params => {
                    const invalid = params.data.date_of_dispatch == '' || params.data.date_of_dispatch == undefined || params.data.date_of_dispatch == null || (!moment(params.data.date_of_dispatch, "DD/MM/YYYY HH:mm", true).isValid())
                    return {
                        backgroundColor: invalid ? '#c85f62' : ''
                    }
                }
            }
        ]
    }, [eximDealers, eximPlantData, eximTransporters])
    const nogpscols = [
        {
            headerName: "",
            field: "_id",
            cellRendererSelector: function (param) {
                try {
                    if (param.data._id != null && param.data._id != undefined) {
                        return {
                            component: NoGPSMap,
                            params: {
                                onShowNoGPSRouteMap: onShowNoGPSRouteMap
                            }
                        }
                    }
                } catch (err) {
                    console.log(err);
                }
            },
            width: 50,
            suppressSizeToFit: true,
            cellClass: function (params) {
                if (params.data.leg_transit_delay == 0 && params.data.processed == 1) {
                    return 'green';
                }
                else if (params.data.processed == 1 && params.data.leg_transit_delay == 1) {
                    return 'lightred';
                }
                else {
                    return '';
                }

            }
        },
        {
            headerName: "Vehicle No.", field: "truck_no", width: 122, resizable: true,
            cellClass: function (params) {
                if (params.data.leg_transit_delay == 0 && params.data.processed == 1) {
                    return 'green';
                }
                else if (params.data.processed == 1 && params.data.leg_transit_delay == 1) {
                    return 'lightred';
                }
                else {
                    return '';
                }

            }
        },
        {
            headerName: "Last Data Receieved",
            field: "last_packet_datetime",
            width: 180,
            resizable: true,
            valueGetter: function (params) {
                return getHyphenDDMMMYYYYHHMM(params.data.last_packet_datetime);
            },
            comparator: (date1, date2) => {
                if (date1 != "" && date2 != "" && date1 != undefined && date2 != undefined) {
                    let d1 = moment(date1, 'DD/MMM/YYYY HH:mm')
                    let d2 = moment(date2, 'DD/MMM/YYYY HH:mm')
                    return d2.isBefore(d1) ? 1 : -1
                }
            },
            cellClass: function (params) {
                if (params.data.leg_transit_delay == 0 && params.data.processed == 1) {
                    return 'green';
                }
                else if (params.data.processed == 1 && params.data.leg_transit_delay == 1) {
                    return 'lightred';
                }
                else {
                    return '';
                }

            }
        },
        {
            headerName: "Data Received on",
            field: "packet_received_on",
            width: 180,
            resizable: true,
            valueGetter: function (params) {
                return getHyphenDDMMMYYYYHHMM(params.data.packet_received_on);
            },
            comparator: (date1, date2) => {
                if (date1 != "" && date2 != "" && date1 != undefined && date2 != undefined) {
                    let d1 = moment(date1, 'DD/MMM/YYYY HH:mm')
                    let d2 = moment(date2, 'DD/MMM/YYYY HH:mm')
                    return d2.isBefore(d1) ? 1 : -1
                }
            },
            cellClass: function (params) {
                if (params.data.leg_transit_delay == 0 && params.data.processed == 1) {
                    return 'green';
                }
                else if (params.data.processed == 1 && params.data.leg_transit_delay == 1) {
                    return 'lightred';
                }
                else {
                    return '';
                }

            }
        }
    ]
    const columnDefs3 = useMemo(() => {
        return [
            {
                headerName: "",
                field: "",
                width: 50,
                pinned: "left",
                filter: false,
                suppressMenu: true,
                cellRendererSelector: function (param) {
                    try {
                        if (param.data._id != null && param.data._id != undefined) {
                            return {
                                component: ViewMap,
                                params: {
                                    onClickShowRoute: onClickShowMap
                                }
                            }
                        }
                    } catch (err) {
                        console.log(err);
                    }
                },
                cellStyle: { display: "flex", justifyContent: "center", alignItems: "center", cursor: "pointer" }
            },
            {
                headerName: "",
                field: "tansit_delay_click",
                width: 50,
                pinned: "left",
                filter: false,
                suppressMenu: true,
                cellRenderer: (param) => {
                    return (
                        <i className="icofont icofont-clock-time f20" title='Transit Delay' style={{ color: (param?.data?.transit_delay != undefined && param?.data?.transit_delay == 1) ? "#FF5370" : "#cccc" }}></i>
                    )
                },
                cellStyle: { display: "flex", justifyContent: "center", alignItems: "center", cursor: "pointer" }
            },
            {
                headerName: "",
                field: "overspeeding_click",
                width: 50,
                pinned: "left",
                filter: false,
                suppressMenu: true,
                cellRenderer: (param) => {
                    return (
                        <i className="fa fa-tachometer f20" title='Overspeeding' style={{ color: (param?.data?.overspeeding_exception != undefined && param?.data?.overspeeding_exception == 1) ? "#3300c2" : "#cccc" }}></i>
                    )
                },
                cellStyle: { display: "flex", justifyContent: "center", alignItems: "center", cursor: "pointer" }
            },
            {
                headerName: "",
                field: "nigthdriving_click",
                width: 50,
                pinned: "left",
                filter: false,
                suppressMenu: true,
                cellRenderer: (param) => {
                    return (
                        <i className="icofont icofont-full-night f20" title='Night Driving' style={{ color: (param?.data?.nightdriving_exception != undefined && param?.data?.nightdriving_exception == 1) ? "#ab8ce4" : "#cccc" }}></i>
                    )
                },
                cellStyle: { display: "flex", justifyContent: "center", alignItems: "center", cursor: "pointer" }
            },
            {
                headerName: "",
                field: "stoppage_click",
                width: 50,
                pinned: "left",
                filter: false,
                suppressMenu: true,
                cellRenderer: (param) => {
                    return (
                        <i className="icofont icofont-pause f20" title='Stoppage' style={{ color: (param?.data?.enroute_exception != undefined && param?.data?.enroute_exception == 1) ? "#a34518" : "#cccc" }}></i>
                    )
                },
                cellStyle: { display: "flex", justifyContent: "center", alignItems: "center", cursor: "pointer" }
            },
            {
                headerName: "",
                field: "deviation_click",
                width: 50,
                pinned: "left",
                filter: false,
                suppressMenu: true,
                cellRenderer: (param) => {
                    return (
                        <i className="fa fa-random f20" title='Deviated Routes' style={{ color: (param?.data?.deviation_identified != undefined && param?.data?.deviation_identified == 1) ? "#9f08b2" : "#cccc" }}></i>
                    )
                },
                cellStyle: { display: "flex", justifyContent: "center", alignItems: "center", cursor: "pointer" }
            },
            {
                headerName: "",
                field: "loading_click",
                width: 50,
                pinned: "left",
                filter: false,
                suppressMenu: true,
                cellRenderer: (param) => {
                    return (
                        <i className="icofont icofont-truck-alt f20" title='Loading Delay' style={{ color: (param?.data?.loading_delay_exception != undefined && param?.data?.loading_delay_exception == 1) ? "#d3a337" : "#cccc" }}></i>
                    )
                },
                cellStyle: { display: "flex", justifyContent: "center", alignItems: "center", cursor: "pointer" }
            },
            {
                headerName: "",
                field: "unloading_click",
                width: 50,
                pinned: "left",
                filter: false,
                suppressMenu: true,
                // hide: (tabName?.value == "active" ? true : false),
                cellRenderer: (param) => {
                    return (
                        <i className="icofont icofont-vehicle-delivery-van f18" title='Unloading Delay' style={{ color: (param?.data?.unloading_delay_exception != undefined && param?.data?.unloading_delay_exception == 1) ? "#7ad337" : "#cccc" }}></i>
                    )
                },
                cellStyle: { display: "flex", justifyContent: "center", alignItems: "center", cursor: "pointer" }
            },
            {
                headerName: "",
                field: "fo_details",
                width: 50,
                pinned: "left",
                filter: false,
                suppressMenu: true,
                cellRenderer: (param) => {
                    return (
                        <i className="icofont icofont-file-text f18" title='FO Updates' style={{ color: "#1e749c" }}></i>
                    )
                },
                cellStyle: { display: "flex", justifyContent: "center", alignItems: "center", cursor: "pointer" }
            },
            {
                headerName: "", pinned: "left", field: "gate_in_type", colId: "view_checklist", filter: true, width: 130,
                valueGetter: function (params) {
                    const status = Number(params?.data?.checklist_rej_status);
                    const hasChecklist = !!params?.data?.checklist;

                    if (status === 1 || status === 2) {
                        return "Rejected";
                    }
                    else if (params.data?.checklist_status) {
                        return params.data.checklist_status

                    }
                    if (hasChecklist) {
                        return "Approved";
                    }

                    return "";
                },
                cellRenderer: (params) => {
                    let isEnabled = false
                    if (params.data?.checklist != undefined && params.data?.checklist != null && params.data?.checklist != "") {
                        isEnabled = true
                    }

                    let accepted = parseInt(params.data.checklist_rej_status)
                    let trip_status = ""
                    if (params.data?.checklist_status) {
                        trip_status = params.data.checklist_status
                    }
                    else {
                        trip_status = accepted == 0 ? "Approved" : (accepted === 1 || accepted === 2) ? "Rejected" : ""
                    }

                    let ibl_checklist_submitted = params.data?.ibl_checklist_submitted || 0

                    let enable_status = isEnabled || ibl_checklist_submitted == 1

                    // let isEnabled = [1].includes(params.data.status)
                    return (
                        <button
                            className='label label-success'
                            title="View Checklist"
                            style={{
                                border: (accepted === 1 || accepted === 2)
                                    ? "1px solid #dc3545"
                                    : params.data?.checklist_status == "Pending for approval" ? "1px solid #ef8816"

                                        : (isEnabled || ibl_checklist_submitted == 1 ? "1px solid #28a745" : "1px solid #d4d5d5"),

                                backgroundColor: (accepted === 1 || accepted === 2)
                                    ? "#dc3545"
                                    : params.data?.checklist_status == "Pending for approval" ? "#ef8816"

                                        : (isEnabled || ibl_checklist_submitted == 1 ? " #28a745" : " #d4d5d5"),

                                padding: "2px 10px",
                                fontSize: "10px",
                                borderRadius: "3px",
                                cursor: "pointer",
                                height: "20px",
                                color: "#fff"
                            }}
                            disabled={!enable_status}
                            onClick={() => {
                                setChecklist(true)
                                if (isEnabled || ibl_checklist_submitted == 1)
                                    setChecklistData({ ...params.data, trip_status })
                            }}
                        >
                            View Checklist
                        </button>
                    )
                }
            },
            {
                headerName: "", pinned: "left", field: "is_otr_submitted", colId: "view_otr", filter: true, width: 130,
                valueGetter: function (params) {
                    const otr_submitted = Number(params?.data?.is_otr_submitted || 0);

                    if (otr_submitted === 1) {
                        return "Approved";
                    }
                    return "";
                },
                cellRenderer: (params) => {
                    let otr_submitted = Number(params?.data?.is_otr_submitted || 0)

                    return (
                        <button
                            className='label label-success'
                            title="View OTR"
                            style={{
                                border: (otr_submitted === 1 ? "1px solid #28a745" : "1px solid #d4d5d5"),

                                backgroundColor: (otr_submitted === 1 ? " #28a745" : " #d4d5d5"),

                                padding: "2px 10px",
                                fontSize: "10px",
                                borderRadius: "3px",
                                cursor: "pointer",
                                height: "20px",
                                color: "#fff"
                            }}
                            disabled={!otr_submitted === 1}
                            onClick={() => {
                                setShowOtr(true)
                                if (otr_submitted === 1)
                                    setOtrData({ ...params.data })
                            }}
                        >
                            View OTR
                        </button>
                    )
                }
            },

            {
                headerName: "",

                field: "item_details",

                width: 50,

                pinned: "left",

                filter: false,

                suppressMenu: true,

                cellRenderer: (param) => {

                    return (

                        <img src={Box} title='Materials'></img>

                    )

                },

                cellStyle: { display: "flex", justifyContent: "center", alignItems: "center", cursor: "pointer" }

            },
            {
                headerName: "",
                field: "id", // or some unique field
                checkboxSelection: true,
                headerCheckboxSelection: true,
                headerCheckboxSelectionFilteredOnly: true, // ✅ only select current page
                width: 50,
                filter: false,
                sort: false,
                suppressMenu: true
            },
            {
                headerName: "FO Number",
                field: "fo_number",
                width: 150,
            },
            {
                headerName: "Vehicle No.",
                field: "truck_no",
                width: 122,
            },
            {
                headerName: "Customer Code",
                field: "consignee_code"
            },
            {
                headerName: "Status",
                field: "status",
                width: 148,
                valueGetter: function (params) {
                    if (params.data.status == 1) {
                        if (params.data.gate_in_time == undefined || params.data.gate_in_time == null || params.data.gate_in_time == "") {
                            if (params.data?.manual_gate_in == undefined || params.data?.manual_gate_in == null || params.data?.manual_gate_in == "")
                                return "Consignment Created"
                            return "Inside Plant"
                        }
                        else
                            return "Inside Plant";
                    }
                    else if (params.data.status == 2) {
                        return "In Transit";
                    }
                    else if (params.data.status == 3) {
                        return "Near Customer";
                    }
                    else if (params.data.status == 4) {
                        return "Reached Customer";
                    }
                    else if (params.data.status == 5) {
                        return "Left Customer";
                    }
                    else if (params.data.status == 6) {
                        return "Force Closed";
                    }
                    else if (params.data.status == 7) {
                        return "Proximity Trip Closure";
                    }
                    else if (params.data.status == 8) {
                        return "Cancelled";
                    }
                    else if (params.data.status == 9) {
                        return "Trip Closed";
                    }
                    else {
                        return "N/A";
                    }
                }
            },
            {
                headerName: "SIM Consent Status",
                field: "sim_tracking_state",
                width: 188,
                valueGetter: function (params) {
                    try {
                        if (params.data.tracking_mode == "GPS")
                            return "Approved"
                        else {
                            if (params.data.sim_tracking_state == 3 || params.data.sim_tracking_state == 18) {
                                return "Approved";
                            }
                            else if (params.data.sim_tracking_state == 4 || params.data.sim_tracking_state == 7 || params.data.sim_tracking_state == 12 ||
                                params.data.sim_tracking_state == 15 || params.data.sim_tracking_state == 16 ||
                                params.data.sim_tracking_state == 17 || params.data.sim_tracking_state == 19 ||
                                params.data.sim_tracking_state == 20 || params.data.sim_tracking_state == 21 ||
                                params.data.sim_tracking_state == 23 || params.data.sim_tracking_state == 24 ||
                                params.data.sim_tracking_state == 25 || params.data.sim_tracking_state == 26) {
                                return "Consent Approved";
                            }
                            else if (params.data.sim_tracking_state == 5 || params.data.sim_tracking_state == 6 || params.data.sim_tracking_state == 11 || params.data.sim_tracking_state == 22) {
                                return "Consent Pending";
                            }
                            else if (params.data.sim_tracking_state == 8 || params.data.sim_tracking_state == 10) {
                                return "Consent Declined";
                            }
                            else if (params.data.sim_tracking_state == 9 || params.data.sim_tracking_state == 18) {
                                return "Approved";
                            }
                            else if (params.data.sim_tracking_state == 13) {
                                return "Error";
                            }
                            else if (params.data.sim_tracking_state == 1 || params.data.sim_tracking_state == 2 || params.data.sim_tracking_state == 14 || params.data.prob_service_provider == "bsnl") {
                                return "Not Registered";
                            }
                        }
                    }
                    catch (e) {
                        // console.log(e)
                    }
                },
            },
            {
                headerName: "Expected ETA (Nestlé)",
                field: "expected_eta",
                // headerComponent: headerComponent,
                valueGetter: function (params) {
                    if (params.data.expected_eta != undefined && params.data.expected_eta != '') {
                        return getHyphenDDMMMYYYYHHMM(params.data.expected_eta)
                    }
                },
                comparator: (date1, date2) => sortingDatesInGrid(date1, date2),
            },
            {
                headerName: "Expected ETA (Enmovil)",
                field: "new_expected_eta",
                valueGetter: function (params) {
                    if (params.data.new_expected_eta != undefined && params.data.new_expected_eta != '') {
                        return getHyphenDDMMMYYYYHHMM(params.data.new_expected_eta)
                    }
                },
                comparator: (date1, date2) => sortingDatesInGrid(date1, date2),
            },
            {
                headerName: "Revised ETA (Enmovil)",
                field: "revised_trip_end",
                valueGetter: function (params) {
                    if (params.data.revised_trip_end != undefined && params.data.revised_trip_end != '') {
                        return getHyphenDDMMMYYYYHHMM(params.data.revised_trip_end)
                    }
                },
                comparator: (date1, date2) => sortingDatesInGrid(date1, date2),
                cellStyle: function (params) {
                    try {
                        let hourDifference = 0;
                        if (params.data.revised_trip_end && params.data.expected_trip_end) {
                            let revisedDateOnlyMoment = moment(params.data.revised_trip_end);
                            let expectedDateOnlyMoment = moment(params.data.expected_trip_end);
                            hourDifference = revisedDateOnlyMoment.diff(expectedDateOnlyMoment, 'hours');
                        } else {
                        }
                        if (hourDifference >= 1) {
                            return { backgroundColor: "#ff90a3" };
                        }
                        if (hourDifference <= -1) {
                            return { backgroundColor: "#00dea7" };
                        }
                        else {
                            return ''
                        }
                    } catch (error) {
                    }
                },
                comparator: (date1, date2) => sortingDatesInGrid(date1, date2),
            },
            {
                headerName: "Tracking Mode",
                field: "tracking_mode"
            },
            {
                headerName: 'Movement Type',
                field: 'movement_type',
            },
            {
                headerName: "Invoice Date",
                field: "invoice_time",
                width: 128,
                valueGetter: function (params) {
                    if (params.data.invoice_time != undefined && params.data.invoice_time != '') {
                        return getHyphenDDMMMYYYYHHMM(params.data.invoice_time)
                    }
                },
                comparator: (date1, date2) => sortingDatesInGrid(date1, date2),
            },
            {
                headerName: "Created Date",
                field: "created_date",
                valueGetter: function (params) {
                    if (params.data.created_date != undefined && params.data.created_date != '') {
                        return getHyphenDDMMMYYYYHHMM(params.data.created_date)
                    }
                },
                comparator: (date1, date2) => sortingDatesInGrid(date1, date2),
            },
            {
                headerName: 'Customer Email',
                field: 'is_consignee_mail_exists',
                valueGetter: function (params) {
                    if (params.data.is_consignee_mail_exists != undefined && params.data.is_consignee_mail_exists != '' && params.data.is_consignee_mail_exists == 1) {
                        return "Yes"
                    }
                    else {
                        return "No"
                    }
                }
            },
            {
                headerName: 'Customer Mobile No.',
                field: 'is_consignee_no_exists',
                valueGetter: function (params) {
                    if (params.data.is_consignee_no_exists != undefined && params.data.is_consignee_no_exists != '' && params.data.is_consignee_no_exists == 1) {
                        return "Yes"
                    }
                    else {
                        return "No"
                    }
                }
            },
            {
                headerName: "Driver Name",
                field: "driver_name",
                width: 128,
                valueGetter: function (params) {
                    return params.data.driver_name == "nan" ? "" : params.data.driver_name

                }
            },
            {
                headerName: "Driver Phone No.",
                field: "driver_mobile_no",
                width: 128
            },
            {
                headerName: "Customer Name",
                field: "consignee_name"
            },
            {
                headerName: "Customer Address",
                field: "consignee_address"
            },
            {
                headerName: "Customer Type",
                field: "consignee_type"
            },
            {
                headerName: "Customer City",
                field: "consignee_city"
            },
            {
                headerName: "Customer State",
                field: "consignee_state"
            },
            {
                headerName: "Delay Status",
                field: "new_delay_status",
            },
            {
                headerName: "Customer Zone",
                field: "consignee_zone",
            },
            {
                headerName: "Vehicle Type",
                field: "truck_type",
                width: 128,
            },
            {
                headerName: "Plant Code",
                field: "consigner_code",
                width: 120
            },
            {
                headerName: "Plant Name",
                field: "consigner_name",
                width: 130,
                valueGetter: function (params) {
                    if (params.data.consigner_name != undefined && params.data.consigner_name != '') {
                        return params.data.consigner_name
                    }
                }
            },
            {
                headerName: "Plant Zone",
                field: "consigner_zone"
            },
            {
                headerName: "Plant In Event",
                field: "plantin_flag",
                width: 120,
                valueGetter: function (params) {
                    if (params.data.plantin_flag != undefined && params.data.plantin_flag != "" && params.data.plantin_flag == 1) {
                        return "Success"
                    }
                    else {
                        return ""
                    }
                }
            },
            {
                headerName: "Plant Out Event",
                field: "plantout_flag",
                width: 120,
                valueGetter: function (params) {
                    if (params.data.plantout_flag != undefined && params.data.plantout_flag != "" && params.data.plantout_flag == 1) {
                        return "Success"
                    }
                    else {
                        return ""
                    }
                }
            },
            // {
            //     headerName: "Gate In Time",
            //     field: "gate_in_time",
            //     width: 130,
            //     valueGetter: function (params) {
            //         if (params.data.gate_in_time != undefined && params.data.gate_in_time != '') {
            //             return getHyphenDDMMMYYYYHHMM(params.data.gate_in_time)
            //         }
            //     },
            //     comparator: (date1, date2) => sortingDatesInGrid(date1, date2),
            // },
            // {
            //     headerName: "Gate Out Time",
            //     field: "gate_out_time",
            //     width: 144,
            //     valueGetter: function (params) {
            //         if (params.data.gate_out_time != undefined && params.data.gate_out_time != '') {
            //             return getHyphenDDMMMYYYYHHMM(params.data.gate_out_time)
            //         }
            //     },
            //     comparator: (date1, date2) => sortingDatesInGrid(date1, date2),
            // },
            {
                headerName: "Reached Customer",
                field: "recent_dealer_reported",
                width: 144,
                valueGetter: function (params) {
                    if (params.data.status >= 4) {
                        if (params.data.recent_dealer_reported != undefined && params.data.recent_dealer_reported != '') {
                            return getHyphenDDMMMYYYYHHMM(params.data.recent_dealer_reported)
                        }
                    }
                    else {
                        return ""
                    }
                },
                comparator: (date1, date2) => sortingDatesInGrid(date1, date2),
            },
            {
                headerName: "Dealer In Event",
                field: "dealerin_flag",
                width: 120,

                valueGetter: function (params) {
                    if (params.data.dealerin_flag != undefined && params.data.dealerin_flag != "" && params.data.dealerin_flag == 1) {
                        return "Success"
                    }
                    else {
                        return ""
                    }
                }
            },
            {
                headerName: "Dealer Out Event",
                field: "dealerout_flag",
                width: 120,
                valueGetter: function (params) {
                    if (params.data.dealerout_flag != undefined && params.data.dealerout_flag != "" && params.data.dealerout_flag == 1) {
                        return "Success"
                    }
                    else {
                        return ""
                    }
                }
            },
            {
                headerName: "Left Customer",
                field: "left_dealer_marked",
                width: 144,
                valueGetter: function (params) {
                    if (params.data.left_dealer_marked != undefined && params.data.left_dealer_marked != '') {
                        return getHyphenDDMMMYYYYHHMM(params.data.left_dealer_marked)
                    }
                },
                comparator: (date1, date2) => sortingDatesInGrid(date1, date2),
            },
            {
                headerName: "Transporter Code",
                field: "transporter_code",
                width: 158,
            },
            {
                headerName: "Transporter Name",
                field: "transporter_name"
            },
            {
                headerName: 'FC OwnerShip',
                field: 'fc_ownership',
            },
            {
                headerName: 'Standard Fc Remarks',
                field: 'standard_fc_remark'
            },
            {
                headerName: "Last Packet Time",
                field: "last_packet_time",
                valueGetter: function (params) {
                    if (params.data.last_packet_time != undefined && params.data.last_packet_time != '') {
                        return getHyphenDDMMMYYYYHHMM(params.data.last_packet_time)
                    }
                },
                comparator: (date1, date2) => sortingDatesInGrid(date1, date2),
            },
            {
                headerName: "Distance(Customer to Plant)",
                field: "dealer_distance_from_plant",
                width: 240
            },
            {
                headerName: "e-POD submitted date",
                field: "epod_submitted_pod_date",
                valueGetter: function (params) {
                    if (params.data.epod_submitted_pod_date != undefined && params.data.epod_submitted_pod_date != '') {
                        return getHyphenDDMMMYYYYHHMM(params.data.epod_submitted_pod_date)
                    }
                },
                comparator: (date1, date2) => sortingDatesInGrid(date1, date2),
            },
            {
                headerName: "e-POD submitted location",
                field: "epod_submitted_location",
                valueGetter: function (params) {
                    if (!!params.data.epod_submitted_location) {
                        try {
                            let temp = JSON.parse(params.data.epod_submitted_location)
                            return `${temp.lat}, ${temp.lng}`
                        } catch (error) {
                            return ""
                        }
                    }
                },
            },
            {
                headerName: "Force/Trip Close Reason",
                field: "force_closure_reason",
                valueGetter: function (params) {
                    if (params.data.status == 6) {
                        return params.data.force_closure_reason
                    }
                    else if (params.data.status == 9)
                        return params.data.trip_closure_reason
                },
            },
            {
                headerName: "Force/Trip Close Secondary Reason",
                field: "force_closure_reason_secondary"
            },
            {
                headerName: "Force/Trip Close Date",
                field: "force_closure_time",
                valueGetter: function (params) {
                    if (params.data.status == 6) {
                        return getHyphenDDMMMYYYYHHMM(params.data.force_closure_time)
                    }
                    else if (params.data.status == 9)
                        return getHyphenDDMMMYYYYHHMM(params.data.trip_closure_done)
                },
                comparator: (date1, date2) => sortingDatesInGrid(date1, date2),
            },
            {
                headerName: "Force Close Done By",
                field: "force_closure_performed_by",
            },
            {
                headerName: "Force Close",
                field: "force_close",
                hide: true,
                cellRendererSelector: function (param) {
                    try {
                        if (param.data._id != null && param.data._id != undefined) {
                            return {
                                component: ForceClosureModal,
                                params: {
                                    forceClosureReason: forceClosureReason.current,
                                    user: user,
                                    loadData: changeReloadPage,
                                    setShow: setShow,
                                    setTitle: setTitle,
                                    setType: setType
                                }
                            }
                        }
                    } catch (err) {
                        console.log(err);
                    }
                },
                cellStyle: { display: "flex", justifyContent: "center", alignItems: "center", cursor: "pointer" }
            },
            {
                headerName: "Shipment creation Email Triggered At",
                field: "send_cons_created_mail_time",
                valueGetter: function (params) {
                    console.log(params, "params")
                    if (params.data.send_cons_created_mail_time != undefined && params.data.send_cons_created_mail_time != '') {
                        return getHyphenDDMMMYYYYHHMM(params.data.send_cons_created_mail_time)
                    }
                },
                comparator: (date1, date2) => sortingDatesInGrid(date1, date2),
            },
            {
                headerName: "Shipment creation SMS Triggered At",
                field: "send_cons_created_sms_time",
                valueGetter: function (params) {
                    if (params.data.send_cons_created_sms_time != undefined && params.data.send_cons_created_sms_time != '') {
                        return getHyphenDDMMMYYYYHHMM(params.data.send_cons_created_sms_time)
                    }
                },
                comparator: (date1, date2) => sortingDatesInGrid(date1, date2),
            },
            {
                headerName: "Shipment expected Email Triggered At",
                field: "eta_mail_sent_time",
                valueGetter: function (params) {
                    if (params.data.eta_mail_sent_time != undefined && params.data.eta_mail_sent_time != '') {
                        return getHyphenDDMMMYYYYHHMM(params.data.eta_mail_sent_time)
                    }
                },
                comparator: (date1, date2) => sortingDatesInGrid(date1, date2),
            },
            {
                headerName: "Shipment expected SMS Triggered At",
                field: "send_cons_eta_sms_time",
                valueGetter: function (params) {
                    if (params.data.send_cons_eta_sms_time != undefined && params.data.send_cons_eta_sms_time != '') {
                        return getHyphenDDMMMYYYYHHMM(params.data.send_cons_eta_sms_time)
                    }
                },
                comparator: (date1, date2) => sortingDatesInGrid(date1, date2),
            },
            {
                headerName: "Packet Count",
                field: "packet_count",
                width: 144,
                hide: true
            },
            {
                headerName: 'Invoice Number / BOE No.',
                field: 'invoice_no',
                width: 230
            },
            // {
            //     headerName: "Gate In Flag",
            //     field: "gate_in_flag",
            //     width: 144,
            //     hide: true
            // },
            // {
            //     headerName: "Gate Out Flag",
            //     field: "gate_out_flag",
            //     width: 144,
            //     hide: true
            // },
            {
                headerName: "Service Provider",
                field: "prob_service_provider",
                hide: true
            },
            {
                headerName: "Mobile Gate In",
                field: "manual_gate_in",
                valueGetter: function (params) {
                    if (params.data?.manual_gate_in != undefined && params.data?.manual_gate_in != '') {
                        return getHyphenDDMMMYYYYHHMM(params.data?.manual_gate_in)
                    }
                },
                comparator: (date1, date2) => sortingDatesInGrid(date1, date2),
                width: 144
            },
            {
                headerName: "Mobile Gate Out",
                field: "manual_gate_out",
                valueGetter: function (params) {
                    if (params.data?.manual_gate_out != undefined && params.data?.manual_gate_out != '') {
                        return getHyphenDDMMMYYYYHHMM(params.data?.manual_gate_out)
                    }
                },
                comparator: (date1, date2) => sortingDatesInGrid(date1, date2),
                width: 144
            },
            {
                headerName: "Geofence Gate In",
                field: "gate_in_time",
                valueGetter: function (params) {
                    if (params.data.gate_in_time != undefined && params.data.gate_in_time != '') {
                        return getHyphenDDMMMYYYYHHMM(params.data.gate_in_time)
                    }
                },
                comparator: (date1, date2) => sortingDatesInGrid(date1, date2),
                width: 144
            },
            {
                headerName: "Geofence Gate Out",
                field: "gate_out_time",
                valueGetter: function (params) {
                    if (params.data.gate_out_time != undefined && params.data.gate_out_time != '') {
                        return getHyphenDDMMMYYYYHHMM(params.data.gate_out_time)
                    }
                },
                comparator: (date1, date2) => sortingDatesInGrid(date1, date2),
                width: 144
            },

            {
                headerName: "Link Access Count",
                field: "tracking_link_count",
                width: 140,
                resizable: true,
                valueGetter: function (param) {
                    if (param.data.tracking_link_count != null && param.data.tracking_link_count != undefined && param.data.tracking_link_count != "") {
                        return param.data.tracking_link_count
                    }
                    else {
                        return 0
                    }
                }
            },
            {
                headerName: "Check List Type",
                field: "checklist",
                valueGetter: function (params) {
                    const isInbound = params.data?.ibl_checklist_submitted == 1;
                    const isOutbound =
                        params.data?.checklist !== undefined &&
                        params.data?.checklist !== null &&
                        params.data?.checklist !== "";

                    if (isInbound && isOutbound) {
                        return "Inbound, Outbound"; // ✅ string
                    } else if (isInbound) {
                        return "Inbound";
                    } else if (isOutbound) {
                        return "Outbound";
                    } else {
                        return "";
                    }
                }
            },
            {
                headerName: "Inbound Vehicle No.",
                field: "inbound_truck_no",
                width: 122,
            },
        ]
    }, []);

    useEffect(() => {
        if (window.location.pathname == "/active-FOs" || window.location.pathname == "/all-FOs") {
            if (middleCounter.value != undefined && middleCounter.value != "") {
                let counter = ''
                if (topCounterAlt.current.value == "consent_acquired")
                    counter = "sim_" + middleCounter.value
                else if (topCounterAlt.current.value == "GPS_data_acquired")
                    counter = "gps_" + middleCounter.value
                else
                    counter = middleCounter.value
                CounterClick(counter, 1)
            }
            else
                CounterClick(topCounterAlt.current.value, 1)
            if (toggle) {
                if (topCounterAlt.current.value == "consent_acquired") {
                    setActiveTripsCounters({
                        inside_plant: activeTripsData.sim_inside_plant.size,
                        in_transit: activeTripsData.sim_in_transit.size,
                        transit_delays: activeTripsData.sim_transit_delays.size,
                        hot_loads: activeTripsData.sim_hot_loads.size,
                        overspeeding: activeTripsData.sim_overspeeding.size,
                        night_driving: activeTripsData.sim_night_driving.size,
                        stoppages: activeTripsData.sim_stoppages.size,
                        loading_delays: activeTripsData.sim_loading_delays.size,
                        unloading_delays: activeTripsData.sim_unloading_delays.size,
                        deviated_routes: activeTripsData.sim_deviated_routes.size,
                    })
                }
                else if (topCounterAlt.current.value == "GPS_data_acquired") {
                    setActiveTripsCounters({
                        inside_plant: activeTripsData.gps_inside_plant.size,
                        in_transit: activeTripsData.gps_in_transit.size,
                        transit_delays: activeTripsData.gps_transit_delays.size,
                        hot_loads: activeTripsData.gps_hot_loads.size,
                        overspeeding: activeTripsData.gps_overspeeding.size,
                        night_driving: activeTripsData.gps_night_driving.size,
                        stoppages: activeTripsData.gps_stoppages.size,
                        loading_delays: activeTripsData.gps_loading_delays.size,
                        unloading_delays: activeTripsData.gps_unloading_delays.size,
                        deviated_routes: activeTripsData.gps_deviated_routes.size,
                    })
                }
                setActiveTopCounters(prevState => ({
                    ...prevState,
                    consent_pending: activeTripsData.consent_pending.size,
                    consent_acquired: activeTripsData.consent_acquired.size,
                    GPS_data_acquired: activeTripsData.GPS_data_acquired.size,
                }))
            }
            else {
                if (topCounterAlt.current.value == "consent_acquired") {
                    setActiveTripsCounters({
                        inside_plant: activeTripsData.drop_sim_inside_plant.size,
                        in_transit: activeTripsData.drop_sim_in_transit.size,
                        transit_delays: activeTripsData.drop_sim_transit_delays.size,
                        hot_loads: activeTripsData.drop_sim_hot_loads.size,
                        overspeeding: activeTripsData.drop_sim_overspeeding.size,
                        night_driving: activeTripsData.drop_sim_night_driving.size,
                        stoppages: activeTripsData.drop_sim_stoppages.size,
                        loading_delays: activeTripsData.drop_sim_loading_delays.size,
                        unloading_delays: activeTripsData.drop_sim_unloading_delays.size,
                        deviated_routes: activeTripsData.drop_sim_deviated_routes.size,
                    })
                }
                else if (topCounterAlt.current.value == "GPS_data_acquired") {
                    setActiveTripsCounters({
                        inside_plant: activeTripsData.drop_gps_inside_plant.size,
                        in_transit: activeTripsData.drop_gps_in_transit.size,
                        transit_delays: activeTripsData.drop_gps_transit_delays.size,
                        hot_loads: activeTripsData.drop_gps_hot_loads.size,
                        overspeeding: activeTripsData.drop_gps_overspeeding.size,
                        night_driving: activeTripsData.drop_gps_night_driving.size,
                        stoppages: activeTripsData.drop_gps_stoppages.size,
                        loading_delays: activeTripsData.drop_gps_loading_delays.size,
                        unloading_delays: activeTripsData.drop_gps_unloading_delays.size,
                        deviated_routes: activeTripsData.drop_gps_deviated_routes.size,
                    })
                }
                setActiveTopCounters(prevState => ({
                    ...prevState,
                    consent_pending: activeTripsData.drop_consent_pending.size,
                    consent_acquired: activeTripsData.drop_consent_acquired.size,
                    GPS_data_acquired: activeTripsData.drop_GPS_data_acquired.size,
                }))
            }
        }
        else if (window.location.pathname == "/delivered-FOs") {
            if (toggle) {
                setDeliveredCounter(prevState => ({
                    ...prevState,
                    total_hot_loads: deliveredTrips.fo_total_hot_loads.length,
                    transit_delays: deliveredTrips.fo_transit_delays.length,
                    on_time: deliveredTrips.fo_on_time.length,
                    overspeeding: deliveredTrips.fo_overspeeding.length,
                    night_driving: deliveredTrips.fo_night_driving.length,
                    stoppages: deliveredTrips.fo_stoppages.length,
                    loading_delays: deliveredTrips.fo_loading_delays.length,
                    unloading_delays: deliveredTrips.fo_unloading_delays.length,
                    deviated_routes: deliveredTrips.fo_deviated_routes.length,
                }))
            }
            else {
                setDeliveredCounter(prevState => ({
                    ...prevState,
                    total_hot_loads: deliveredTrips.total_hot_loads.length,
                    transit_delays: deliveredTrips.transit_delays.length,
                    on_time: deliveredTrips.on_time.length,
                    overspeeding: deliveredTrips.overspeeding.length,
                    night_driving: deliveredTrips.night_driving.length,
                    stoppages: deliveredTrips.stoppages.length,
                    loading_delays: deliveredTrips.loading_delays.length,
                    unloading_delays: deliveredTrips.unloading_delays.length,
                    deviated_routes: deliveredTrips.deviated_routes.length,
                }))
            }
        }
    }, [toggle])

    const onClickHideAll = () => {
        setBulkType('')
        if (!!fileRef?.current)
            fileRef.current.value = ''
        setOpenMap2({
            open: false,
            rownode: {}
        })
        setOpenMap({
            sliderRouteTranslate: "",
            showDiv: 'show-n',
            mapinfo: [],
            dealer: "",
            consignment_code: "",
            maptruckno: "",
            geofence_coordinates: [],
            parking_coordinates: [],
            routeTruck: { "truck_no": '', "startTime": '', "endTime": '' },
            loadshow: 'show-n',
            sidebarSubHeader: "",
            overly: 'show-m',
            rownode: {},
            leg_no: 0,
            tolls: []
        })
        setBulkUploadModal({
            overly: "show-n",
            bulkPrioritySlide: ""
        })
        setModalLoadData([])
        setOverlay("show-n")
        setLoadShow("show-n")
        setInvalidData([])
        setValidData([])
    }

    const closeForceCloseModal = (e) => {
        setForcecloseModal(false)
        setRownode([])
    }

    const onClickShowMap = (rownode) => {
        if (topCounterAlt.current.value == "uniqueFO")
            onClickShowRoute(rownode)
        else
            onClickShowRouteLegs(rownode)
    }

    const onShowForceCloseModal = (e) => {
        setForcecloseModal(true)
        setRownode(e)
    }

    const saveGrid = async (e) => {
        let tab_coloumndef = ''
        if (window.location.pathname == "/active-FOs") {
            tab_coloumndef = 'consignments_active'
        }
        else if (window.location.pathname == "/all-FOs") {
            tab_coloumndef = 'consignments_all'
        }
        else if (window.location.pathname == "/delivered-FOs") {
            tab_coloumndef = 'consignments_delivered'
        }
        let coloumnState = columnApiConsignments.current.api.getColumnState()
        let temp = await saveGridLayout(user.email, tab_coloumndef, coloumnState)
        reloadPage.current = 4;
        gridColumnState.current = coloumnState
        if (temp.data.status == "success") {
            setShow(true)
            setTitle("Grid successfully updated")
            setType("success")
        }
        else {
            setShow(true)
            setTitle("Failed to update grid")
            setType("danger")
        }
    }

    const resetGrid = async (e) => {
        let coloumnState = []
        let tab_coloumndef = ''
        if (window.location.pathname == "/active-FOs") {
            tab_coloumndef = 'consignments_active'
        }
        else if (window.location.pathname == "/all-FOs") {
            tab_coloumndef = 'consignments_all'
        }
        else if (window.location.pathname == "/delivered-FOs") {
            tab_coloumndef = 'consignments_delivered'
        }
        let temp = await saveGridLayout(user.email, tab_coloumndef, coloumnState)
        if (temp.data.status == "success") {
            gridColumnState.current = coloumnState
            setShow(true)
            setTitle("Grid successfully reset")
            setType("success")
            columnApiConsignments.current.api.resetColumnState()
        }
        else {
            setShow(true)
            setTitle("Failed to reset grid")
            setType("danger")
        }
    }

    const markHotLoads = async (e) => {
        let fo_numbers = []
        let data = columnApiConsignments.current.api.getSelectedNodes()
        for (var i = 0; i < data.length; i++) {
            if (data[i].data.status == 1 || data[i].data.status == 2 || data[i].data.status == 3)
                fo_numbers.push(data[i].data.fo_number)
            else {
                fo_numbers = []
                setShow(true)
                setTitle("Select only FO's with status as Consignment Created, Inside Plant, In Transit, Near Customer")
                setType("info")
                break
            }
        }
        if (fo_numbers.length > 0) {
            setLoadShow("show-m")
            setOverlay("show-m")
            let body = {
                fo_numbers
            }
            await redirectURL.post("/markHotLoads", body)
                .then(response => {
                    if (response.data.status == "success") {
                        setShow(true)
                        setTitle(response.data.message)
                        setType("success")
                        loadConsignmentsData()
                    }
                    else {
                        setShow(true)
                        setTitle(response.data.message)
                        setType("danger")
                        setLoadShow("show-n")
                        setOverlay("show-n")
                    }
                })
                .catch(err => console.log(err))
        }
    }
    const downloadChecklist = async (e) => {
        const api = columnApiConsignments.current.api;

        const selectedNodes = api.getSelectedNodes();
        const pageSize = api.paginationGetPageSize();
        const currentPage = api.paginationGetCurrentPage();
        const startRow = currentPage * pageSize;
        const endRow = startRow + pageSize;

        const currentPageNodes = [];
        for (let i = startRow; i < endRow; i++) {
            const rowNode = api.getDisplayedRowAtIndex(i);
            if (rowNode) {
                currentPageNodes.push(rowNode);
            }
        }
        const allCurrentPageSelected = currentPageNodes.length > 0 &&
            currentPageNodes.every((node) => node.isSelected());

        let resultData = [];

        if (allCurrentPageSelected) {
            resultData = currentPageNodes.map((node) => node.data);
        } else {
            resultData = selectedNodes.map((node) => node.data)
                .filter((row) => row.fo_number !== undefined && row.fo_number !== null);
        }
        let selectedFOs = []
        for (var i = 0; i < resultData.length; i++) {
            selectedFOs.push(resultData[i]?.fo_number)
        }
        let query = {
            fo_numbers: selectedFOs
        }
        if (selectedFOs.length > 0) {
            setLoadShow("show-m")
            setOverlay("show-m")
            await redirectURL.post("/downloadChecklist", query, { responseType: 'blob' })
                .then(response => {
                    if (response.status == "200") {
                        const blob = new Blob([response.data], { type: 'application/pdf' });
                        const url = window.URL.createObjectURL(blob);
                        const link = document.createElement('a');
                        link.href = url;
                        link.setAttribute('download', 'Checklist_Report.pdf');
                        document.body.appendChild(link);
                        link.click();
                        link.remove();
                        window.URL.revokeObjectURL(url);
                        setLoadShow("show-n");
                        setOverlay("show-n");
                    }
                    else {
                        setToast(prev => ({
                            ...prev,
                            toastImage: toastError,
                            toastTitle: "Download Failed",
                            toastMessage: "The file you were downloading was unable to download. Please try again.",
                            showToast: true
                        }))
                    }
                })
        }
        else {
            setToast(prev => ({
                ...prev,
                toastImage: toastWarning,
                toastTitle: "Please Select a FO number",
                toastMessage: "To download the data, select at least one FO number from the list",
                showToast: true
            }))
        }

    }

    const downloadInboundChecklist = async (e) => {
        const api = columnApiConsignments.current.api;

        const selectedNodes = api.getSelectedNodes();
        const pageSize = api.paginationGetPageSize();
        const currentPage = api.paginationGetCurrentPage();
        const startRow = currentPage * pageSize;
        const endRow = startRow + pageSize;

        const currentPageNodes = [];
        for (let i = startRow; i < endRow; i++) {
            const rowNode = api.getDisplayedRowAtIndex(i);
            if (rowNode) {
                currentPageNodes.push(rowNode);
            }
        }
        const allCurrentPageSelected = currentPageNodes.length > 0 &&
            currentPageNodes.every((node) => node.isSelected());

        let resultData = [];

        if (allCurrentPageSelected) {
            resultData = currentPageNodes.map((node) => node.data);
        } else {
            resultData = selectedNodes.map((node) => node.data)
                .filter((row) => row.fo_number !== undefined && row.fo_number !== null);
        }
        let selectedFOs = []
        for (var i = 0; i < resultData.length; i++) {
            selectedFOs.push(resultData[i]?.fo_number)
        }
        let query = {
            fo_numbers: selectedFOs
        }
        if (selectedFOs.length > 0) {
            setLoadShow("show-m")
            setOverlay("show-m")
            await redirectURL.post("/downloadInboundChecklist", query, { responseType: 'blob' })
                .then(response => {
                    if (response.status == "200") {
                        const blob = new Blob([response.data], { type: 'application/pdf' });
                        const url = window.URL.createObjectURL(blob);
                        const link = document.createElement('a');
                        link.href = url;
                        link.setAttribute('download', 'Inbound_Checklist_Report.pdf');
                        document.body.appendChild(link);
                        link.click();
                        link.remove();
                        window.URL.revokeObjectURL(url);
                        setLoadShow("show-n");
                        setOverlay("show-n");
                    }
                    else {
                        setToast(prev => ({
                            ...prev,
                            toastImage: toastError,
                            toastTitle: "Download Failed",
                            toastMessage: "The file you were downloading was unable to download. Please try again.",
                            showToast: true
                        }))
                    }
                })
        }
        else {
            setToast(prev => ({
                ...prev,
                toastImage: toastWarning,
                toastTitle: "Please Select a FO number",
                toastMessage: "To download the data, select at least one FO number from the list",
                showToast: true
            }))
        }

    }


    const unmarkHotLoads = async (e) => {
        let fo_numbers = columnApiConsignments.current.api.getSelectedNodes().map(e => e.data.fo_number)
        if (fo_numbers.length > 0) {
            setLoadShow("show-m")
            setOverlay("show-m")
            let body = {
                fo_numbers
            }
            await redirectURL.post("/unmarkHotLoads", body)
                .then(response => {
                    if (response.data.status == "success") {
                        setShow(true)
                        setTitle(response.data.message)
                        setType("success")
                        loadConsignmentsData()
                    }
                    else {
                        setShow(true)
                        setTitle(response.data.message)
                        setType("danger")
                        setLoadShow("show-n")
                        setOverlay("show-n")
                    }
                })
                .catch(err => console.log(err))
        }
    }

    const handleStartDateChange = (date) => {
        if (endDate && date > endDate) {
            setShow(true)
            setTitle("To Date should be greater than From Date")
            setType("danger")
        } else {
            setStartDate(date)
        }
    };

    const handleEndDateChange = (date) => {
        if (startDate && date < startDate) {
            setShow(true)
            setTitle("To Date should be greater than From Date")
            setType("danger")
        } else {
            setEndDate(date)
        }
    };


    const onShowTransitRouteMap = (rownode) => {
        // var fintance = rownode.leg_start.replace("T", " ").replace("Z", " ").replace(".000", " ").trim();
        // var eintance = rownode.leg_end_eta.replace("T", " ").replace("Z", " ").replace(".000", " ").trim();
        setOverlay("show-m")
        setLoadShow("show-m")
        var fintance = moment.parseZone(rownode.leg_start).format('YYYY-MM-DD HH:mm:ss')
        var eintance = moment.parseZone(rownode.leg_end_eta).format('YYYY-MM-DD HH:mm:ss')
        var params = {
            truck_no: rownode.truck_no,
            consignment_code: rownode.consignment_code,
            consignee_code: rownode.consignee_code,
            first_instance: fintance,
            recent_instance: eintance,
            screen: "consignment",
            user_email: user.email
        }
        redirectURL.post('/consignments/nightdriveroutes', params)
            .then((response) => {
                if (response.data.coords.length == 0) {
                    setOverlay("show-n")
                    setLoadShow("show-n")
                    setShow(true)
                    setTitle("No GPS data available")
                    setType("danger")
                }
                else {
                    var sdate = '';
                    var edate = '';

                    if (rownode.leg_start != '' && rownode.leg_start != undefined) {
                        sdate = rownode.leg_start;
                    }
                    if (rownode.leg_end_eta != '' && rownode.leg_end_eta != undefined) {
                        edate = getHyphenDDMMMYYYYHHMM(rownode.leg_end_eta)
                    }
                    setOpenMap({
                        overly: "show-m",
                        sliderRouteTranslate: "slider-translate-60p",
                        mapinfo: response.data,
                        dealer: rownode.consignee_code,
                        consignment_code: "FO Number : " + rownode.fo_number,
                        maptruckno: rownode.truck_no,
                        routeTruck: { "truck_no": rownode.truck_no, "startTime": sdate, "endTime": edate },
                        loadshow: 'show-n',
                        sidebarSubHeader: "Consignment Leg Information",
                        overly: 'show-m',
                        rownode: rownode,
                        leg_no: rownode.leg_no,
                        tolls: response.data.tolls,
                        defTransitCoords: rownode.consignee_coordinates,
                    })
                    setLoadShow("show-n")
                }
            })
            .catch(function (error) {
                console.log(error);
                setLoadShow("show-n")
            });

    }
    const onShowEnrouteRouteMap = (rownode) => {
        var fintance = rownode.stoppage_start_time.replace("T", " ").replace("Z", " ").replace(".000", " ").trim();
        if (rownode.reset_datetime) {
            var eintance = rownode.reset_datetime.replace("T", " ").replace("Z", " ").replace(".000", " ").trim();
        }
        else {
            var eintance = moment.parseZone().format('YYYY-MM-DD HH:mm:ss');
        }
        var params = {
            truck_no: rownode.truck_no,
            first_instance: fintance,
            recent_instance: eintance,
            screen: "consignment",
            user_email: user.email
        }
        setOverlay("show-m")
        setLoadShow("show-m")
        redirectURL.post('/consignments/nightdriveroutes', params)
            .then((response) => {
                let records = response.data
                if (response.data.coords.length == 0) {
                    setShow(true)
                    setTitle("No GPS data available")
                    setType("danger")
                    setOverlay("show-n")
                    setLoadShow("show-n")
                }
                else {
                    var sdate = '';
                    var edate = '';
                    if (rownode.leg_start != '' && rownode.leg_start != undefined) {
                        sdate = rownode.leg_start;
                    }
                    if (rownode.leg_end_eta != '' && rownode.leg_end_eta != undefined) {
                        edate = getHyphenDDMMMYYYYHHMM(rownode.leg_end_eta)
                    }
                    if (response.data.route_details.start_time != "" && response.data.route_details.start_time != undefined) {
                        sdate = records.route_details.start_time;
                    }
                    if (response.data.route_details.end_time != "" && response.data.route_details.end_time != undefined) {
                        edate = records.route_details.end_time;
                    }
                    setOpenMap({
                        overly: "show-m",
                        sliderRouteTranslate: "slider-translate-60p",
                        mapinfo: response.data,
                        dealer: rownode.consignee_code,
                        consignment_code: "FO Number : " + rownode.fo_number,
                        maptruckno: rownode.truck_no,
                        routeTruck: { "truck_no": rownode.truck_no, "startTime": sdate, "endTime": edate },
                        loadshow: 'show-n',
                        sidebarSubHeader: "Consignment Leg Information",
                        overly: 'show-m',
                        rownode: rownode,
                        leg_no: rownode.leg_no,
                        tolls: response.data.tolls,
                        defTransitCoords: rownode.consignee_coordinates,
                    })
                    setLoadShow("show-n")
                }
            })
            .catch(function (error) {
                console.log(error);
                setLoadShow("show-n")
            });
    }
    const onShowNightDriveRouteMap = (rownode) => {
        var fintance = rownode.first_instance.replace("T", " ").replace("Z", " ").replace(".000", " ").trim();
        var eintance = rownode.recent_instance.replace("T", " ").replace("Z", " ").replace(".000", " ").trim();
        var params = {
            truck_no: rownode.truck_no,
            first_instance: fintance,
            recent_instance: eintance,
            screen: "consignment",
            consignment_code: rownode?.consignment_codes?.[0],
            user_email: user.email
        }
        setOverlay("show-m")
        setLoadShow("show-m")
        redirectURL.post('/consignments/nightdriveroutes2', params)
            .then((response) => {
                let apiData = {}
                try {
                    apiData = JSON.parse(response.data.apiData)
                } catch (e) { }
                if (apiData.coords.length == 0) {
                    setShow(true)
                    setTitle("No GPS data available")
                    setType("danger")
                }
                else {
                    setLoadShow("show-n")
                    setOpenMap({
                        overly: "show-m",
                        sliderRouteTranslate: "slider-translate-60p",
                        mapinfo: apiData,
                        consignment_code: "FO Number: " + response.data?.fo_number?.[0]?.["fo_number"],
                        defTransitCoords: { "lat": rownode.first_lat, "lng": rownode.first_lng },
                        maptruckno: rownode.truck_no,
                        routeTruck: {
                            "truck_no": rownode.truck_no, "startTime": apiData['route_details']['start_time'],
                            "endTime": apiData['route_details']['end_time']
                        },
                        loadshow: 'show-n',
                        tolls: apiData.tolls
                    })
                }
            })
            .catch(function (error) {
                console.log(error);
            });

    }

    const onShowDeviationRouteMap = (rownode) => {
        setOpenMap2({
            open: true,
            rownode: rownode
        })
    }
    const onShowRouteMap = (rownode) => {
        // var finstance = rownode.first_instance.replace("T", " ").replace("Z", " ").replace(".000", " ").trim();
        // var rinstance = rownode.recent_instance.replace("T", " ").replace("Z", " ").replace(".000", " ").trim();

        var finstance = moment.parseZone(rownode.first_instance).format('YYYY-MM-DD HH:mm:ss')
        var rinstance = moment.parseZone(rownode.recent_instance).format('YYYY-MM-DD HH:mm:ss')

        var params = {
            truck_no: rownode.truck_no,
            consignment_code: rownode.consignment_code,
            consignee_code: rownode.consignee_code,
            first_instance: finstance,
            recent_instance: rinstance,
            screen: "consignment",
            user_email: user.email
        }
        redirectURL.post('/consignments/overspeedgpsroutes', params)
            .then((response) => {
                setOpenMap({
                    overly: "show-m",
                    sliderRouteTranslate: "slider-translate-60p",
                    mapinfo: response.data,
                    dealer: rownode.consignee_code,
                    consignment_code: "FO Number : " + rownode.fo_number,
                    maptruckno: rownode.truck_no,
                    routeTruck: { "truck_no": rownode.truck_no, "startTime": finstance, "endTime": rinstance },
                    loadshow: 'show-n',
                    sidebarSubHeader: "Consignment Leg Information",
                    overly: 'show-m',
                    rownode: rownode,
                    leg_no: rownode.leg_no,
                    tolls: response.data.tolls,
                    defTransitCoords: rownode.consignee_coordinates,
                })
            })
            .catch(function (error) {
                console.log(error);
            });
    }
    const onShowNoGPSRouteMap = (rownode) => {
        var fintance = rownode.last_packet_datetime.replace("T", " ").replace("Z", " ").replace(".000", " ").trim();
        var eintance = moment(new Date()).format("YYYY-MM-DD HH:mm:ss");
        eintance = eintance.replace("T", " ").replace("Z", " ").replace(".000", " ").trim()
        if ((rownode.hasOwnProperty("exception_closed") && rownode.exception_closed == 1) || rownode.hasOwnProperty("packet_received_on"))
            eintance = rownode.packet_received_on.replace("T", " ").replace("Z", " ").replace(".000", " ").trim();
        else
            eintance = rownode.modified_date.replace("T", " ").replace("Z", " ").replace(".000", " ").trim();
        var params = {
            truck_no: rownode.truck_no,
            consignment_code: rownode.consignment_code,
            first_instance: fintance,
            recent_instance: eintance,
            screen: "consignment",
            user_email: user.email
        }
        redirectURL.post('/consignments/nightdriveroutes', params)
            .then((response) => {
                if (response.data.coords.length == 0) {
                    setShow(true)
                    setTitle("No GPS data available")
                    setType("danger")
                }
                else {
                    var sdate = '';
                    var edate = '';
                    if (rownode.leg_start != '' && rownode.leg_start != undefined) {
                        sdate = rownode.leg_start;
                    }
                    if (rownode.leg_end_eta != '' && rownode.leg_end_eta != undefined) {
                        edate = getHyphenDDMMMYYYYHHMM(rownode.leg_end_eta)
                    }
                    setOpenMap({
                        overly: "show-m",
                        sliderRouteTranslate: "slider-translate-60p",
                        mapinfo: response.data,
                        dealer: rownode.consignee_code,
                        consignment_code: "FO Number : " + rownode.fo_number,
                        maptruckno: rownode.truck_no,
                        routeTruck: { "truck_no": rownode.truck_no, "startTime": sdate, "endTime": edate },
                        loadshow: 'show-n',
                        sidebarSubHeader: "Consignment Leg Information",
                        overly: 'show-m',
                        rownode: rownode,
                        leg_no: rownode.leg_no,
                        tolls: response.data.tolls,
                        defTransitCoords: rownode.consignee_coordinates,
                    })
                }
            })
            .catch(function (error) {
                console.log(error);
            });


    }
    const onClickOpenBulkUploadModal = (e) => {
        setOverlay("show-m")
        setBulkUploadModal({
            overly: "show-m",
            bulkPrioritySlide: "slider-translate-60p"
        })
    }
    const closeBulkUploadModal = () => {
        setOverlay("show-n")
        setBulkUploadModal({
            overly: "show-n",
            bulkPrioritySlide: ""
        })
        setModalLoadData([])
        setInvalidData([])
        setValidData([])
        setBulkType('')
    }
    const closeMapModal = () => {
        setOverlay("show-n")
        setOpenMap({
            sliderRouteTranslate: "",
            showDiv: 'show-n',
            mapinfo: [],
            dealer: "",
            consignment_code: "",
            maptruckno: "",
            geofence_coordinates: [],
            parking_coordinates: [],
            routeTruck: { "truck_no": '', "startTime": '', "endTime": '' },
            loadshow: 'show-n',
            sidebarSubHeader: "",
            overly: 'show-m',
            rownode: {},
            leg_no: 0,
            tolls: []
        })
        setOpenMap2({
            open: false,
            rownode: {}
        })
    }

    const getRecordsFromAllData = (setName, truckLevel) => {
        if (truckLevel)
            return activeTripsData.total_fo_deliveries.filter((item) => activeTripsData[setName].has(item._id))
        else {
            setName = "drop_" + setName
            return activeTripsData.total_fo_deliveries.filter((item) => activeTripsData[setName].has(item._id))
        }
    }

    const CounterClick = (ecounter, i = 0) => {
        if (tabName.value == "active" || tabName.value == "all") {
            switch (ecounter) {
                case "uniqueFO":
                    setRowData(activeTripsData.total_unique_fo)
                    topCounterAlt.current = { label: "Total Unique FOs", value: "uniqueFO" }
                    setMiddleCounter({ label: "", value: "" })
                    break;
                case "fo_deliveries":
                    setRowData(activeTripsData.total_fo_deliveries)
                    topCounterAlt.current = { label: "Total FO Deliveries", value: "fo_deliveries" }
                    setMiddleCounter({ label: "", value: "" })
                    break;
                case "hot_loads":
                    if (toggle)
                        setRowData(activeTripsData.total_unique_fo.filter(e => e.hot_loads == 1))
                    else
                        setRowData(activeTripsData.total_fo_deliveries.filter(e => e.hot_loads == 1))
                    topCounterAlt.current = { label: toggle ? "Total Hot Loads  (FO Level)" : "Total Hot Loads (Drop Level)", value: "hot_loads" }
                    setMiddleCounter({ label: "", value: "" })
                    break;

                case "consent_pending":
                    if (toggle) {
                        // setRowData(activeTripsData.cp_all_data)
                        setRowData(getRecordsFromAllData(ecounter, true))
                    }
                    else {
                        // setRowData(activeTripsData.drop_cp_all_data)
                        setRowData(getRecordsFromAllData(ecounter, false))
                    }
                    topCounterAlt.current = { label: toggle ? "Consent Pending (FO Level)" : "Consent Pending (Drop Level)", value: "consent_pending" }
                    setMiddleCounter({ label: "", value: "" })
                    break;
                case "consent_acquired":
                    if (toggle) {
                        setActiveTripsCounters({
                            inside_plant: activeTripsData.sim_inside_plant.size,
                            in_transit: activeTripsData.sim_in_transit.size,
                            transit_delays: activeTripsData.sim_transit_delays.size,
                            hot_loads: activeTripsData.sim_hot_loads.size,
                            overspeeding: activeTripsData.sim_overspeeding.size,
                            night_driving: activeTripsData.sim_night_driving.size,
                            stoppages: activeTripsData.sim_stoppages.size,
                            loading_delays: activeTripsData.sim_loading_delays.size,
                            unloading_delays: activeTripsData.sim_unloading_delays.size,
                            deviated_routes: activeTripsData.sim_deviated_routes.size,
                        })
                        setRowData(getRecordsFromAllData(ecounter, true))
                        // setRowData(activeTripsData.consent_acquired)
                        setMiddleCounter({ label: "", value: "" })
                    }
                    else {
                        setActiveTripsCounters({
                            inside_plant: activeTripsData.drop_sim_inside_plant.size,
                            in_transit: activeTripsData.drop_sim_in_transit.size,
                            transit_delays: activeTripsData.drop_sim_transit_delays.size,
                            hot_loads: activeTripsData.drop_sim_hot_loads.size,
                            overspeeding: activeTripsData.drop_sim_overspeeding.size,
                            night_driving: activeTripsData.drop_sim_night_driving.size,
                            stoppages: activeTripsData.drop_sim_stoppages.size,
                            loading_delays: activeTripsData.drop_sim_loading_delays.size,
                            unloading_delays: activeTripsData.drop_sim_unloading_delays.size,
                            deviated_routes: activeTripsData.drop_sim_deviated_routes.size,
                        })
                        setRowData(getRecordsFromAllData(ecounter, false))
                        // setRowData(activeTripsData.drop_consent_acquired)
                    }
                    topCounterAlt.current = { label: toggle ? "Consent Acquired (FO Level)" : "Consent Acquired (Drop Level)", value: "consent_acquired" }
                    // setMiddleCounter({ label: "Inside Plant", value: "inside_plant" })
                    setMiddleCounter({ label: "", value: "" })
                    break;

                case "GPS_data_acquired":
                    if (toggle) {
                        setActiveTripsCounters({
                            inside_plant: activeTripsData.gps_inside_plant.size,
                            in_transit: activeTripsData.gps_in_transit.size,
                            transit_delays: activeTripsData.gps_transit_delays.size,
                            hot_loads: activeTripsData.gps_hot_loads.size,
                            overspeeding: activeTripsData.gps_overspeeding.size,
                            night_driving: activeTripsData.gps_night_driving.size,
                            stoppages: activeTripsData.gps_stoppages.size,
                            loading_delays: activeTripsData.gps_loading_delays.size,
                            unloading_delays: activeTripsData.gps_unloading_delays.size,
                            deviated_routes: activeTripsData.gps_deviated_routes.size,
                        })
                        // setRowData(activeTripsData.GPS_data_acquired)
                        setRowData(getRecordsFromAllData(ecounter, true))
                    }
                    else {
                        setActiveTripsCounters({
                            inside_plant: activeTripsData.drop_gps_inside_plant.size,
                            in_transit: activeTripsData.drop_gps_in_transit.size,
                            transit_delays: activeTripsData.drop_gps_transit_delays.size,
                            hot_loads: activeTripsData.drop_gps_hot_loads.size,
                            overspeeding: activeTripsData.drop_gps_overspeeding.size,
                            night_driving: activeTripsData.drop_gps_night_driving.size,
                            stoppages: activeTripsData.drop_gps_stoppages.size,
                            loading_delays: activeTripsData.drop_gps_loading_delays.size,
                            unloading_delays: activeTripsData.drop_gps_unloading_delays.size,
                            deviated_routes: activeTripsData.drop_gps_deviated_routes.size,
                        })
                        setRowData(getRecordsFromAllData(ecounter, false))
                        // setRowData(activeTripsData.drop_GPS_data_acquired)
                    }
                    topCounterAlt.current = { label: toggle ? "Location Data Acquired (FO Level)" : "Location Data Acquired (Drop Level)", value: "GPS_data_acquired" }
                    setMiddleCounter({ label: "", value: "" })
                    break;

                case "cp_oldest_fo":
                    if (toggle)
                        setRowData(getRecordsFromAllData(ecounter, true))
                    // setRowData(activeTripsData.cp_oldest_fo)
                    else
                        setRowData(getRecordsFromAllData(ecounter, false))
                    // setRowData(activeTripsData.drop_cp_oldest_fo)
                    setMiddleCounter({ label: "Oldest FO Date", value: "cp_oldest_fo" })
                    break;
                case "cp_latest_fo":
                    if (toggle)
                        setRowData(getRecordsFromAllData(ecounter, true))
                    // setRowData(activeTripsData.cp_latest_fo)
                    else
                        setRowData(getRecordsFromAllData(ecounter, false))
                    // setRowData(activeTripsData.drop_cp_latest_fo)
                    setMiddleCounter({ label: "Latest FO Date", value: "cp_latest_fo" })
                    break;
                case "cp_hot_loads":
                    if (toggle)
                        setRowData(getRecordsFromAllData(ecounter, true))
                    // setRowData(activeTripsData.cp_hot_loads)
                    else
                        setRowData(getRecordsFromAllData(ecounter, false))
                    // setRowData(activeTripsData.drop_cp_hot_loads)
                    setMiddleCounter({ label: "Hot Loads", value: "cp_hot_loads" })
                    break;
                case "sim_inside_plant":
                    if (toggle)
                        setRowData(getRecordsFromAllData(ecounter, true))
                    // setRowData(activeTripsData.sim_inside_plant)
                    else
                        setRowData(getRecordsFromAllData(ecounter, false))
                    // setRowData(activeTripsData.drop_sim_inside_plant)
                    setMiddleCounter({ label: "Inside Plant", value: "inside_plant" })
                    break;
                case "sim_in_transit":
                    if (toggle)
                        setRowData(getRecordsFromAllData(ecounter, true))
                    // setRowData(activeTripsData.sim_in_transit)
                    else
                        setRowData(getRecordsFromAllData(ecounter, false))
                    // setRowData(activeTripsData.drop_sim_in_transit)
                    setMiddleCounter({ label: "In Transit", value: "in_transit" })
                    break;
                case "sim_transit_delays":
                    if (toggle)
                        setRowData(getRecordsFromAllData(ecounter, true))
                    // setRowData(activeTripsData.sim_transit_delays)
                    else
                        setRowData(getRecordsFromAllData(ecounter, false))
                    // setRowData(activeTripsData.drop_sim_transit_delays)
                    setMiddleCounter({ label: "Transit Delays", value: "transit_delays" })
                    break;
                case "sim_hot_loads":
                    if (toggle)
                        setRowData(getRecordsFromAllData(ecounter, true))
                    // setRowData(activeTripsData.sim_hot_loads)
                    else
                        setRowData(getRecordsFromAllData(ecounter, false))
                    // setRowData(activeTripsData.drop_sim_hot_loads)
                    setMiddleCounter({ label: "Hot Loads", value: "hot_loads" })
                    break;
                case "sim_overspeeding":
                    if (toggle)
                        setRowData(getRecordsFromAllData(ecounter, true))
                    // setRowData(activeTripsData.sim_overspeeding)
                    else
                        setRowData(getRecordsFromAllData(ecounter, false))
                    // setRowData(activeTripsData.drop_sim_overspeeding)
                    setMiddleCounter({ label: "Overspeeding", value: "overspeeding" })
                    break;
                case "sim_night_driving":
                    if (toggle)
                        setRowData(getRecordsFromAllData(ecounter, true))
                    // setRowData(activeTripsData.sim_night_driving)
                    else
                        setRowData(getRecordsFromAllData(ecounter, false))
                    // setRowData(activeTripsData.drop_sim_night_driving)
                    setMiddleCounter({ label: "Night Driving", value: "night_driving" })
                    break;
                case "sim_stoppages":
                    if (toggle)
                        setRowData(getRecordsFromAllData(ecounter, true))
                    // setRowData(activeTripsData.sim_stoppages)
                    else
                        setRowData(getRecordsFromAllData(ecounter, false))
                    // setRowData(activeTripsData.drop_sim_stoppages)
                    setMiddleCounter({ label: "Stoppages", value: "stoppages" })
                    break;
                case "sim_loading_delays":
                    if (toggle)
                        setRowData(getRecordsFromAllData(ecounter, true))
                    else
                        setRowData(getRecordsFromAllData(ecounter, false))
                    setMiddleCounter({ label: "Loading Delays", value: "loading_delays" })
                    break;
                case "sim_unloading_delays":
                    if (toggle)
                        setRowData(getRecordsFromAllData(ecounter, true))
                    else
                        setRowData(getRecordsFromAllData(ecounter, false))
                    setMiddleCounter({ label: "Unloading Delays", value: "unloading_delays" })
                    break;
                case "sim_deviated_routes":
                    if (toggle)
                        setRowData(getRecordsFromAllData(ecounter, true))
                    // setRowData(activeTripsData.sim_deviated_routes)
                    else
                        // setRowData(activeTripsData.drop_sim_deviated_routes)
                        setRowData(getRecordsFromAllData(ecounter, false))
                    setMiddleCounter({ label: "Deviated Routes", value: "deviated_routes" })
                    break;
                case "gps_inside_plant":
                    if (toggle)
                        setRowData(getRecordsFromAllData(ecounter, true))
                    // setRowData(activeTripsData.gps_inside_plant)
                    else
                        // setRowData(activeTripsData.drop_gps_inside_plant)
                        setRowData(getRecordsFromAllData(ecounter, false))
                    setMiddleCounter({ label: "Inside Plant", value: "inside_plant" })
                    break;
                case "gps_in_transit":
                    if (toggle)
                        setRowData(getRecordsFromAllData(ecounter, true))
                    // setRowData(activeTripsData.gps_in_transit)
                    else
                        // setRowData(activeTripsData.drop_gps_in_transit)
                        setRowData(getRecordsFromAllData(ecounter, false))
                    setMiddleCounter({ label: "In Transit", value: "in_transit" })
                    break;
                case "gps_transit_delays":
                    if (toggle)
                        setRowData(getRecordsFromAllData(ecounter, true))
                    // setRowData(activeTripsData.gps_transit_delays)
                    else
                        // setRowData(activeTripsData.drop_gps_transit_delays)
                        setRowData(getRecordsFromAllData(ecounter, false))
                    setMiddleCounter({ label: "Transit Delays", value: "transit_delays" })
                    break;
                case "gps_hot_loads":
                    if (toggle)
                        setRowData(getRecordsFromAllData(ecounter, true))
                    // setRowData(activeTripsData.gps_hot_loads)
                    else
                        // setRowData(activeTripsData.drop_gps_hot_loads)
                        setRowData(getRecordsFromAllData(ecounter, false))
                    setMiddleCounter({ label: "Hot Loads", value: "hot_loads" })
                    break;
                case "gps_overspeeding":
                    if (toggle)
                        setRowData(getRecordsFromAllData(ecounter, true))
                    // setRowData(activeTripsData.gps_overspeeding)
                    else
                        // setRowData(activeTripsData.drop_gps_overspeeding)
                        setRowData(getRecordsFromAllData(ecounter, false))
                    setMiddleCounter({ label: "Overspeeding", value: "overspeeding" })
                    break;
                case "gps_night_driving":
                    if (toggle)
                        setRowData(getRecordsFromAllData(ecounter, true))
                    // setRowData(activeTripsData.gps_night_driving)
                    else
                        // setRowData(activeTripsData.drop_gps_night_driving)
                        setRowData(getRecordsFromAllData(ecounter, false))
                    setMiddleCounter({ label: "Night Driving", value: "night_driving" })
                    break;
                case "gps_stoppages":
                    if (toggle)
                        setRowData(getRecordsFromAllData(ecounter, true))
                    // setRowData(activeTripsData.gps_stoppages)
                    else
                        // setRowData(activeTripsData.drop_gps_stoppages)
                        setRowData(getRecordsFromAllData(ecounter, false))
                    setMiddleCounter({ label: "Stoppages", value: "stoppages" })
                    break;
                case "gps_loading_delays":
                    if (toggle)
                        setRowData(getRecordsFromAllData(ecounter, true))
                    else
                        setRowData(getRecordsFromAllData(ecounter, false))
                    setMiddleCounter({ label: "Loading Delays", value: "loading_delays" })
                    break;
                case "gps_unloading_delays":
                    if (toggle)
                        setRowData(getRecordsFromAllData(ecounter, true))
                    else
                        setRowData(getRecordsFromAllData(ecounter, false))
                    setMiddleCounter({ label: "Unloading Delays", value: "unloading_delays" })
                    break;
                case "gps_deviated_routes":
                    if (toggle)
                        setRowData(getRecordsFromAllData(ecounter, true))
                    // setRowData(activeTripsData.gps_deviated_routes)
                    else
                        // setRowData(activeTripsData.drop_gps_deviated_routes)
                        setRowData(getRecordsFromAllData(ecounter, false))
                    setMiddleCounter({ label: "Deviated Routes", value: "deviated_routes" })
                    break;
            }
        }
    }

    const CounterClickDelivered = (ecounter, i = 0) => {
        if (tabName?.value == "completed") {
            switch (ecounter) {
                case "uniqueFO":
                    setRowData(deliveredTrips.total_unique_fo)
                    topCounterAlt.current = { label: "Total Unique FOs", value: "uniqueFO" }
                    break;
                case "fo_deliveries":
                    setRowData(deliveredTrips.total_fo_deliveries)
                    topCounterAlt.current = { label: "Total FO Deliveries", value: "fo_deliveries" }
                    break;
                case "hot_loads":
                    if (toggle)
                        setRowData(deliveredTrips.total_unique_fo.filter(e => e.hot_loads == 1))
                    else
                        setRowData(deliveredTrips.total_fo_deliveries.filter(e => e.hot_loads == 1))
                    topCounterAlt.current = { label: toggle ? "Total Hot Loads  (FO Level)" : "Total Hot Loads (Drop Level)", value: "hot_loads" }
                    break;
                case "transit_delays":
                    if (toggle)
                        setRowData(deliveredTrips.fo_transit_delays)
                    else
                        setRowData(deliveredTrips.transit_delays)
                    topCounterAlt.current = { label: toggle ? "Transit Delays  (FO Level)" : "Transit Delays (Drop Level)", value: "transit_delays" }
                    break;
                case "on_time":
                    if (toggle)
                        setRowData(deliveredTrips.fo_on_time)
                    else
                        setRowData(deliveredTrips.on_time)
                    topCounterAlt.current = { label: toggle ? "On Time    (FO Level)" : "On Time (Drop Level)", value: "on_time" }
                    break;
                case "overspeeding":
                    if (toggle)
                        setRowData(deliveredTrips.fo_overspeeding)
                    else
                        setRowData(deliveredTrips.overspeeding)
                    topCounterAlt.current = { label: toggle ? "Overspeeding  (FO Level)" : "Overspeeding (Drop Level)", value: "overspeeding" }
                    break;
                case "night_driving":
                    if (toggle)
                        setRowData(deliveredTrips.fo_night_driving)
                    else
                        setRowData(deliveredTrips.night_driving)
                    topCounterAlt.current = { label: toggle ? "Night Driving  (FO Level)" : "Night Driving (Drop Level)", value: "night_driving" }
                    break;
                case "stoppages":
                    if (toggle)
                        setRowData(deliveredTrips.fo_stoppages)
                    else
                        setRowData(deliveredTrips.stoppages)
                    topCounterAlt.current = { label: toggle ? "Stoppages  (FO Level)" : "Stoppages (Drop Level)", value: "stoppages" }
                    break;
                case "loading_delays":
                    if (toggle)
                        setRowData(deliveredTrips.fo_loading_delays)
                    else
                        setRowData(deliveredTrips.loading_delays)
                    topCounterAlt.current = { label: toggle ? "Loading Delays  (FO Level)" : "Loading Delays (Drop Level)", value: "loading_delays" }
                    break;
                case "unloading_delays":
                    if (toggle)
                        setRowData(deliveredTrips.fo_unloading_delays)
                    else
                        setRowData(deliveredTrips.unloading_delays)
                    topCounterAlt.current = { label: toggle ? "Unloading Delays  (FO Level)" : "Unloading Delays (Drop Level)", value: "unloading_delays" }
                    break;
                case "deviated_routes":
                    if (toggle)
                        setRowData(deliveredTrips.fo_deviated_routes)
                    else
                        setRowData(deliveredTrips.deviated_routes)
                    topCounterAlt.current = { label: toggle ? "Deviated Routes  (FO Level)" : "Deviated Routes (Drop Level)", value: "deviated_routes" }
                    break;
            }
        }
    }

    useEffect(() => {
        setOverlay("show-m")
        setLoadShow("show-m")
        if (window.location.pathname == "/activeconsignments") {
            window.location.href = "/active-FOs"
        }
        else if (window.location.pathname == "/deliveredconsignments") {
            window.location.href = "/delivered-FOs"
        }
        else if (window.location.pathname == "/allconsignments") {
            window.location.href = "/all-FOs"
        }
        redirectURL.get("consignments/getForceClosureReasons", {})
            .then(response2 => {
                const reasonMap = new Map()
                const mainReason = []
                let data = response2?.data?.data
                setForceClosureData(data)
                response2?.data?.data.forEach(each => {
                    const key = Object.keys(each)[1];
                    mainReason.push({ label: key, value: key })
                    reasonMap.set(key, each[key].map(e => ({ label: e, value: e })))
                })
                mainReason.push({ label: "Other", value: "Other" })
                forceClosureReason.current = {
                    reasonMap,
                    mainReason
                }
            })
            .catch(err => {
                return err;
            })
        let query = {}
        if (user.role[0] == "DEALER")
            query["user_code"] = user.dealer_code ?? "EMPTY"
        else if (user.role[0] == "PLANT") {
            query["plant_codes"] = user.plant_codes ?? "EMPTY"
        }
        redirectURL.get('consignments/getConsigner', { params: query })
            .then((response) => {
                setConsignersList(response.data.records)
            })
            .catch((error) => {
                console.error('Error fetching data:', error);
            });
        redirectURL.get('consignments/getConsignee', {})
            .then((response) => {
                setConsigneesList(response.data.records)
            })
            .catch((error) => {
                console.error('Error fetching data:', error);
            });
        let query2 = {
            dept_code: "SNDG"
        }
        if (user.role[0] == "DEALER")
            query2["user_code"] = user.dealer_code ?? "EMPTY"
        else if (user.role[0] == "PLANT") {
            query["plant_codes"] = user.plant_codes ?? "EMPTY"
        }
        redirectURL.get("/consignments/getConsignmentsNewFilterKeys", { params: query2 })
            .then((resp) => {
                var cities = resp.data.cities;
                var filterCities = [];
                if (cities != undefined) {
                    if (cities.length > 0) {
                        cities.map(function (c) {
                            filterCities.push({
                                label: c,
                                value: c,
                            });
                        });
                    }
                }
                var states = resp.data.states;
                var filterStates = [];
                if (states != undefined) {
                    if (states.length > 0) {
                        states.map(function (s) {
                            filterStates.push({
                                label: s,
                                value: s,
                            });
                        });
                    }
                }
                var clusters = resp.data.clusters;
                var filterClusters = [];
                if (clusters != undefined) {
                    if (clusters.length > 0) {
                        clusters.map(function (cl) {
                            filterClusters.push({
                                label: cl,
                                value: cl,
                            });
                        });
                    }
                }
                var transporters = resp.data.transporters;
                var filterTransporters = [];
                if (transporters != undefined) {
                    if (transporters.length > 0) {
                        transporters.map(function (t) {
                            filterTransporters.push({
                                label: t.transporter_name + " (" + t.transporter_code + ")",
                                value: t.transporter_name,
                                code: t.transporter_code,
                            });
                        });
                    }
                }
                var consigneeZones = resp.data.consigneeZones;
                var filterConsigneeZones = [{ label: 'All', value: 'all' }];
                if (consigneeZones != undefined) {
                    if (consigneeZones.length > 0) {
                        consigneeZones.map(function (cz) {
                            filterConsigneeZones.push({
                                label: cz,
                                value: cz,
                            });
                        });
                    }
                }
                var consigneeTypes = resp.data.consigneeTypes;
                var filterConsigneeTypes = [{ label: 'All', value: 'all' }];
                if (consigneeTypes != undefined) {
                    if (consigneeTypes.length > 0) {
                        consigneeTypes.map(function (ct) {
                            filterConsigneeTypes.push({
                                label: ct,
                                value: ct,
                            });
                        });
                    }
                }
                var plantZones = resp.data.plantZones;
                var filterPlantZones = [{ label: 'All', value: 'all' }];
                if (plantZones != undefined) {
                    if (plantZones.length > 0) {
                        plantZones.map(function (pz) {
                            filterPlantZones.push({
                                label: pz,
                                value: pz,
                            });
                        });
                    }
                }
                setFilterCities(filterCities)
                setFilterStates(filterStates)
                setFilterTransporters(filterTransporters)
                setFilterConsigneeZones(filterConsigneeZones)
                setFilterConsigneeTypes(filterConsigneeTypes)
                setFilterPlantZones(filterPlantZones)
            })
        loadConsignmentsData()
        if (window.location.pathname == "/active-FOs") {
            getCurrentTabGridStatus()
            setRowData([])
            setTabName(tabOptions[0])
            topCounterAlt.current = { label: "Total Unique FOs", value: "uniqueFO" }
            all_rows_data.current = []
            setDeliveredTrips({
                total_unique_fo: [],
                total_hot_loads: [],
                total_fo_deliveries: [],
                fo_transit_delays: [],
                fo_on_time: [],
                fo_overspeeding: [],
                fo_night_driving: [],
                fo_stoppages: [],
                fo_loading_delays: [],
                fo_unloading_delays: [],
                fo_deviated_routes: [],
                fo_total_hot_loads: [],
                transit_delays: [],
                on_time: [],
                overspeeding: [],
                night_driving: [],
                stoppages: [],
                loading_delays: [],
                unloading_delays: [],
                deviated_routes: [],
            })
            setDeliveredCounter({
                total_unique_fo: 0,
                total_hot_loads: 0,
                total_fo_deliveries: 0,
                transit_delays: 0,
                on_time: 0,
                overspeeding: 0,
                night_driving: 0,
                stoppages: 0,
                loading_delays: 0,
                unloading_delays: 0,
                deviated_routes: 0,
            })
        }
        else if (window.location.pathname == "/delivered-FOs") {
            getCurrentTabGridStatus()
            setRowData([])
            setTabName(tabOptions[1])
            topCounterAlt.current = { label: "Total Unique FOs", value: "uniqueFO" }
            all_rows_data.current = []
            setActiveTripsData({
                total_unique_fo: [],
                total_fo_deliveries: [],
                total_hot_loads: [],
                GPS_data_acquired: [],
                gps_inside_plant: [],
                gps_in_transit: [],
                gps_transit_delays: [],
                gps_hot_loads: [],
                gps_overspeeding: [],
                gps_night_driving: [],
                gps_stoppages: [],
                gps_loading_delays: [],
                gps_unloading_delays: [],
                gps_deviated_routes: [],
                consent_acquired: [],
                sim_inside_plant: [],
                sim_in_transit: [],
                sim_transit_delays: [],
                sim_hot_loads: [],
                sim_overspeeding: [],
                sim_night_driving: [],
                sim_stoppages: [],
                sim_loading_delays: [],
                sim_unloading_delays: [],
                sim_deviated_routes: [],
                cp_all_data: [],
                cp_latest_fo: [],
                cp_oldest_fo: [],
                cp_hot_loads: [],
                drop_total_hot_loads: [],
                drop_GPS_data_acquired: [],
                drop_gps_inside_plant: [],
                drop_gps_in_transit: [],
                drop_gps_transit_delays: [],
                drop_gps_hot_loads: [],
                drop_gps_overspeeding: [],
                drop_gps_night_driving: [],
                drop_gps_stoppages: [],
                drop_gps_loading_delays: [],
                drop_gps_unloading_delays: [],
                drop_gps_deviated_routes: [],
                drop_consent_acquired: [],
                drop_sim_inside_plant: [],
                drop_sim_in_transit: [],
                drop_sim_transit_delays: [],
                drop_sim_hot_loads: [],
                drop_sim_overspeeding: [],
                drop_sim_night_driving: [],
                drop_sim_stoppages: [],
                drop_sim_loading_delays: [],
                drop_sim_unloading_delays: [],
                drop_sim_deviated_routes: [],
                drop_cp_all_data: [],
                drop_cp_oldest_fo: [],
                drop_cp_latest_fo: [],
                drop_cp_hot_loads: [],
            })
            setActiveTripsCounters({
                inside_plant: 0,
                in_transit: 0,
                transit_delays: 0,
                hot_loads: 0,
                overspeeding: 0,
                night_driving: 0,
                stoppages: 0,
                loading_delays: 0,
                deviated_routes: 0,
            })
        }
        else if (window.location.pathname == "/all-FOs") {
            getCurrentTabGridStatus()
            setRowData([])
            setTabName(tabOptions[2])
            topCounterAlt.current = { label: "Total Unique FOs", value: "uniqueFO" }
            all_rows_data.current = []
            setDeliveredTrips({
                total_unique_fo: [],
                total_hot_loads: [],
                total_fo_deliveries: [],
                fo_transit_delays: [],
                fo_on_time: [],
                fo_overspeeding: [],
                fo_night_driving: [],
                fo_stoppages: [],
                fo_loading_delays: [],
                fo_unloading_delays: [],
                fo_deviated_routes: [],
                fo_total_hot_loads: [],
                transit_delays: [],
                on_time: [],
                overspeeding: [],
                night_driving: [],
                stoppages: [],
                loading_delays: [],
                unloading_delays: [],
                deviated_routes: [],
            })
            setDeliveredCounter({
                total_unique_fo: 0,
                total_hot_loads: 0,
                total_fo_deliveries: 0,
                transit_delays: 0,
                on_time: 0,
                overspeeding: 0,
                night_driving: 0,
                stoppages: 0,
                loading_delays: 0,
                unloading_delays: 0,
                deviated_routes: 0,
            })
        }
    }, [window.location.pathname])

    useEffect(() => {
        if (columnApiConsignments.current.api && window.location.pathname == "/active-FOs") {
            columnApiConsignments.current.api.setFilterModel(null); // Clear all filters
            columnApiConsignments.current.api.setColumnsVisible(["unloading_click", "force_closure_reason", "force_closure_reason_secondary", "force_closure_performed_by", "dealerin_flag", "dealerout_flag"], false);
            columnApiConsignments.current.api.setColumnsVisible(["force_close"], true);
        }
        else if (columnApiConsignments.current.api && window.location.pathname == "/all-FOs") {
            columnApiConsignments.current.api.setFilterModel(null); // Clear all filters
            columnApiConsignments.current.api.setColumnsVisible(["unloading_click", "force_closure_reason", "force_closure_reason_secondary", "force_closure_performed_by", "force_close", "dealerin_flag", "dealerout_flag"], true);
        }
        else if (columnApiConsignments.current.api && window.location.pathname == "/delivered-FOs") {
            columnApiConsignments.current.api.setFilterModel(null); // Clear all filters
            columnApiConsignments.current.api.setColumnsVisible(["unloading_click", "force_closure_reason", "force_closure_reason_secondary", "force_closure_performed_by", "dealerin_flag", "dealerout_flag"], true);
            columnApiConsignments.current.api.setColumnsVisible(["force_close"], false);
        }
    }, [columnApiConsignments.current, tabName])

    const changeFileHandler = async (e) => {
        setOverly2("show-m")
        const formData = new FormData()
        formData.append("fileUpload", e.target.files[0])
        if (bulkType?.value == 'Road') {
            (redirectURL.post("/readExcel", formData, {
                headers: {
                    'content-type': 'multipart/form-data',
                    'Access-Control-Allow-Origin': "*",
                    'Access-Control-Allow-Methods': 'POST',
                    'Access-Control-Allow-Headers': 'Origin, Content-Type'
                }
            })
                .then((response) => {
                    const excelData = response.data
                    if (excelData.status == "success") {
                        if (excelData.data.length > 0) {
                            const dataArray = Object.values(excelData.data || {});
                            const consignerCodes = excelData.plantData.map(item => item.consigner_code); // array of consigner codes
                            const consigneeCodes = excelData.dealers.map(item => item.consignee_code)
                            const transporters = excelData.transporters.map(item => item.transporter_code)
                            let validArray = []
                            let invalidArray = []
                            let responseData = dataArray.map(each => {
                                if (each.status == 'valid' && consignerCodes.includes(each.plant_code) && consigneeCodes.includes(each.dealer_code) && transporters.includes(each.transporter_code) && (each.invoice_date != '' && moment(each.invoice_date, "DD/MM/YYYY HH:mm", false).isValid()) && each.expected_date != '' && each.vehicle_no != '' && each.driver_name != '' && (each.driver_number != '' && each.driver_number.length == 10 && (/^[6-9]\d{9}$/.test(each.driver_number))) && (each.expected_date != '' && moment(each.expected_date, "DD/MM/YYYY HH:mm", false).isValid())) {
                                    validArray.push(each)
                                }
                                else {
                                    invalidArray.push(each)
                                }
                            })
                            setInvalidData(invalidArray)
                            setValidData(validArray)
                            setModalLoadData(validArray)
                            setPlantData(excelData.plantData)
                            setTransporters(excelData.transporters)
                            setDealers(excelData.dealers)
                            setOverly2("show-n")
                        }
                        else {
                            setModalLoadData([])
                        }
                    }
                    else {
                        setShow(true)
                        setTitle(excelData.message)
                        setType("danger")
                        setOverly2("show-n")
                        e.target.value = ''
                        setValidData([])
                        setModalLoadData([])
                        setInvalidData([])
                    }
                })
                .catch(error => {
                    console.log(error);
                }))
        }
        else {
            try {
                const responseData = await readEximExcel(formData);
                if (responseData?.data?.status == "success") {
                    const excelResponseData = responseData?.data?.data
                    const codes = responseData?.data
                    let valid = []
                    let invalid = []
                    if (excelResponseData.length > 0) {
                        excelResponseData.map(item => {
                            if (item.status == "valid" && (codes?.dealers?.includes(item.dealer_code) || codes?.plantData?.includes(item.dealer_code)) && ((codes?.plantData?.includes(item.plant_code) || codes?.dealers?.includes(item.plant_code))) && codes?.transporters?.includes(item.transporter_code) && (item.date_of_dispatch && moment(item.date_of_dispatch, "DD/MM/YYYY HH:mm", true).isValid())) {
                                valid.push(item)
                            }
                            else {
                                invalid.push(item)
                            }
                        })
                        setValidData(valid)
                        setInvalidData(invalid);
                        setModalLoadData(valid);
                        setEximPlantData(codes?.plantData)
                        setEximTransporters(codes?.transporters)
                        setEximDealers(codes?.dealers)
                        setOverly2("show-n")
                    }
                    else {
                        setModalLoadData([])
                    }
                }
                else {
                    setShow(true)
                    setTitle(responseData.data.message)
                    setType("danger")
                    setOverly2("show-n")
                    setValidData([])
                    setModalLoadData([])
                    setInvalidData([])
                    e.target.value = ''
                }
            }
            catch (e) {
                return e
            }

        };
    }


    const onClickShowRoute = (rownode) => {
        setOverlay("show-m")
        setLoadShow("show-m")
        let e = {}
        const fo_cons = all_rows_data.current.filter(each => each.fo_number == rownode.data.fo_number)
        if (fo_cons.length > 1) {
            const temp = fo_cons.find(e => e.status <= 4)
            if (temp)
                e = temp
            else {
                const all_dates = []
                fo_cons.forEach(e => {
                    if (e.status == 5 && !!e.left_dealer_marked)
                        all_dates.push({ id: e._id, date: e.left_dealer_marked })
                    if (e.status == 6 && !!e.force_closure_time)
                        all_dates.push({ id: e._id, date: e.force_closure_time })
                    if (e.status == 8 && !!e.cancel_date)
                        all_dates.push({ id: e._id, date: e.cancel_date })
                    if (!!e.trip_closure_done)
                        all_dates.push({ id: e._id, date: e.trip_closure_done })
                })
                const newest = all_dates.length > 0
                    ? all_dates.reduce((latest, item) => {
                        return new Date(item.date) > new Date(latest.date) ? item : latest;
                    })
                    : null;
                e = newest ? fo_cons.find(each => each._id == newest.id) : rownode.data
            }
        }
        else
            e = rownode.data
        const getFormattedDate = (value) =>
            !!value ? moment.parseZone(value).format('YYYY-MM-DD HH:mm:ss') : null;
        const gateouttime =
            getFormattedDate(e.manual_gate_in) ||
            getFormattedDate(e.gate_in_time) ||
            getFormattedDate(e.created_date) ||
            '';
        let edate = '';
        let end_date;
        if (e.status <= 2) {
            end_date = moment.parseZone().format('YYYY-MM-DD HH:mm:ss')
            edate = getHyphenDDMMMYYYYHHMM(end_date);
        }
        else if ((e.status == 3 || e.status == 4)) {
            if (e.recent_dealer_reported) {
                end_date = e.recent_dealer_reported.replace("T", " ").replace("Z", " ").replace(".000", " ").trim();
                edate = getHyphenDDMMMYYYYHHMM(e.recent_dealer_reported);
            }
        }
        else if (e.status == 5) {
            if (e.tvp_gate_in) {
                end_date = e.tvp_gate_in.replace("T", " ").replace("Z", " ").replace(".000", " ").trim();
                edate = getHyphenDDMMMYYYYHHMM(e.tvp_gate_in);
            }
            else if (e.left_dealer_marked) {
                end_date = moment.parseZone(e.left_dealer_marked).format('YYYY-MM-DD HH:mm:ss')
                // end_date = e.left_dealer_marked.replace("T", " ").replace("Z", " ").replace(".000", " ").trim();
                edate = getHyphenDDMMMYYYYHHMM(e.left_dealer_marked);
            }
        }
        else if (e.status == 6) {
            if (e.tvp_gate_in) {
                end_date = e.tvp_gate_in.replace("T", " ").replace("Z", " ").replace(".000", " ").trim();
                edate = getHyphenDDMMMYYYYHHMM(e.tvp_gate_in);
            } else if (e.force_closure_time) {
                end_date = moment.parseZone(e.force_closure_time).format('YYYY-MM-DD HH:mm:ss')
            }
        }
        else if (e.status == 8) {
            end_date = moment.parseZone(e.cancel_date).format('YYYY-MM-DD HH:mm:ss')
            edate = moment.parseZone(e.cancel_date).format('YYYY-MM-DD HH:mm:ss')
        }
        else if (e.status == 9) {
            end_date = moment.parseZone(e.trip_closure_done).format('YYYY-MM-DD HH:mm:ss')
        }
        else {
            end_date = moment.parseZone().format('YYYY-MM-DD HH:mm:ss')
            edate = getHyphenDDMMMYYYYHHMM(end_date);
        }
        if (!end_date) {
            // When end date is unavailable then current date is considered as end date.
            end_date = moment.parseZone().format('YYYY-MM-DD HH:mm:ss');
        }
        console.log(user, "user_details")
        var reqData = {
            truck_no: e.truck_no,
            gate_out_time: gateouttime,
            seconddate: end_date,
            group_code: e.fo_number,
            screen: "consignment",
            display_elis_base_route: 1,
            user_email: user?.email || ""
        }
        if (e.consignee_code !== undefined) reqData.consignee_code = e.consignee_code
        if (e.consignment_code !== undefined) reqData.consignment_code = e.consignment_code
        redirectURL.post('/consignments/maproutesnew', reqData, {
            headers: {
                'content-type': 'application/json'
            }
        })
            .then((response) => {
                var records = response.data;
                // this.setState({
                //     loadshow: 'show-m'
                // });
                if (response?.data?.status == "failure" || response?.data?.status == "Failure") {
                    setShow(true)
                    setTitle("No GPS data available")
                    setType("danger")
                    setOverlay("show-n")
                    setLoadShow("show-n")
                    return
                }
                else if (!(response?.data !== null && typeof response?.data === 'object')) {
                    setShow(true)
                    setTitle("No GPS data available")
                    setType("danger")
                    setOverlay("show-n")
                    setLoadShow("show-n")
                    return
                }
                try {
                    if (records.coords.length == 0) {
                        setShow(true)
                        setTitle("No GPS data available")
                        setType("danger")
                        setOverlay("show-n")
                        setLoadShow("show-n")
                        return
                    }
                    else {
                        if (records.hasOwnProperty("consignee_details"))
                            records["consignee_coordinates"] = records.consignee_details
                        if (records != '') {
                            var sdate = e.gate_out_time;
                            if (e.invoice_time) {
                                var sdate = e.invoice_time;
                            }
                            else {
                                if (e.gate_in_time) {
                                    var sdate = e.gate_in_time;
                                }
                                else {
                                    if (e.gate_out_time) {
                                        var sdate = e.gate_out_time;
                                    }
                                }
                            }
                            var edate = '';
                            if (e.status <= 4) {
                                end_date = moment.parseZone().format('DD/MM/YYYY HH:mm:ss')
                                edate = getHyphenDDMMMYYYYHHMM(end_date);
                            }
                            else if (e.status == 5) {
                                if (e.left_dealer_marked) {
                                    edate = getHyphenDDMMMYYYYHHMM(e.left_dealer_marked);
                                }
                                else {
                                    end_date = moment.parseZone().format('DD/MM/YYYY HH:mm:ss')
                                    edate = getHyphenDDMMMYYYYHHMM(end_date);
                                }
                            }
                            if (records.hasOwnProperty("consignee_details")) {
                                records["consignee_coordinates"] = records.consignee_details
                            }
                            let consignee_city;
                            consignee_city = e.consignee_city
                            var params = {
                                "base_route_id": e.base_route_id,
                                "consigner_code": e.consigner_code,
                                "consignee_city": consignee_city
                            }
                            // redirectURL.post("/consignments/getDeviationRouteBaseRoute",
                            //     params).then((resp) => {
                            var baseRouteCoords = eval(records.base_route);
                            setOpenMap({
                                overly: "show-m",
                                sliderRouteTranslate: "slider-translate-60p",
                                mapinfo: records,
                                dealer: e.consignee_code,
                                consignment_code: "FO Number : " + e.fo_number,
                                maptruckno: e.truck_no,
                                routeTruck: { "truck_no": e.truck_no, "startTime": sdate, "endTime": end_date },
                                loadshow: 'show-n',
                                sidebarSubHeader: "Consignment Information",
                                rownode: e,
                                leg_no: 0,
                                tolls: records.tolls,
                                baseRouteCoords: baseRouteCoords
                            })
                            // })
                            setLoadShow("show-n")
                            var params =
                            {
                                consignee_code: e.consignee_code,
                                dept_code: e.dept_code
                            }
                        }
                    }
                }
                catch (e) {
                }

            })
            .catch(function (error) {
                console.log(error);
            });
    }

    const onClickShowRouteLegs = (rownode) => {
        setOverlay("show-m")
        setLoadShow("show-m")
        let e = rownode.data
        const getFormattedDate = (value) =>
            !!value ? moment.parseZone(value).format('YYYY-MM-DD HH:mm:ss') : null;
        const gateouttime =
            getFormattedDate(e.manual_gate_in) ||
            getFormattedDate(e.gate_in_time) ||
            getFormattedDate(e.created_date) ||
            '';
        let edate = '';
        let end_date;
        if (e.status <= 2) {
            end_date = moment.parseZone().format('YYYY-MM-DD HH:mm:ss')
            edate = end_date
        }
        else if ((e.status == 3 || e.status == 4)) {
            if (e.recent_dealer_reported) {
                end_date = e.recent_dealer_reported.replace("T", " ").replace("Z", " ").replace(".000", " ").trim();
                edate = edate = moment.parseZone(e.recent_dealer_reported).format('YYYY-MM-DD HH:mm:ss')
            }
        }
        else if (e.status == 5) {
            if (e.tvp_gate_in) {
                end_date = e.tvp_gate_in.replace("T", " ").replace("Z", " ").replace(".000", " ").trim();
                edate = moment.parseZone(e.tvp_gate_in).format('YYYY-MM-DD HH:mm:ss')
            }
            else if (e.left_dealer_marked) {
                // end_date = e.left_dealer_marked.replace("T", " ").replace("Z", " ").replace(".000", " ").trim();
                end_date = moment.parseZone(e.left_dealer_marked).format('YYYY-MM-DD HH:mm:ss')
                edate = moment.parseZone(e.left_dealer_marked).format('YYYY-MM-DD HH:mm:ss')
            }
        }
        else if (e.status == 6) {
            if (e.tvp_gate_in) {
                end_date = e.tvp_gate_in.replace("T", " ").replace("Z", " ").replace(".000", " ").trim();
                edate = getHyphenDDMMMYYYYHHMM(e.tvp_gate_in);
            } else if (e.force_closure_time) {
                end_date = moment.parseZone(e.force_closure_time).format('YYYY-MM-DD HH:mm:ss')
            }
        }
        else if (e.status == 8) {
            end_date = moment.parseZone(e.cancel_date).format('YYYY-MM-DD HH:mm:ss')
            edate = moment.parseZone(e.cancel_date).format('YYYY-MM-DD HH:mm:ss')
        }
        else if (e.status == 9) {
            end_date = moment.parseZone(e.trip_closure_done).format('YYYY-MM-DD HH:mm:ss')
            edate = moment.parseZone(e.trip_closure_done).format('YYYY-MM-DD HH:mm:ss')
        }
        else {
            end_date = moment.parseZone().format('YYYY-MM-DD HH:mm:ss')
            edate = moment.parseZone(end_date).format('YYYY-MM-DD HH:mm:ss')
        }
        if (!end_date) {
            // When end date is unavailable then current date is considered as end date.
            end_date = moment.parseZone().format('YYYY-MM-DD HH:mm:ss');
        }
        if (gateouttime == "Invalid date" && e.gate_out_time != undefined && e.gate_out_time != "") {
            gateouttime = moment.parseZone(e.gate_out_time).format('YYYY-MM-DD HH:mm:ss');
        }
        else if (gateouttime == "Invalid date") {
            gateouttime = moment.parseZone(e.created_date).format('YYYY-MM-DD HH:mm:ss');
        }
        var reqData = {
            truck_no: e.truck_no,
            gate_out_time: gateouttime,
            seconddate: end_date,
            screen: "consignment",
            display_elis_base_route: 1
        }
        if (e.consignee_code !== undefined) reqData.consignee_code = e.consignee_code
        if (e.consignment_code !== undefined) reqData.consignment_code = e.consignment_code
        reqData["user_email"] = user?.email || ""
        redirectURL.post('/consignments/maproutes', reqData, {
            headers: {
                'content-type': 'application/json'
            }
        })
            .then((response) => {
                var records = response.data;
                // this.setState({
                //     loadshow: 'show-m'
                // });
                if (response?.data?.status == "failure" || response?.data?.status == "Failure") {
                    setShow(true)
                    setTitle((e.gate_in_time != undefined && e.gate_in_time != "") ? ((e.last_packet_time != undefined && e.last_packet_time != "") ? "No GPS data available" : "No GPS data available") : "No GPS data available")
                    setType("danger")
                    setOverlay("show-n")
                    setLoadShow("show-n")
                    return
                }
                else if (!(response?.data !== null && typeof response?.data === 'object')) {
                    setShow(true)
                    setTitle((e.gate_in_time != undefined && e.gate_in_time != "") ? ((e.last_packet_time != undefined && e.last_packet_time != "") ? "No GPS data available" : "No GPS data available") : "No GPS data available")
                    setType("danger")
                    setOverlay("show-n")
                    setLoadShow("show-n")
                }
                try {
                    if (records.coords.length == 0) {
                        setShow(true)
                        setTitle((e.gate_in_time != undefined && e.gate_in_time != "") ? ((e.last_packet_time != undefined && e.last_packet_time != "") ? "No GPS data available" : "No GPS data available") : "No GPS data available")
                        setType("danger")
                        setOverlay("show-n")
                        setLoadShow("show-n")
                    }
                    else {
                        if (records != '') {
                            var sdate = e.gate_out_time;
                            if (e.invoice_time) {
                                var sdate = e.invoice_time;
                            }
                            else {
                                if (e.gate_in_time) {
                                    var sdate = e.gate_in_time;
                                }
                                else {
                                    if (e.gate_out_time) {
                                        var sdate = e.gate_out_time;
                                    }
                                }
                            }
                            if (e.status <= 4) {
                                end_date = moment.parseZone().format('DD/MM/YYYY HH:mm:ss')
                                edate = end_date
                            }
                            else if (e.status == 5) {
                                if (e.left_dealer_marked) {
                                    edate = moment.parseZone(e.left_dealer_marked).format('YYYY-MM-DD HH:mm:ss')
                                }
                                else {
                                    end_date = moment.parseZone().format('DD/MM/YYYY HH:mm:ss')
                                    edate = end_date
                                }
                            }
                            // if (e.deviation_flag == 1) {
                            let consignee_city;
                            consignee_city = e.consignee_city
                            var params = {
                                "base_route_id": e.base_route_id,
                                "consigner_code": e.consigner_code,
                                "consignee_city": consignee_city
                            }
                            // redirectURL.post("/consignments/getDeviationRouteBaseRoute",
                            //     params).then((resp) => {
                            var baseRouteCoords = eval(records.base_route);
                            setOpenMap({
                                overly: "show-m",
                                sliderRouteTranslate: "slider-translate-60p",
                                mapinfo: records,
                                dealer: e.consignee_code,
                                consignment_code: "FO Number : " + e.fo_number,
                                maptruckno: e.truck_no,
                                routeTruck: { "truck_no": e.truck_no, "startTime": sdate, "endTime": end_date },
                                loadshow: 'show-n',
                                sidebarSubHeader: "Consignment Information",
                                rownode: e,
                                leg_no: 0,
                                tolls: records.tolls,
                                baseRouteCoords: baseRouteCoords
                            })
                            // })
                            setLoadShow("show-n")
                            // }
                            // else {
                            var params =
                            {
                                consignee_code: e.consignee_code,
                                dept_code: e.dept_code
                            }
                            redirectURL.post('/consignments/geofencedata', params).then((response) => {
                                var records1 = response.data.records;
                                let parkingGeodata = []
                                if (response.data.parkingGeofence[0] !== undefined) parkingGeodata = response.data.parkingGeofence[0]
                                var geofence_coords = []
                                if (records1.length) {
                                    geofence_coords = records1[0].geofence_coordinates;
                                }
                                // setOpenMap({
                                //     sliderRouteTranslate: "slider-translate-60p",
                                //     showDiv: 'show-m',
                                //     mapinfo: records,
                                //     dealer: e.consignee_code,
                                //     consignment_code: "Consignment : " + e.consignment_code,
                                //     maptruckno: e.truck_no,
                                //     geofence_coordinates: geofence_coords,
                                //     parking_coordinates: parkingGeodata,
                                //     routeTruck: { "truck_no": e.truck_no, "startTime": sdate, "endTime": end_date },
                                //     loadshow: 'show-n',
                                //     sidebarSubHeader: "Consignment Information",
                                //     overly: 'show-m',
                                //     rownode: e,
                                //     leg_no: 0,
                                //     tolls: records.tolls
                                // })
                                setLoadShow("show-n")
                            })
                            // }
                        }
                    }
                }
                catch (e) {
                    // setShow(true)
                    // setTitle("No GPS data available")
                    // setType("danger")
                }

            })
            .catch(function (error) {
                return error;
            });
    }

    // const onShowTransitData = (params) => {
    //     let query = {
    //         truck_no: params.data.truck_no,
    //         consignment_code: params.data.consignment_code,
    //         consignee_code: params.data.consignee_code
    //     }
    //     redirectURL.post('/consignments/transitdelay', query)
    //         .then(resp => {
    //             if (resp.data?.length > 0) {
    //                 params.node.setExpanded(!params.node.expanded)
    //                 setdetailCellRendererParams({
    //                     detailGridOptions: {
    //                         columnDefs: transitdelaycols,
    //                         defaultColDef: {
    //                         },
    //                     },
    //                     getDetailRowData: (params) => {
    //                         params.successCallback(resp.data);
    //                     },
    //                 })
    //             }
    //             else {
    //                 params.node.setExpanded(!params.node.expanded)
    //                 setdetailCellRendererParams({
    //                     detailGridOptions: {
    //                         columnDefs: transitdelaycols,
    //                         defaultColDef: {
    //                         },
    //                     },
    //                     getDetailRowData: (params) => {
    //                         params.successCallback([]);
    //                     },
    //                 })
    //             }
    //         })
    //         .catch(err => {
    //             console.log(err);
    //         })
    // }

    const onShowStoppagesData = (params) => {
        let query = {
            truck_no: params.data.truck_no,
            consignment_codes: params.data.consignment_code,
            // fo_numbers: params.data.fo_number,
            old_truck_no: ''
        }
        redirectURL.post('/consignments/enroutes', query)
            .then(resp => {
                if (resp.data?.length > 0) {
                    params.node.setExpanded(!params.node.expanded)
                    setdetailCellRendererParams({
                        detailGridOptions: {
                            columnDefs: stoppagescols,
                            defaultColDef: {
                                flex: 1,
                            },
                        },
                        getDetailRowData: (params) => {
                            params.successCallback(resp.data);
                        },
                    })
                }
                else {
                    params.node.setExpanded(!params.node.expanded)
                    setdetailCellRendererParams({
                        detailGridOptions: {
                            columnDefs: stoppagescols,
                            defaultColDef: {
                                flex: 1,
                            },
                        },
                        getDetailRowData: (params) => {
                            params.successCallback([]);
                        },
                    })
                }
            })
            .catch(err => {
                console.log(err);
            })
    }

    const onShowOverspeedingData = (params) => {
        let query = {
            truck_no: params.data.truck_no,
            // consignment_code: params.data.consignment_code
            fo_numbers: params.data.fo_number
        }
        redirectURL.post('/consignments/overspeed', query)
            .then(resp => {
                if (resp.data?.length > 0) {
                    params.node.setExpanded(!params.node.expanded)
                    setdetailCellRendererParams({
                        detailGridOptions: {
                            columnDefs: overspeedcols,
                            defaultColDef: {
                                flex: 1,
                            },
                        },
                        getDetailRowData: (params) => {
                            params.successCallback(resp.data);
                        },
                    })
                }
                else {
                    params.node.setExpanded(!params.node.expanded)
                    setdetailCellRendererParams({
                        detailGridOptions: {
                            columnDefs: overspeedcols,
                            defaultColDef: {
                                flex: 1,
                            },
                        },
                        getDetailRowData: (params) => {
                            params.successCallback([]);
                        },
                    })
                }
            })
            .catch(err => {
                console.log(err);
            })
    }

    const onShowNightDrivingData = (params) => {
        params.node.setExpanded(!params.node.expanded)
        setdetailCellRendererParams({
            detailGridOptions: {
                columnDefs: nightdrivingcols,
                defaultColDef: {
                    flex: 1,
                },
            },
            getDetailRowData: (params) => {
                let nightdriving = []
                redirectURL.post('/consignments/nightdriving', {
                    // consignment_code: params.data.consignment_code,
                    fo_numbers: params.data.fo_number,
                    gate_out_time: params.data.gate_out_time,
                    truck_no: params.data.truck_no
                })
                    .then(async (response) => {
                        nightdriving = response.data;
                        params.successCallback(nightdriving);

                    });
            },
        })
    }

    const onShowLoadingData = (params) => {
        params.node.setExpanded(!params.node.expanded)
        setdetailCellRendererParams({
            detailGridOptions: {
                columnDefs: [
                    {
                        headerName: "Geofence Gate In Time",
                        field: "gate_in_time",
                        width: 180,
                        resizable: true,
                        valueGetter: function (params) {
                            if (params.data.gate_in_time) {
                                return params.data.gate_in_time;
                            }
                            else {
                                return "N/A"
                            }

                        }
                    },
                    {
                        headerName: "Geofence Gate Out Time",
                        field: "gate_out_time",
                        width: 144,
                        resizable: true,
                        valueGetter: function (params) {
                            if (params.data.gate_out_time) {
                                return params.data.gate_out_time;
                            }
                            else {
                                return "N/A"
                            }
                        }
                    },
                    {
                        headerName: "Geofence Loading Time",
                        field: "loading_time",
                        width: 180,
                    },
                    {
                        headerName: "Mobile Gate In Time",
                        field: "manual_gate_in",
                        width: 180,
                        resizable: true,
                        valueGetter: function (params) {
                            if (!!params.data.manual_gate_in) {
                                return params.data.manual_gate_in;
                            }
                            else {
                                return "N/A"
                            }

                        }
                    },
                    {
                        headerName: "Mobile Gate Out Time",
                        field: "manual_gate_out",
                        width: 144,
                        resizable: true,
                        valueGetter: function (params) {
                            if (!!params.data.manual_gate_out) {
                                return params.data.manual_gate_out;
                            }
                            else {
                                return "N/A"
                            }
                        }
                    },
                    {
                        headerName: "Mobile Loading Time",
                        field: "manual_total",
                        width: 180,
                    }
                ],
                defaultColDef: {
                    flex: 1,
                },
            },
            getDetailRowData: (params) => {
                if (params.data.gate_in_time != undefined) {
                    var g1 = getHyphenDDMMMYYYYHHMM(params.data.gate_in_time);
                    var gdate1 = new Date(params.data.gate_in_time);
                    var fromDate = g1;
                    var secondsgate1 = moment.parseZone(new Date(params.data.gate_in_time)).format("x")
                }
                else {
                    var g1 = getHyphenDDMMMYYYYHHMM(params.data.inside_fence);
                    var gdate1 = new Date(params.data.inside_fence);
                    var fromDate = g1;
                    var secondsgate1 = moment.parseZone(new Date(params.data.inside_fence)).format("x")
                }
                if (params.data.gate_out_time != undefined) {
                    var g2 = getHyphenDDMMMYYYYHHMM(params.data.gate_out_time);
                    var gdate2 = new Date(params.data.gate_out_time);
                    var toField = getHyphenDDMMMYYYYHHMM(params.data.gate_out_time);
                    var secondsgate2 = moment.parseZone(new Date(params.data.gate_out_time)).format("x")
                }
                else {
                    var c = new Date();
                    var todaydate = moment(new Date(c)).format("x");
                    var g2 = getHyphenDDMMMYYYYHHMM(todaydate);
                    var gdate2 = new Date(todaydate);
                    var toField = getHyphenDDMMMYYYYHHMM(new Date());
                    var secondsgate2 = todaydate
                }

                var total = secondsgate2 - secondsgate1;
                var diffMs = total;
                var dataarr = []
                let manual_gate_in = undefined
                let manual_gate_out = undefined
                let manual_total = 'N/A'
                if (!!params.data.manual_gate_in && !!params.data.manual_gate_out) {
                    manual_gate_in = new Date(params.data.manual_gate_in).getTime();
                    manual_gate_out = new Date(params.data.manual_gate_out).getTime();
                    manual_total = secondsToString((manual_gate_out - manual_gate_in) / 1000)
                }
                dataarr.push({
                    "gate_in_time": fromDate,
                    "gate_out_time": toField,
                    "loading_time": secondsToString(diffMs / 1000),
                    "manual_gate_in": getHyphenDDMMMYYYYHHMM(params.data.manual_gate_in),
                    "manual_gate_out": getHyphenDDMMMYYYYHHMM(params.data.manual_gate_out),
                    "manual_total": manual_total,
                })
                params.successCallback(dataarr);
            },
        })
    }
    const onShowUnloadingData = (params) => {
        params.node.setExpanded(!params.node.expanded)
        let unloading = []
        redirectURL.post('/consignments/getUnloadingLegs', {
            consignment_code: params.data.consignment_code,
            truck_no: params.data.truck_no
        })
            .then(async (response) => {
                if (response.data.length > 0) {
                    response.data.map(each => {
                        if (each.locked_dealer_reported == undefined) {
                            var g1 = each.first_dealer_reported;
                            var fromField = g1;
                        }
                        else {
                            var g1 = each.locked_dealer_reported;
                            var fromField = g1;
                        }
                        if (each.left_dealer_marked == undefined) {
                            var todaydate = moment().local().format("YYYY-MM-DDTHH:mm:ss.SSS[Z]")
                            var g2 = todaydate
                            var toField = g2;
                        }
                        else {
                            var g2 = each.left_dealer_marked
                            var toField = g2;
                        }
                        if (fromField == undefined || fromField == null) {
                            unloading.push({
                                "from_date": undefined,
                                "to_date": undefined,
                                "consignment_code": each.consignment_code,
                                "unloading_time": "N/A"
                            })
                        }
                        else {
                            var gdate1 = new Date(fromField);
                            var gdate2 = new Date(toField);
                            var frmd = gdate1.getTime();
                            var tod = gdate2.getTime();
                            var total = tod - frmd;
                            var diffMs = total;
                            let loadingTimeDifference = null;
                            loadingTimeDifference = secondsToString(diffMs / 1000)
                            unloading.push({
                                "from_date": fromField,
                                "to_date": toField,
                                "consignment_code": each.consignment_code,
                                "unloading_time": loadingTimeDifference
                            })
                        }
                    })
                    setdetailCellRendererParams({
                        detailGridOptions: {
                            columnDefs: unloadingcols,
                            defaultColDef: {
                                flex: 1,
                            },
                        },
                        getDetailRowData: (params) => {
                            params.successCallback(unloading);
                        },
                    })
                }
                else {
                    setdetailCellRendererParams({
                        detailGridOptions: {
                            columnDefs: unloadingcols,
                            defaultColDef: {
                                flex: 1,
                            },
                        },
                        getDetailRowData: (params) => {
                            params.successCallback([]);
                        },
                    })
                }
            })
            .catch(err => console.log(err))
    }
    const onShowFoDetails = (params) => {

        setdetailCellRendererParams({
            detailGridOptions: {
                columnDefs: fodetails,
                defaultColDef: {
                    flex: 1,
                },
            },
            getDetailRowData: (params) => {
                redirectURL.post('/consignments/getFoLevelLegs', {
                    fo_number: params.data.fo_number,
                }).then((response) => {
                    const foDetails = response.data;
                    const combinedData = [
                        ...(foDetails?.mobile_log_df || []),
                        ...(foDetails?.sftp_df || [])
                    ];
                    params.successCallback(combinedData || []);


                })
            },
        });
        params.node.setExpanded(!params.node.expanded)
    };

    const onShowItemDetails = (params) => {
        console.log("show details")
        setdetailCellRendererParams({
            detailGridOptions: {
                columnDefs: item_details,
                defaultColDef: {
                    flex: 1,
                },
            },
            getDetailRowData: (params) => {
                params.successCallback(params?.data?.item_list ?? []);
            },
        });

        // Toggle row expansion safely
        params.node.setExpanded(!params.node.expanded);
    };




    const onShowTripDeviation = (params) => {
        params.node.setExpanded(!params.node.expanded)
        setdetailCellRendererParams({
            detailGridOptions: {
                columnDefs: deviationlogscols,
                defaultColDef: {
                    flex: 1,
                },
            },
            getDetailRowData: (params) => {
                let data = []
                redirectURL.post('/consignments/tripDeviationLogs', {
                    consignment_code: params.data.consignment_code,
                })
                    .then(async (response) => {
                        data = response.data;
                        params.successCallback(data)
                    });
            },
        })
    }

    const onShowNoGPSData = (params) => {
        params.node.setExpanded(!params.node.expanded)
        setdetailCellRendererParams({
            detailGridOptions: {
                columnDefs: nogpscols,
                defaultColDef: {
                    flex: 1,
                },
            },
            getDetailRowData: (params) => {
                let nogpsrecords = []
                redirectURL.post('/consignments/nogpsdata', {
                    consignment_code: params.data.consignment_code,
                    truck_no: params.data.truck_no
                })
                    .then(async (response) => {
                        nogpsrecords = response.data;
                        params.successCallback(nogpsrecords);

                    });
            },
        })
    }

    // const onClickShowConsignmentsLegsData = async (params) => {
    //     params.node.setExpanded(!params.node.expanded)
    //     let body = {
    //         number: params.data.fo_number
    //     }
    //     let defs = columnDefs2
    //     if (params.data.consignment_legs.some(e => e.status == 6)) {
    //         defs.push(
    //             {
    //                 headerName: "Force Close Reason",
    //                 field: "force_closure_reason"
    //             })
    //         defs.push(
    //             {
    //                 headerName: "Force Close Done By",
    //                 field: "force_closure_performed_by"
    //             })
    //     }
    //     else if (params.data.consignment_legs.some(e => e.status == 8)) {
    //         defs.push(
    //             {
    //                 headerName: "Remarks",
    //                 field: "cancel_remarks",
    //                 valueGetter: function (params) {
    //                     if (params.data.status == 8) {
    //                         return "Consignment has been canceled";
    //                     }
    //                     else {
    //                         return "N/A"
    //                     }
    //                 }
    //             })
    //         defs.push(
    //             {
    //                 headerName: "Cancel Date",
    //                 field: "cancel_date",
    //                 valueGetter: function (params) {
    //                     return getHyphenDDMMMYYYYHHMM(params.data.cancel_date);
    //                 },
    //             })
    //     }
    //     if (params.data.consignment_legs?.length > 0) {
    //         setdetailCellRendererParams({
    //             detailGridOptions: {
    //                 columnDefs: defs,
    //                 defaultColDef: {
    //                 },
    //             },
    //             getDetailRowData: (params) => {
    //                 params.successCallback(params.data.consignment_legs);
    //             },
    //         })
    //     }
    //     else {
    //         setOverlay("show-m")
    //         setLoadShow("show-m")
    //         if (user.role[0] == "DEALER")
    //             body["user_code"] = user.dealer_code ?? "EMPTY"
    //         else if (user.role[0] == "PLANT") {
    //             body["plant_codes"] = user.plant_codes ?? "EMPTY"
    //         }
    //         await redirectURL.post("consignments/getConsignmentLegs", body)
    //             .then(resp => {
    //                 params.data["consignment_legs"] = resp.data.consignments
    //                 setOverlay("show-n")
    //                 setLoadShow("show-n")
    //                 setdetailCellRendererParams({
    //                     detailGridOptions: {
    //                         columnDefs: defs,
    //                         defaultColDef: {
    //                         },
    //                     },
    //                     getDetailRowData: (params) => {
    //                         params.successCallback(params.data.consignment_legs);
    //                     },
    //                 })
    //             })
    //             .catch(err => {
    //                 setOverlay("show-n")
    //                 setLoadShow("show-n")
    //                 setdetailCellRendererParams({
    //                     detailGridOptions: {
    //                         columnDefs: columnDefs2,
    //                         defaultColDef: {
    //                         },
    //                     },
    //                     getDetailRowData: (params) => {
    //                         params.successCallback([]);
    //                     },
    //                 })
    //                 console.log(err)
    //             })
    //     }
    // }

    const fragmentData = (resp, setLoader = false) => {
        if (resp.data.status == "success") {
            if (window.location.pathname == "/active-FOs" || window.location.pathname == "/all-FOs") {
                let all_data = []
                let total_unique_fo = new Set([])
                let total_hot_loads = new Set([])
                let total_fo_deliveries = new Set([])
                let GPS_data_acquired = new Set([])
                let gps_inside_plant = new Set([])
                let gps_in_transit = new Set([])
                let gps_transit_delays = new Set([])
                let gps_hot_loads = new Set([])
                let gps_overspeeding = new Set([])
                let gps_night_driving = new Set([])
                let gps_stoppages = new Set([])
                let gps_loading_delays = new Set([])
                let gps_unloading_delays = new Set([])
                let gps_deviated_routes = new Set([])
                let consent_acquired = new Set([])
                let sim_inside_plant = new Set([])
                let sim_in_transit = new Set([])
                let sim_transit_delays = new Set([])
                let sim_hot_loads = new Set([])
                let sim_overspeeding = new Set([])
                let sim_night_driving = new Set([])
                let sim_stoppages = new Set([])
                let sim_loading_delays = new Set([])
                let sim_unloading_delays = new Set([])
                let sim_deviated_routes = new Set([])
                let consent_pending = new Set([])
                let cp_oldest_fo = new Set([])
                let cp_latest_fo = new Set([])
                let cp_hot_loads = new Set([])
                let drop_total_hot_loads = new Set([])

                let drop_GPS_data_acquired = new Set([])
                let drop_gps_inside_plant = new Set([])
                let drop_gps_in_transit = new Set([])
                let drop_gps_transit_delays = new Set([])
                let drop_gps_hot_loads = new Set([])
                let drop_gps_overspeeding = new Set([])
                let drop_gps_night_driving = new Set([])
                let drop_gps_stoppages = new Set([])
                let drop_gps_loading_delays = new Set([])
                let drop_gps_unloading_delays = new Set([])
                let drop_gps_deviated_routes = new Set([])
                let drop_consent_acquired = new Set([])
                let drop_sim_inside_plant = new Set([])
                let drop_sim_in_transit = new Set([])
                let drop_sim_transit_delays = new Set([])
                let drop_sim_hot_loads = new Set([])
                let drop_sim_overspeeding = new Set([])
                let drop_sim_night_driving = new Set([])
                let drop_sim_stoppages = new Set([])
                let drop_sim_loading_delays = new Set([])
                let drop_sim_unloading_delays = new Set([])
                let drop_sim_deviated_routes = new Set([])
                let drop_consent_pending = new Set([])
                let drop_cp_oldest_fo = new Set([])
                let drop_cp_latest_fo = new Set([])
                let drop_cp_hot_loads = new Set([])

                let data = JSON.parse(resp.data.apiData)
                all_data = parseJSONSafely(data, "all_data")

                let data_total_unique_fo = new Set(parseJSONSafely(data, "total_unique_fo"))
                total_hot_loads = new Set(parseJSONSafely(data, "total_hot_loads"))
                drop_total_hot_loads = new Set(parseJSONSafely(data, "drop_total_hot_loads"))
                consent_pending = new Set(parseJSONSafely(data, "consent_pending_data"))
                drop_consent_pending = new Set(parseJSONSafely(data, "drop_consent_pending_data"))
                consent_acquired = new Set(parseJSONSafely(data, "consent_approved_data"))
                GPS_data_acquired = new Set(parseJSONSafely(data, "location_data_acquired"))
                drop_consent_acquired = new Set(parseJSONSafely(data, "drop_consent_approved_data"))
                drop_GPS_data_acquired = new Set(parseJSONSafely(data, "drop_location_data_acquired"))

                cp_oldest_fo = new Set(parseJSONSafely(data, "oldest_date_records"))
                cp_latest_fo = new Set(parseJSONSafely(data, "latest_date_records"))
                drop_cp_oldest_fo = new Set(parseJSONSafely(data, "drop_cp_oldest_fo"))
                drop_cp_latest_fo = new Set(parseJSONSafely(data, "drop_cp_latest_fo"))
                cp_hot_loads = new Set(parseJSONSafely(data, "cp_hot_loads"))
                drop_cp_hot_loads = new Set(parseJSONSafely(data, "drop_cp_hot_loads"))

                gps_inside_plant = new Set(parseJSONSafely(data, "gps_inside_plant"))
                gps_in_transit = new Set(parseJSONSafely(data, "gps_in_transit"))
                gps_transit_delays = new Set(parseJSONSafely(data, "gps_transit_delays"))
                gps_hot_loads = new Set(parseJSONSafely(data, "gps_hot_loads"))
                gps_overspeeding = new Set(parseJSONSafely(data, "gps_overspeeding"))
                gps_night_driving = new Set(parseJSONSafely(data, "gps_night_driving"))
                gps_stoppages = new Set(parseJSONSafely(data, "gps_stoppages"))
                gps_loading_delays = new Set(parseJSONSafely(data, "gps_loading_delays"))
                gps_unloading_delays = new Set(parseJSONSafely(data, "gps_unloading_delays"))
                gps_deviated_routes = new Set(parseJSONSafely(data, "gps_deviated_routes"))
                sim_inside_plant = new Set(parseJSONSafely(data, "sim_inside_plant"))
                sim_in_transit = new Set(parseJSONSafely(data, "sim_in_transit"))
                sim_transit_delays = new Set(parseJSONSafely(data, "sim_transit_delays"))
                sim_hot_loads = new Set(parseJSONSafely(data, "sim_hot_loads"))
                sim_overspeeding = new Set(parseJSONSafely(data, "sim_overspeeding"))
                sim_night_driving = new Set(parseJSONSafely(data, "sim_night_driving"))
                sim_stoppages = new Set(parseJSONSafely(data, "sim_stoppages"))
                sim_loading_delays = new Set(parseJSONSafely(data, "sim_loading_delays"))
                sim_unloading_delays = new Set(parseJSONSafely(data, "sim_unloading_delays"))
                sim_deviated_routes = new Set(parseJSONSafely(data, "sim_deviated_routes"))
                drop_gps_inside_plant = new Set(parseJSONSafely(data, "drop_gps_inside_plant"))
                drop_gps_in_transit = new Set(parseJSONSafely(data, "drop_gps_in_transit"))
                drop_gps_transit_delays = new Set(parseJSONSafely(data, "drop_gps_transit_delays"))
                drop_gps_hot_loads = new Set(parseJSONSafely(data, "drop_gps_hot_loads"))
                drop_gps_overspeeding = new Set(parseJSONSafely(data, "drop_gps_overspeeding"))
                drop_gps_night_driving = new Set(parseJSONSafely(data, "drop_gps_night_driving"))
                drop_gps_stoppages = new Set(parseJSONSafely(data, "drop_gps_stoppages"))
                drop_gps_loading_delays = new Set(parseJSONSafely(data, "drop_gps_loading_delays"))
                drop_gps_unloading_delays = new Set(parseJSONSafely(data, "drop_gps_unloading_delays"))
                drop_gps_deviated_routes = new Set(parseJSONSafely(data, "drop_gps_deviated_routes"))
                drop_sim_inside_plant = new Set(parseJSONSafely(data, "drop_sim_inside_plant"))
                drop_sim_in_transit = new Set(parseJSONSafely(data, "drop_sim_in_transit"))
                drop_sim_transit_delays = new Set(parseJSONSafely(data, "drop_sim_transit_delays"))
                drop_sim_hot_loads = new Set(parseJSONSafely(data, "drop_sim_hot_loads"))
                drop_sim_overspeeding = new Set(parseJSONSafely(data, "drop_sim_overspeeding"))
                drop_sim_night_driving = new Set(parseJSONSafely(data, "drop_sim_night_driving"))
                drop_sim_stoppages = new Set(parseJSONSafely(data, "drop_sim_stoppages"))
                drop_sim_loading_delays = new Set(parseJSONSafely(data, "drop_sim_loading_delays"))
                drop_sim_unloading_delays = new Set(parseJSONSafely(data, "drop_sim_unloading_delays"))
                drop_sim_deviated_routes = new Set(parseJSONSafely(data, "drop_sim_deviated_routes"))

                total_unique_fo = all_data.filter((item) => data_total_unique_fo.has(item._id))

                setCPCounterDate({
                    cp_oldest_fo: data.oldest_fo_date,
                    cp_latest_fo: data.latest_fo_date,
                    cp_hot_loads_cp: cp_hot_loads.size,
                    drop_cp_hot_loads: drop_cp_hot_loads.size,
                })
                all_rows_data.current = all_data
                let data_object = {
                    total_unique_fo,
                    total_fo_deliveries: all_data,
                    total_hot_loads,
                    GPS_data_acquired,
                    gps_inside_plant,
                    gps_in_transit,
                    gps_transit_delays,
                    gps_hot_loads,
                    gps_overspeeding,
                    gps_night_driving,
                    gps_stoppages,
                    gps_loading_delays,
                    gps_unloading_delays,
                    gps_deviated_routes,
                    consent_acquired,
                    sim_inside_plant,
                    sim_in_transit,
                    sim_transit_delays,
                    sim_hot_loads,
                    sim_overspeeding,
                    sim_night_driving,
                    sim_stoppages,
                    sim_loading_delays,
                    sim_unloading_delays,
                    sim_deviated_routes,
                    consent_pending,
                    cp_latest_fo,
                    cp_oldest_fo,
                    cp_hot_loads,
                    drop_total_hot_loads,
                    drop_GPS_data_acquired,
                    drop_gps_inside_plant,
                    drop_gps_in_transit,
                    drop_gps_transit_delays,
                    drop_gps_hot_loads,
                    drop_gps_overspeeding,
                    drop_gps_night_driving,
                    drop_gps_stoppages,
                    drop_gps_loading_delays,
                    drop_gps_unloading_delays,
                    drop_gps_deviated_routes,
                    drop_consent_acquired,
                    drop_sim_inside_plant,
                    drop_sim_in_transit,
                    drop_sim_transit_delays,
                    drop_sim_hot_loads,
                    drop_sim_overspeeding,
                    drop_sim_night_driving,
                    drop_sim_stoppages,
                    drop_sim_loading_delays,
                    drop_sim_unloading_delays,
                    drop_sim_deviated_routes,
                    drop_consent_pending,
                    drop_cp_oldest_fo,
                    drop_cp_latest_fo,
                    drop_cp_hot_loads,
                }
                setActiveTripsData(data_object)
                if (toggle) {
                    setActiveTopCounters({
                        uniqueFO: total_unique_fo.length,
                        fo_deliveries: all_data.length,
                        hot_loads: total_hot_loads.size,
                        consent_pending: consent_pending.size,
                        consent_acquired: consent_acquired.size,
                        GPS_data_acquired: GPS_data_acquired.size,
                    })
                }
                else {
                    setActiveTopCounters({
                        uniqueFO: total_unique_fo.length,
                        fo_deliveries: all_data.length,
                        hot_loads: drop_total_hot_loads.size,
                        consent_pending: drop_consent_pending.size,
                        consent_acquired: drop_consent_acquired.size,
                        GPS_data_acquired: drop_GPS_data_acquired.size,
                    })
                }
                if ((middleCounter.value != undefined && middleCounter.value != "") || topCounterAlt.current.value == "consent_pending" || topCounterAlt.current.value == "consent_acquired" || topCounterAlt.current.value == "GPS_data_acquired") {
                    if (toggle) {
                        if (middleCounter.value != "" && topCounterAlt.current.value == "consent_acquired") {
                            setActiveTripsCounters({
                                inside_plant: sim_inside_plant.size,
                                in_transit: sim_in_transit.size,
                                transit_delays: sim_transit_delays.size,
                                hot_loads: sim_hot_loads.size,
                                overspeeding: sim_overspeeding.size,
                                night_driving: sim_night_driving.size,
                                stoppages: sim_stoppages.size,
                                loading_delays: sim_loading_delays.size,
                                unloading_delays: sim_unloading_delays.size,
                                deviated_routes: sim_deviated_routes.size,
                            })
                        }
                        else if (middleCounter.value != "" && topCounterAlt.current.value == "GPS_data_acquired") {
                            setActiveTripsCounters({
                                inside_plant: gps_inside_plant.size,
                                in_transit: gps_in_transit.size,
                                transit_delays: gps_transit_delays.size,
                                hot_loads: gps_hot_loads.size,
                                overspeeding: gps_overspeeding.size,
                                night_driving: gps_night_driving.size,
                                stoppages: gps_stoppages.size,
                                loading_delays: gps_loading_delays.size,
                                unloading_delays: gps_unloading_delays.size,
                                deviated_routes: gps_deviated_routes.size,
                            })
                        }
                        if (middleCounter.value != undefined && middleCounter.value != "") {
                            let setName = ''
                            if (topCounterAlt.current.value == "GPS_data_acquired")
                                setName = "gps_" + middleCounter.value.toString()
                            else if (topCounterAlt.current.value == "consent_acquired")
                                setName = "sim_" + middleCounter.value.toString()
                            else if (topCounterAlt.current.value == "consent_pending")
                                setName = middleCounter.value.toString()
                            setRowData(all_data.filter((item) => data_object[setName].has(item._id)))
                        }
                        else {
                            setRowData(all_data.filter((item) => data_object[(topCounterAlt.current.value).toString()].has(item._id)))
                        }
                    }
                    else {
                        // if (middleCounter.value != "" && topCounterAlt.current.value == "consent_acquired") {
                        //     setActiveTripsCounters({
                        //         inside_plant: drop_sim_inside_plant.size,
                        //         in_transit: drop_sim_in_transit.size,
                        //         transit_delays: drop_sim_transit_delays.size,
                        //         hot_loads: drop_sim_hot_loads.size,
                        //         overspeeding: drop_sim_overspeeding.size,
                        //         night_driving: drop_sim_night_driving.size,
                        //         stoppages: drop_sim_stoppages.size,
                        //         loading_delays: drop_sim_loading_delays.size,
                        //         unloading_delays: drop_sim_unloading_delays.size,
                        //         deviated_routes: drop_sim_deviated_routes.size,
                        //     })
                        // }
                        // else if (middleCounter.value != "" && topCounterAlt.current.value == "GPS_data_acquired") {
                        //     setActiveTripsCounters({
                        //         inside_plant: drop_gps_inside_plant.size,
                        //         in_transit: drop_gps_in_transit.size,
                        //         transit_delays: drop_gps_transit_delays.size,
                        //         hot_loads: drop_gps_hot_loads.size,
                        //         overspeeding: drop_gps_overspeeding.size,
                        //         night_driving: drop_gps_night_driving.size,
                        //         stoppages: drop_gps_stoppages.size,
                        //         loading_delays: drop_gps_loading_delays.size,
                        //         unloading_delays: drop_gps_unloading_delays.size,
                        //         deviated_routes: drop_gps_deviated_routes.size,
                        //     })
                        // }
                        // if (middleCounter.value != undefined && middleCounter.value != "") {
                        //     let setName = ''
                        //     if (topCounterAlt.current.value == "GPS_data_acquired")
                        //         setName = "drop_gps_" + middleCounter.value.toString()
                        //     if (topCounterAlt.current.value == "consent_acquired")
                        //         setName = "drop_sim_" + middleCounter.value.toString()
                        //     setRowData(all_data.filter((item) => data_object[setName].has(item._id)))
                        // }
                        // else {
                        //     let setName = "drop_" + topCounterAlt.current.value.toString()
                        //     setRowData(all_data.filter((item) => data_object[setName].has(item._id)))
                        // }
                        if (middleCounter.value != "" && topCounterAlt.current.value == "consent_acquired") {
                            setActiveTripsCounters({
                                inside_plant: drop_sim_inside_plant.size,
                                in_transit: drop_sim_in_transit.size,
                                transit_delays: drop_sim_transit_delays.size,
                                hot_loads: drop_sim_hot_loads.size,
                                overspeeding: drop_sim_overspeeding.size,
                                night_driving: drop_sim_night_driving.size,
                                stoppages: drop_sim_stoppages.size,
                                loading_delays: drop_sim_loading_delays.size,
                                unloading_delays: drop_sim_unloading_delays.size,
                                deviated_routes: drop_sim_deviated_routes.size,
                            })
                        }
                        else if (middleCounter.value != "" && topCounterAlt.current.value == "GPS_data_acquired") {
                            setActiveTripsCounters({
                                inside_plant: drop_gps_inside_plant.size,
                                in_transit: drop_gps_in_transit.size,
                                transit_delays: drop_gps_transit_delays.size,
                                hot_loads: drop_gps_hot_loads.size,
                                overspeeding: drop_gps_overspeeding.size,
                                night_driving: drop_gps_night_driving.size,
                                stoppages: drop_gps_stoppages.size,
                                loading_delays: drop_gps_loading_delays.size,
                                unloading_delays: drop_gps_unloading_delays.size,
                                deviated_routes: drop_gps_deviated_routes.size,
                            })
                        }
                        if (middleCounter.value != undefined && middleCounter.value != "") {
                            let setName = ''
                            if (topCounterAlt.current.value == "GPS_data_acquired")
                                setName = "drop_gps_" + middleCounter.value.toString()
                            else if (topCounterAlt.current.value == "consent_acquired")
                                setName = "drop_sim_" + middleCounter.value.toString()
                            else if (topCounterAlt.current.value == "consent_pending")
                                setName = "drop_" + middleCounter.value.toString()
                            setRowData(all_data.filter((item) => data_object[setName].has(item._id)))
                        }
                        else {
                            setRowData(all_data.filter((item) => data_object[(topCounterAlt.current.value).toString()].has(item._id)))
                        }
                    }
                }
                else if (topCounterAlt.current.value == "fo_deliveries")
                    setRowData(all_data)
                else if (topCounterAlt.current.value == "hot_loads")
                    setRowData(all_data.filter((item) => data_object["total_hot_loads"].has(item._id)))
                else
                    setRowData(total_unique_fo)
            }
            else if (window.location.pathname == "/delivered-FOs") {
                let all_data = []
                let total_unique_fo = []
                let total_hot_loads = []
                let transit_delays = []
                let on_time = []
                let overspeeding = []
                let night_driving = []
                let stoppages = []
                let loading_delays = []
                let unloading_delays = []
                let deviated_routes = []
                let fo_transit_delays = []
                let fo_on_time = []
                let fo_overspeeding = []
                let fo_night_driving = []
                let fo_stoppages = []
                let fo_loading_delays = []
                let fo_unloading_delays = []
                let fo_deviated_routes = []
                let fo_total_hot_loads = []


                let data = JSON.parse(resp.data.apiData)
                all_data = parseJSONSafely(data, "all_data")

                let data_total_unique_fo = new Set(parseJSONSafely(data, "total_unique_fo"))
                let data_total_hot_loads = new Set(parseJSONSafely(data, "total_hot_loads"))

                total_unique_fo = all_data.filter((item) => data_total_unique_fo.has(item._id))

                total_hot_loads = all_data.filter((item) => data_total_hot_loads.has(item._id))

                all_data.forEach(each => {
                    if (each.hasOwnProperty("ontime_status") && each.ontime_status == "Delayed") {
                        transit_delays.push(each)
                    }
                    if (each.hasOwnProperty("ontime_status") && each.ontime_status == "On Time") {
                        on_time.push(each)
                    }
                    if (each.hasOwnProperty("overspeeding_exception") && each.overspeeding_exception == 1) {
                        overspeeding.push(each)
                    }
                    if (each.hasOwnProperty("nightdriving_exception") && each.nightdriving_exception == 1) {
                        night_driving.push(each)
                    }
                    if (each.hasOwnProperty("enroute_exception") && each.enroute_exception == 1) {
                        stoppages.push(each)
                    }
                    if (each.hasOwnProperty("loading_delay_exception") && each.loading_delay_exception == 1) {
                        loading_delays.push(each)
                    }
                    if (each.hasOwnProperty("deviation_identified") && each.deviation_identified == 1) {
                        deviated_routes.push(each)
                    }
                    if (each.hasOwnProperty("unloading_delay_exception") && each.unloading_delay_exception == 1) {
                        unloading_delays.push(each)
                    }
                })

                total_unique_fo.forEach(each => {
                    if (each.hasOwnProperty("ontime_status") && each.ontime_status == "Delayed") {
                        fo_transit_delays.push(each)
                    }
                    if (each.hasOwnProperty("ontime_status") && each.ontime_status == "On Time") {
                        fo_on_time.push(each)
                    }
                    if (each.hasOwnProperty("overspeeding_exception") && each.overspeeding_exception == 1) {
                        fo_overspeeding.push(each)
                    }
                    if (each.hasOwnProperty("nightdriving_exception") && each.nightdriving_exception == 1) {
                        fo_night_driving.push(each)
                    }
                    if (each.hasOwnProperty("enroute_exception") && each.enroute_exception == 1) {
                        fo_stoppages.push(each)
                    }
                    if (each.hasOwnProperty("loading_delay_exception") && each.loading_delay_exception == 1) {
                        fo_loading_delays.push(each)
                    }
                    if (each.hasOwnProperty("deviation_identified") && each.deviation_identified == 1) {
                        fo_deviated_routes.push(each)
                    }
                    if (each.hasOwnProperty("unloading_delay_exception") && each.unloading_delay_exception == 1) {
                        fo_unloading_delays.push(each)
                    }
                    if (each.hasOwnProperty("hot_loads") && each.hot_loads == 1) {
                        fo_total_hot_loads.push(each)
                    }
                })
                all_rows_data.current = all_data
                setDeliveredTrips({
                    total_unique_fo,
                    total_hot_loads,
                    total_fo_deliveries: all_data,
                    transit_delays,
                    on_time,
                    overspeeding,
                    night_driving,
                    stoppages,
                    loading_delays,
                    unloading_delays,
                    deviated_routes,
                    fo_transit_delays,
                    fo_on_time,
                    fo_overspeeding,
                    fo_night_driving,
                    fo_stoppages,
                    fo_loading_delays,
                    fo_unloading_delays,
                    fo_deviated_routes,
                    fo_total_hot_loads
                })
                setDeliveredCounter({
                    total_unique_fo: total_unique_fo.length ?? 0,
                    total_fo_deliveries: all_data.length ?? 0,
                    total_hot_loads: total_hot_loads.length ?? 0,
                    transit_delays: fo_transit_delays.length ?? 0,
                    on_time: fo_on_time.length ?? 0,
                    overspeeding: fo_overspeeding.length ?? 0,
                    night_driving: fo_night_driving.length ?? 0,
                    stoppages: fo_stoppages.length ?? 0,
                    loading_delays: fo_loading_delays.length ?? 0,
                    unloading_delays: fo_unloading_delays.length ?? 0,
                    deviated_routes: fo_deviated_routes.length ?? 0,
                })
                setRowData(total_unique_fo)
            }
        }
        if (setLoader != false) {
            setLoader(false)
        }
        else {
            setOverlay("show-n")
            setLoadShow("show-n")
        }
    }

    const loadConsignmentsData = async (setLoader = false) => {
        let params = {
            sdate: moment.parseZone(new Date(startDate)).format("YYYY-MM-DD"),
            edate: moment.parseZone(new Date(endDate)).format("YYYY-MM-DD")
        }
        if (setLoader != false) {
            setLoader(false)
        }
        if (user.role[0] == "DEALER")
            params["user_code"] = user.dealer_code ?? "EMPTY"
        else if (user.role[0] == "PLANT") {
            params["plant_codes"] = user.plant_codes ?? "EMPTY"
        }
        else if (user.role[0] == "TRANSPORTER") {
            params["transporter_code"] = user.transporter_code ?? "EMPTY"
        }

        let url = ''
        if (window.location.pathname == "/active-FOs")
            url = "consignments/getActiveConsignments"
        else if (window.location.pathname == "/delivered-FOs")
            url = "consignments/getDeliveredConsignments"
        else if (window.location.pathname == "/all-FOs")
            url = "consignments/getAllConsignments"
        await redirectURL.post(url, params)
            .then(resp => {
                fragmentData(resp, setLoader)
            })
            .catch(err => console.log(err))
        // await redirectURL.post("/consignments/consigneeDetails").then(resp =>{
        //     if(resp.data.status == 'success')
        //     setConsigneeDetails(resp?.data?.data)
        // })

    }
    const changeReloadPage = () => {
        reloadPage.current = true
    }
    const saveConsignments = async (e) => {
        e.preventDefault();
        setOverlay("show-m")
        setLoadShow("show-m")
        let error = 0
        if (bulkType?.value == 'Road') {
            if (gridApi.current) {
                gridApi.current.stopEditing();
                const gridRowData = [];
                gridApi.current.forEachNode((node) => {
                    if (!!!node.data.plant_code || !!!node.data.fo_number || !!!node.data.invoice_date || !!!node.data.transporter_code || !!!node.data.dealer_code || !!!node.data.expected_date || !!!node.data.driver_name || !!!node.data.vehicle_no) {
                        setShow(true)
                        setTitle("Please fill the required fields")
                        setType("danger")
                        gridApi.current.refreshCells()
                        error = 1
                        setOverlay("show-n")
                        setLoadShow("show-n")
                        return
                    }
                    else if (!node.data.fo_number.startsWith('I30')) {
                        setShow(true)
                        setTitle("Please fill the required fields")
                        setType("danger")
                        gridApi.current.refreshCells()
                        error = 1
                        setOverlay("show-n")
                        setLoadShow("show-n")
                        return
                    }
                    else if (!plantData.some(e => e.consigner_code == node.data.plant_code)) {
                        setShow(true)
                        setTitle("Please give a valid Plant Code")
                        setType("danger")
                        gridApi.current.refreshCells()
                        error = 1
                        setOverlay("show-n")
                        setLoadShow("show-n")
                        return
                    }
                    else if ((!moment(node.data.invoice_date, "DD/MM/YYYY HH:mm", true).isValid())) {
                        setShow(true)
                        setTitle("Please give a valid Invoice Date (DD/MM/YYYY HH:mm)")
                        setType("danger")
                        gridApi.current.refreshCells()
                        error = 1
                        setOverlay("show-n")
                        setLoadShow("show-n")
                        return
                    }
                    else if (!transporters.some(e => e.transporter_code == node.data.transporter_code)) {
                        setShow(true)
                        setTitle("Please give a valid Transporter Code")
                        setType("danger")
                        gridApi.current.refreshCells()
                        error = 1
                        setOverlay("show-n")
                        setLoadShow("show-n")
                        return
                    }
                    else if (!dealers.some(e => e.consignee_code == node.data.dealer_code)) {
                        setShow(true)
                        setTitle("Please give a valid Customer Code")
                        setType("danger")
                        gridApi.current.refreshCells()
                        error = 1
                        setOverlay("show-n")
                        setLoadShow("show-n")
                        return
                    }
                    else if (!(/^[6-9]\d{9}$/.test(node.data.driver_number))) {
                        setShow(true)
                        setTitle("Please give a valid Driver Number")
                        setType("danger")
                        gridApi.current.refreshCells()
                        error = 1
                        setOverlay("show-n")
                        setLoadShow("show-n")
                        return
                    }
                    else if (!moment(node.data.expected_date, "DD/MM/YYYY HH:mm", true).isValid()) {
                        setShow(true)
                        setTitle("Please give a valid Expected Date (DD/MM/YYYY HH:mm)")
                        setType("danger")
                        gridApi.current.refreshCells()
                        error = 1
                        setOverlay("show-n")
                        setLoadShow("show-n")
                        return
                    }
                    else
                        gridRowData.push(node.data)
                })
                if (gridRowData.length > 0 && error === 0) {
                    await redirectURL.post("/bulkUploadConsignments", { consignments: gridRowData, email: "" })
                        .then(response => {
                            if (response.data.status == "success") {
                                setShow(true)
                                setTitle(response.data.message)
                                setType("success")
                                setBulkUploadModal(false)
                                setModalLoadData([])
                                setValidData([])
                                setInvalidData([])
                                fileRef.current.value = ''
                                setBulkType('')
                                loadConsignmentsData()
                                setOverlay("show-n")
                                setLoadShow("show-n")
                            }
                            else {
                                setShow(true)
                                setTitle(response.data.message)
                                setValidData([])
                                setInvalidData([])
                                fileRef.current.value = ''
                                setBulkType('')
                                setType("danger")
                                setOverlay("show-n")
                                setLoadShow("show-n")
                            }
                        })
                        .catch(err => console.log(err))
                }
                else if (error == 0) {
                    setShow(true)
                    setTitle("File input is required. Please choose a file")
                    setType("danger")
                    setValidData([])
                    setInvalidData([])
                    fileRef.current.value = ''
                    setBulkType('')
                    setOverlay("show-n")
                    setLoadShow("show-n")
                }
            }
        } else {
            if (gridApi.current) {
                gridApi.current.stopEditing();
                const gridRowData = [];
                gridApi.current.forEachNode((node) => {
                    if (!!!node.data.plant_code || !!!node.data.fo_number || !!!node.data.transporter_code || !!!node.data.dealer_code || !!!node.data.date_of_dispatch || !!!node.data.vehicle_no) {
                        setShow(true)
                        setTitle("Please fill the required fields")
                        setType("danger")
                        gridApi.current.refreshCells()
                        error = 1
                        setOverlay("show-n")
                        setLoadShow("show-n")
                        return
                    }
                    else if (!eximPlantData.includes(node.data.plant_code) && !eximDealers.includes(node.data.plant_code)) {
                        setShow(true)
                        setTitle("Please give a valid Plant Code")
                        setType("danger")
                        gridApi.current.refreshCells()
                        error = 1
                        setOverlay("show-n")
                        setLoadShow("show-n")
                        return
                    }
                    else if (!eximTransporters.includes(node.data.transporter_code)) {
                        setShow(true)
                        setTitle("Please give a valid Transporter Code")
                        setType("danger")
                        gridApi.current.refreshCells()
                        error = 1
                        setOverlay("show-n")
                        setLoadShow("show-n")
                        return
                    }
                    else if (!eximDealers.includes(node.data.dealer_code) && !eximPlantData.includes(node.data.dealer_code)) {
                        setShow(true)
                        setTitle("Please give a valid Customer Code")
                        setType("danger")
                        gridApi.current.refreshCells()
                        error = 1
                        setOverlay("show-n")
                        setLoadShow("show-n")
                        return
                    }
                    else if (!moment(node.data.date_of_dispatch, "DD/MM/YYYY HH:mm", true).isValid()) {
                        setShow(true)
                        setTitle("Please give a valid Expected Date (DD/MM/YYYY HH:mm)")
                        setType("danger")
                        gridApi.current.refreshCells()
                        error = 1
                        setOverlay("show-n")
                        setLoadShow("show-n")
                        return
                    }
                    else if ((!node.data.vehicle_no)) {
                        setShow(true)
                        setTitle("Please give a valid Truck Number")
                        setType("danger")
                        gridApi.current.refreshCells()
                        error = 1
                        setOverlay("show-n")
                        setLoadShow("show-n")
                        return
                    }
                    else
                        gridRowData.push(node.data)
                })
                if (gridRowData.length > 0 && error === 0) {
                    try {
                        const responseData = await uploadBulkEximExcel(gridRowData)
                        const excelResponseData = responseData?.data?.data
                        if (excelResponseData?.status == "success") {
                            setShow(true)
                            setTitle(excelResponseData?.message)
                            setType("success")
                            setBulkUploadModal(false)
                            setModalLoadData([])
                            setValidData([])
                            setInvalidData([])
                            // fileRef.current.value = ''
                            setBulkType('')
                            loadConsignmentsData()
                            setOverlay("show-n")
                            setLoadShow("show-n")
                        }
                        else if (error == 0) {
                            setShow(true)
                            setTitle(excelResponseData?.message)
                            setType("danger")
                            setOverlay("show-n")
                            setLoadShow("show-n")
                            setValidData([])
                            setInvalidData([])
                            fileRef.current.value = ''
                            setBulkType('')
                        }

                    }
                    catch (e) {
                        return e
                    }
                }
                else if (error == 0) {
                    setShow(true)
                    setTitle("File input is required. Please choose a file")
                    setType("danger")
                    setOverlay("show-n")
                    setLoadShow("show-n")
                }
            }
        }
    }
    const onConfirm = () => {
        setShow(false);
        setTitle('')
        setType('default')
        if (reloadPage.current && reloadPage.current == 4) {
            setTimeout(async () => {
                await columnApiConsignments.current.api.applyColumnState({
                    state: gridColumnState.current,
                    applyOrder: true,
                })
            }, 1000);
        }
        else if (reloadPage.current && reloadPage.current != 4) {
            window.location.reload()
        }
        else if (type == "success") {
            loadConsignmentsData()
        }
    };

    const resetSearch2 = (e) => {
        setSearchCity({ label: '', value: '' })
        setSearchStates({ label: '', value: '' })
        setSearchTransporters({ label: '', value: '' })
        setSearchConsigner([{ label: 'All', value: 'all' }])
        setStartDate(new Date(moment.parseZone().subtract(1, "month")))
        setEndDate(new Date(moment.parseZone()))
        loadConsignmentsData()
    }

    const onGetConsignments = async (event) => {
        let query = {}
        if (searchCity.value != '')
            query["consignee_city"] = searchCity.value
        if (startDate == '' || startDate == "NaN-NaN-NaN") {
            var sDate = "";
        }
        else {
            query["sdate"] = moment.parseZone(new Date(startDate)).format("YYYY-MM-DD")
        }
        if (endDate == '' || startDate == "NaN-NaN-NaN") {
            var eDate = "";
        }
        else {
            query["edate"] = moment.parseZone(new Date(endDate)).format("YYYY-MM-DD")
        }
        if (searchConsigner == null || searchConsigner[0]?.value == '' || searchConsigner[0]?.value == 'all') {
        }
        else {
            query["consigner_code"] = searchConsigner.map(e => e.value)
        }
        if (searchState.value != '') {
            query["consignee_state"] = searchState.value
        }
        if (searchTransporters.value != "") {
            query["transporter_name"] = searchTransporters.value
        }
        if (user.role[0] == "DEALER")
            query["user_code"] = user.dealer_code ?? "EMPTY"
        else if (user.role[0] == "PLANT") {
            query["plant_codes"] = user.plant_codes ?? "EMPTY"
        } else if (user.role[0] == "TRANSPORTER") {
            query["transporter_code"] = user.transporter_code ?? "EMPTY"
        }
        await redirectURL.post("consignments/filterConsignments", query)
            .then(resp => {
                fragmentData(resp)
            })
            .catch(err => console.log(err))
    }

    const onGridReady = useCallback((params) => {
        gridApi.current = params.api
    }, []);

    const onGridReadyConsignments = useCallback(async (params) => {
        // getCurrentTabGridStatus(params)
    }, []);

    const getCurrentTabGridStatus = async (params = null) => {
        let tab_coloumndef = ''
        if (window.location.pathname == "/active-FOs") {
            tab_coloumndef = 'consignments_active'
        }
        else if (window.location.pathname == "/all-FOs") {
            tab_coloumndef = 'consignments_all'
        }
        else if (window.location.pathname == "/delivered-FOs") {
            tab_coloumndef = 'consignments_delivered'
        }
        await fetchGridLayout(user.email, tab_coloumndef)
            .then(async res => {
                if (res.data.status == "success" && Array.isArray(res.data.data[0].columnState) && res.data.data[0].columnState.length > 0) {
                    let coloumnAPI = ''
                    if (params == null)
                        coloumnAPI = columnApiConsignments.current.api
                    else
                        coloumnAPI = params.api
                    gridColumnState.current = res.data.data[0].columnState
                    setTimeout(async () => {
                        await coloumnAPI.applyColumnState({
                            state: res.data.data[0].columnState,
                            applyOrder: true,
                        })
                    }, 1500);
                    if (window.location.pathname == "/active-FOs") {
                        coloumnAPI.setFilterModel(null); // Clear all filters
                        coloumnAPI.setColumnsVisible(["unloading_click", "force_closure_reason", "force_closure_reason_secondary", "force_closure_performed_by", "dealerin_flag", "dealerout_flag"], false);
                        coloumnAPI.setColumnsVisible(["force_close"], true);
                    }
                    else if (window.location.pathname == "/all-FOs") {
                        coloumnAPI.setFilterModel(null); // Clear all filters
                        coloumnAPI.setColumnsVisible(["unloading_click", "force_closure_reason", "force_closure_reason_secondary", "force_closure_performed_by", "force_close", "dealerin_flag", "dealerout_flag"], true);
                    }
                    else if (window.location.pathname == "/delivered-FOs") {
                        coloumnAPI.setFilterModel(null); // Clear all filters
                        coloumnAPI.setColumnsVisible(["unloading_click", "force_closure_reason", "force_closure_reason_secondary", "force_closure_performed_by", "dealerin_flag", "dealerout_flag"], true);
                        coloumnAPI.setColumnsVisible(["force_close"], false);
                    }
                }
                else {
                    let coloumnAPI = ''
                    if (params == null)
                        coloumnAPI = columnApiConsignments.current.api
                    else
                        coloumnAPI = params.api
                    const defaultState = columnDefs3.map((col) => ({
                        colId: col.field,
                        hide: false,
                        pinned: col.pinned || null,
                        width: col.width,
                    }));
                    setTimeout(async () => {
                        await coloumnAPI.applyColumnState({
                            state: defaultState,
                            applyOrder: true,
                        })
                    }, 1500);
                }
            })
            .catch(err => console.log(err))
    }

    const getRowStyle = (params) => {
        if (params.data.hot_loads == 1) {
            return { backgroundColor: '#F4E0AF' };
        }
        if (params.data.invalid_driver_no != undefined && params.data.invalid_driver_no == 1) {
            return { backgroundColor: "#ff90a3" }
        }
        return undefined;
    };

    const onCellClicked = (row) => {
        if (row.colDef.field == "tansit_delay_click") {
            // onShowTransitData(row)
        }
        else if (row.colDef.field == "no_gps_click") {
            onShowNoGPSData(row)
        }
        else if (row.colDef.field == "overspeeding_click") {
            onShowOverspeedingData(row)
        }
        else if (row.colDef.field == "nigthdriving_click") {
            onShowNightDrivingData(row)
        }
        else if (row.colDef.field == "stoppage_click") {
            onShowStoppagesData(row)
        }
        else if (row.colDef.field == "deviation_click") {
            onShowTripDeviation(row)
        }
        else if (row.colDef.field == "loading_click") {
            onShowLoadingData(row)
        }
        else if (row.colDef.field == "unloading_click") {
            onShowUnloadingData(row)
        }
        else if (row.colDef.field == "fo_details") {
            onShowFoDetails(row)
        }
        else if (row.colDef.field == "item_details") {
            onShowItemDetails(row)
        }
    }
    const handleCloseModal = () => {
        setChecklist(false);
    };
    const handleBulkOption = (selectedOption) => {
        if (fileRef && fileRef.current)
            fileRef.current.value = ''
        setBulkType(selectedOption)
        setModalLoadData([])
        setValidData([])
        setInvalidData([])
    }
    const onCellValueChanged = () => {
        gridApi.current.refreshCells()

    };
    const handleTabChange = (tabKey) => {
        setActiveTab(tabKey, validData);
        setModalLoadData(tabKey === 'valid' ? validData : invalidData);
    };
    const invalidEximColumn = {
        headerName: "Remarks",
        field: "reason",
        valueGetter: function (params) {
            let message = []
            // message.push("invalid plant code")
            if (!!!params.data.plant_code || (!eximPlantData.includes(params.data.plant_code) && !eximDealers.includes(params.data.plant_code))) {
                message.push("invalid plant code")
            }
            if (params.data.status == 'invalid' || !params.data.fo_number) {
                message.push("invalid container number")
            }
            if (!!!params.data.dealer_code || (!eximPlantData.includes(params.data.dealer_code) && !eximDealers.includes(params.data.dealer_code))) {
                message.push("invalid consignee")
            }
            if (params.data.vehicle_no == '') {
                message.push("invalid truck no.")
            }
            if (params.data.transporter_code == '' || !eximTransporters.includes(params.data.transporter_code)) {
                message.push("invalid transporter code")
            }
            if (params.data.date_of_dispatch == '' || (!moment(params.data.date_of_dispatch, "DD/MM/YYYY HH:mm", true).isValid())) {
                message.push("invalid dispatch date")
            }
            params.data.remarks = message.join(", ");
            return params.data.remarks;
        }
    };
    const validPlantCodes = useMemo(() => plantData.map(p => String(p.consigner_code).trim()), [plantData]);
    const validDealerCodes = useMemo(() => dealers.map(p => String(p.consignee_code).trim()), [dealers]);
    const validTransporterCodes = useMemo(() => transporters.map(p => String(p.transporter_code).trim()), [transporters]);
    const invalidConsignmentColumn = {
        headerName: "Remarks",
        field: '',
        valueGetter: function (params) {
            let message = []
            if (!params.data.fo_number || !params.data.fo_number.startsWith('I30') || params.data.status == "invalid") {
                message.push("invalid FO number")
            }
            if (!!!params.data.plant_code || !validPlantCodes.includes(params.data.plant_code)) {
                message.push("invalid plant code")
            }
            if (!!!params.data.invoice_date || (!moment(params.data.invoice_date, "DD/MM/YYYY HH:mm", false).isValid())) {
                message.push("invalid invoice date")
            }
            if (!!!params.data.vehicle_no) {
                message.push("invalid vehicle no")
            }
            if (!!!params.data.driver_name) {
                message.push("invalid driver name")
            }
            if (!!!params.data.driver_number || params.data.driver_number.length != 10) {
                message.push("invalid driver no")
            }
            if (!!!params.data.transporter_code || !validTransporterCodes.includes(params.data.transporter_code)) {
                message.push("invalid transporter code")
            }
            if (!!!params.data.dealer_code || !validDealerCodes.includes(params.data.dealer_code)) {
                message.push("invalid consignee code")
            }
            if (!!!params.data.expected_date || (!moment(params.data.expected_date, "DD/MM/YYYY HH:mm", false).isValid())) {
                message.push("invalid expected date")
            }
            params.data.remarks = message.join(", ");
            return params.data.remarks;
        }
    }
    const eximColumnDefs = useMemo(() => {
        return activeTab === "invalid"
            ? [...columnDefs, invalidEximColumn]
            : columnDefs;
    }, [activeTab]);
    const consignmentColumnDef = useMemo(() => {
        return activeTab === "invalid"
            ? [...validConsignmentColumnDef, invalidConsignmentColumn]
            : validConsignmentColumnDef;
    }, [activeTab]);


    const invalidExcelExport = () => {
        if (!invalidData || invalidData.length === 0) {
            alert("No invalid data to export.");
            return;
        }

        // Format data for Export type
        const exportFormatted = invalidData.map(item => ({
            "Container No": item.fo_number || '',
            "Plant Code": item.plant_code || '',
            "Consignee Code": item.dealer_code || '',
            "Truck No": item.vehicle_no || '',
            "Transporter Code": item.transporter_code || '',
            "Date & Time Of Dispatch": item.date_of_dispatch ? item.date_of_dispatch : '',
            "Reamrks": item.remarks || ''
        }));

        // Format data for other types (e.g. Consignment)
        const consignmentExportFormat = invalidData.map(item => ({
            "Plant Location Code": item.plant_code || '',
            "Fo Number": item.fo_number || '',
            "Invoice Date": item.invoice_date ? item.invoice_date : '',
            "Vehicle No": item.vehicle_no || '',
            "Vehicle Type": item.vehicle_type || '',
            "Driver Name": item.driver_name || '',
            "Driver No": item.driver_no || '',
            "Transporter Code": item.transporter_code || '',
            "Transporter Name": item.transporter_name || '',
            "Dealer Code": item.dealer_code || '',
            "Dealer Name": item.dealer_name || '',
            "Dealer City": item.dealer_city || '',
            "Expected Delivery Date": item.expected_date ? item.expected_date : '',
            "Remarks": item.remarks || ''
        }));

        const dataToExport = bulkType?.value === 'Export' ? exportFormatted : consignmentExportFormat;

        // Create worksheet and workbook
        const worksheet = XLSX.utils.json_to_sheet(dataToExport);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Invalid Records");


        // File name with timestamp
        const fileName = `Invalid_Records_${new Date().toISOString().slice(0, 19).replace(/[:T]/g, '-')}.xlsx`;
        XLSX.writeFile(workbook, fileName);
    };


    return (
        <div>
            <SweetAlert
                show={show}
                title={<span style={{ fontSize: "1rem" }}>{title}</span>}
                onConfirm={onConfirm}
                confirmBtnBsStyle={type}
                confirmBtnCssClass="sweetButton"
                customClass='sweetWidth'
                type={type}>
            </SweetAlert>
            <Modal
                onHide={closeForceCloseModal}
                dialogClassName="my-modal"
                show={forcecloseModal}
                centered>
                <Modal.Header>
                    <Modal.Title>Force Close</Modal.Title>
                    <div className="btn-box d-flex gap-3">
                        <button type="button" className="btn btn-sm btn-icon btn-outline-primary" data-bs-dismiss="modal" aria-label="Close" onClick={closeForceCloseModal}>
                            <i className="fa fa-times"></i>
                        </button>
                    </div>
                </Modal.Header>
                <Modal.Body className="view-task">
                    <ModelForceClose rownode={rownode} setShow={setShow} setTitle={setTitle} setType={setType} changeReloadPage={changeReloadPage} closeForceCloseModal={closeForceCloseModal} user={user} />
                </Modal.Body>
            </Modal>
            {/* <div className='col-xl-9 col-lg-8' style={{ backgroundColor: "#ffff", borderRadius: "2px" }}>
                            <marquee direct="left" scrollAmount="4" onMouseOver="this.stop()">
                                <ul className="feeds">
                                    {(feeds.length > 0 && feeds !== undefined) ?
                                        (feeds.map((feed) =>
                                            <li>
                                                <a href={feed.url} target="_blank">
                                                    {feed.headline}
                                                </a>
                                            </li>
                                        ))
                                        : ""}
                                </ul>
                            </marquee>
                        </div> */}
            <h5 className="mb-15p fbold f16">
                <i className="icofont icofont-vehicle-delivery-van cus-i"></i> <span style={{ fontWeight: "600" }}>Consignments Information</span>
            </h5>
            <div className="row" style={{ marginBottom: "1%" }}>
                <div className="col-xl-12 col-lg-12">
                    <button
                        onClick={(e) => navigate("/active-FOs")}
                        className={(tabName.value == "active") ? "btn btn-info f14" : "btn tab-btn f14"}
                        style={{
                            display: (tabName.value == "active") ? "inline-flex" : ""
                        }}>
                        Active
                    </button>
                    <button
                        onClick={(e) => navigate("/delivered-FOs")}
                        className={(tabName.value == "completed") ? "btn btn-info f14" : "btn tab-btn f14"}
                        style={{
                            display: (tabName.value == "completed") ? "inline-flex" : ""
                        }}>
                        Delivered
                    </button>
                    <button
                        onClick={(e) => navigate("/all-FOs")}
                        className={(tabName.value == "all") ? "btn btn-info f14" : "btn tab-btn f14"}
                        style={{
                            display: (tabName.value == "all") ? "inline-flex" : ""
                        }}>
                        All
                    </button>
                    {
                        (user?.role[0] != undefined && user?.role == "ADMIN" || user?.role == 'SUPERADMIN' || user?.role == 'RLM') ?
                            <button
                                title="Bulk Upload"
                                onClick={onClickOpenBulkUploadModal}
                                className={"float-right f14 btn btn-warning mr-2"}
                                type="button">
                                <i className="fa fa-upload"></i>&nbsp;&nbsp;&nbsp;Upload Consignments
                            </button> :
                            <></>
                    }
                    <div className='float-right' style={{ paddingRight: "8px" }}>
                        <ToggleSwitch toggle={toggle} setToggle={setToggle} />
                    </div>
                    <i className='fa fa-search mx-2' title='Search' onClick={(e) => setFilterToggle(prev => !prev)} style={{ cursor: "pointer", float: "right", fontSize: "1rem", padding: "8px" }} />
                </div>
            </div>
            <div className={filterToggle ? "filter-in" : "filter-out"}>
                {
                    filterToggle &&
                    <Filters filterCardStyle1={filterCardStyle1} loadConsignmentsData={loadConsignmentsData} user={user}
                        consignersList={consignersList} filterCities={filterCities} setOverlay={setOverlay} setLoadShow={setLoadShow}
                        filterStates={filterStates} filterTransporters={filterTransporters} fragmentData={fragmentData}
                        filterToggle={filterToggle} consigneesList={consigneesList}
                        filterConsigneeZones={filterConsigneeZones} filterConsigneeTypes={filterConsigneeTypes}
                        filterPlantZones={filterPlantZones} />
                }
            </div>
            {
                tabName?.value == "active" || tabName?.value == "all" ?
                    <>
                        <div>
                            <MainCounters middleCounter={middleCounter} CPCounterDate={CPCounterDate} counter={topCounterAlt.current} setCounter={CounterClick} toggle={toggle} data={activeTopCounters} dataMiddle={activeTripsCounter} tabName={tabName} />
                        </div>
                    </> :
                    <>
                        {
                            tabName?.value == "completed" ?
                                <DeliveredCounters counter={topCounterAlt.current} toggle={toggle} setCounter={CounterClickDelivered} data={deliveredTripsCounter} />
                                :
                                <></>
                        }
                    </>
            }
            <div className="row">
                <div className="col-xl-12 col-lg-12">
                    <div className="card">
                        <div className="card-header main-page-display">
                            <h5>
                                <i className="icofont icofont-vehicle-delivery-van cus-i"></i> <span>{`${tabName?.label} - ${topCounterAlt.current?.label}`}</span>
                            </h5>
                            <div>
                                <button type="button" title="Reset Grid Layout" name="resetgrid" className="btn btn-info float-right action_btn main-page-gridbutton" onClick={resetGrid}> <i className="fa fa-reply"></i> </button>
                                <button type="button" title="Save Grid Layout" name="savegrid" className="btn btn-success float-right action_btn main-page-gridbutton" onClick={saveGrid}> <i className="fa fa-save"></i> </button>
                                {
                                    tabName.value != "completed" ?
                                        <>
                                            {
                                                topCounterAlt.current.value == "hot_loads" ?
                                                    <button type="button" title="Unmark Consignment as Hot Loads" className="btn btn-danger float-right action_btn main-page-button" style={{ marginLeft: "10px" }} onClick={unmarkHotLoads}>Unmark Hot Loads</button> :
                                                    <button type="button" title="Mark Consignment as Hot Loads" className="btn btn-info float-right action_btn main-page-button" style={{ marginLeft: "10px" }} onClick={markHotLoads}>Mark Hot Loads</button>
                                            }
                                            <BulkForceClose setOverlay={setOverlay} setType={setType} setTitle={setTitle}
                                                setShow={setShow} loadConsignmentsData={loadConsignmentsData} user={user} data={forceClosureData} />
                                            <BulkUploadHL setOverlay={setOverlay} setType={setType} setTitle={setTitle}
                                                setShow={setShow} loadConsignmentsData={loadConsignmentsData} />
                                        </> :
                                        <></>
                                }
                                {toast?.showToast && (
                                    <Toast
                                        message={toast?.toastMessage}
                                        onClose={() => setToast(prev => ({ ...prev, showToast: false }))}
                                        title={toast?.toastTitle}
                                        image={toast?.toastImage}
                                    />
                                )}
                                {rowData.length ? <button className="bth btn-success float-right action_btn main-page-button download_button" type='button' name="checklist" onClick={downloadChecklist}>Bulk Download Outbound Checklist</button> : <></>}
                                {rowData.length ? <button className="bth btn-success float-right action_btn main-page-button download_button " type='button' name="checklist" onClick={downloadInboundChecklist} style={{ marginRight: "15px" }}>Bulk Download Inbound Checklist</button> : <></>}
                            </div>
                        </div>
                        <div className="card-body pt-10px" >
                            <div className="row">
                                <div className="col-xl-12 col-lg-12 mb-10p">
                                    <Legends tabName={tabName} />
                                </div>
                            </div>
                            <div className={"ag-theme-balham mt-8"} style={{ height: '500px', width: '100%', paddingTop: "1rem" }}>
                                <AgGridReact
                                    ref={columnApiConsignments}
                                    columnDefs={columnDefs3}
                                    rowData={rowData}
                                    defaultColDef={defaultColDef}
                                    pagination={true}
                                    paginationPageSize={50}
                                    onGridReady={onGridReadyConsignments}
                                    enableRangeSelection={true}
                                    enableCellContextMenu={true}
                                    masterDetail={true}
                                    detailCellRendererParams={detailCellRendererParams || []}
                                    onCellClicked={onCellClicked}
                                    getRowStyle={getRowStyle}
                                    rowSelection="multiple"
                                    suppressRowClickSelection={true} // optional, but good UX
                                    sideBar={{
                                        toolPanels: [
                                            {
                                                id: "columns",
                                                labelDefault: "Columns",
                                                labelKey: "columns",
                                                iconKey: "columns",
                                                toolPanel: "agColumnsToolPanel",
                                                toolPanelParams: {
                                                    suppressPivotMode: true,
                                                    suppressRowGroups: true,
                                                    suppressValues: true,
                                                }
                                            },
                                            {
                                                id: "filters",
                                                labelDefault: "Filters",
                                                labelKey: "filters",
                                                iconKey: "filter",
                                                toolPanel: "agFiltersToolPanel"
                                            }
                                        ]
                                    }}
                                    statusBar={{
                                        statusPanels: [
                                            {
                                                statusPanel: "agTotalAndFilteredRowCountComponent",
                                                align: "left"
                                            },
                                            {
                                                statusPanel: "agTotalRowCountComponent",
                                                align: "center"
                                            },
                                            { statusPanel: "agFilteredRowCountComponent" },
                                            { statusPanel: "agSelectedRowCountComponent" },
                                            { statusPanel: "agAggregationComponent" }
                                        ]
                                    }}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {
                openMap.sliderRouteTranslate != '' ?
                    <div className={"slide-r " + (openMap.sliderRouteTranslate)} style={{ overflow: "auto" }}>
                        <div className="slide-r-title">
                            <h4>
                                {(openMap.consignment_code)}
                                <span className="float-right closebtn" style={{ marginRight: "25px" }} onClick={closeMapModal} >X</span>
                            </h4>
                        </div>
                        <div className="slide-r-body" style={{ position: "relative" }}>
                            <div className="row col-xl-12 col-lg-12 ml-0p n-p-0">
                                <DrawMap
                                    rownode={openMap.rownode}
                                    mapFor={"consignment"}
                                    tolls={openMap.tolls}
                                    googleroutes={openMap.googelRoutes}
                                    truckno={openMap.maptruckno}
                                    dealer={openMap.dealer}
                                    mapinfo={openMap.mapinfo}
                                    deptcode={openMap.deptcode}
                                    defTransitCoords={openMap.defTransitCoords}
                                    baseRouteCoords={openMap.baseRouteCoords}
                                    geofence_coordinates={openMap.geofence_coordinates}
                                    parking_coordinates={openMap.parking_coordinates}
                                />
                                <div className="col-xl-12 col-lg-12 n-p-0">
                                    <div className="crm-numbers pb-0">
                                        <h3 className="subH">{openMap.sidebarSubHeader}</h3>
                                        <div className="col-xl-12 col-lg-12 row">
                                            <div className="col route-block">
                                                <label className="sidebar-label">Vehicle No.</label>
                                                <div>{openMap.routeTruck.truck_no}</div>
                                            </div>
                                            <div className="col route-block">
                                                <label className="sidebar-label">Start Time</label>
                                                <div>{(!isEmpty(openMap.mapinfo.route_details)) ? getHyphenDDMMMYYYYHHMM(openMap.mapinfo.route_details.start_time) : "-"}</div>
                                            </div>
                                            <div className="col route-block">
                                                <label className="sidebar-label">End Time</label>
                                                <div>{(!isEmpty(openMap.mapinfo.route_details)) ? getHyphenDDMMMYYYYHHMM(openMap.mapinfo.route_details.end_time) : "-"}</div>
                                            </div>

                                            <div className="col route-block">
                                                <label className="sidebar-label">GPS Distance</label>
                                                <div>{(!isEmpty(openMap.mapinfo.route_details)) ? Math.round(openMap.mapinfo.route_details.distance_without_google / 1000) : "0"} Kms</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                    : ""
            }
            {
                openMap2.open ?
                    <DeviationRouteMap openMap={openMap2} closeMapModal={closeMapModal}
                        show={show} title={title} onConfirm={onConfirm} type={type}
                        setShow={setShow} setTitle={setTitle} setType={setType}
                        setLoadShow={setLoadShow} setOverlay={setOverlay} />
                    : ""
            }
            <div className={"slide-r " + (bulkUploadModal.bulkPrioritySlide)} style={{ overflow: "auto" }}>
                <h3 className="subH">Bulk Upload
                    <span className="float-right closebtn" style={{ marginRight: "25px" }} onClick={closeBulkUploadModal} >X</span>
                </h3>
                <div className="slide-r-body" style={{ position: "relative" }}>
                    <div className={"dataLoad " + (overly2)} style={{ opacity: "0.5" }}>
                        <div style={{ position: "fixed", left: "50%", top: '50%' }}>
                            <div class="loader-box">
                                <div class="loader-box">
                                    <div class="rotate dashed colored"></div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className='invalid_filed'>
                        <div className='col-4'>
                            <label className='consignments_label'>Select Movement Type<span style={{ color: 'red' }}>*</span></label>
                            <Select
                                placeholder="Select Type..."
                                options={[{ label: "Road", value: "Road" }, { label: "Export", value: "Export" }]}
                                value={bulkType}
                                onChange={handleBulkOption}
                            />
                        </div>
                        {bulkType != "" ? <div className='invalid_filed'><form method="POST" id="upform" className="form-group">
                            <div className="col-10">
                                <label className="">Upload File</label>
                                <input type="file" name="uploadFile" id="bulkUploadCritical" onChange={changeFileHandler} className="form-control" required ref={fileRef} />
                            </div>
                        </form>
                            <div className='col-4' style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                                <div className="form-group" id='form_group'>
                                    <label>&nbsp;</label>
                                    <a className="btn btn-primary" href={bulkType?.value == 'Road' ? require('../../assets/files/Nestle Autometrics Consignments Format.xlsx') : require('../../assets/files/Nestle Autometrics EXIM Format.xlsx')} target="_blank">Sample Template</a>
                                </div>
                            </div>
                        </div> : <></>}
                    </div>
                    {bulkType != '' ? <div className='container-fluid'>
                        <div className='invalid_filed'>
                            <div className='button_container'>
                                <div>
                                    <button
                                        className={activeTab === 'valid' ? 'exim-tab-button exim-active' : 'exim-tab-button'}
                                        onClick={() => handleTabChange('valid')}
                                    >
                                        {`Valid Data ${validData.length > 0 ? `(${validData.length})` : ''}`}
                                    </button>
                                    <button
                                        className={activeTab === 'invalid' ? 'exim-tab-button exim-active' : 'exim-tab-button'}
                                        onClick={() => handleTabChange('invalid')}
                                    >
                                        {`Invalid Data ${invalidData.length > 0 ? `(${invalidData.length})` : ''}`}
                                    </button>
                                </div>
                            </div>
                            {activeTab == 'invalid' ? <div><i className="fa fa-circle" style={{ color: "#c85f62" }}></i>&nbsp; Invalid Field Value</div> : ''}</div>
                        <div className="ag-theme-balham" style={{ height: '58vh', width: '100%' }}>
                            <AgGridReact
                                columnDefs={bulkType?.value == 'Road' ? consignmentColumnDef : eximColumnDefs}
                                rowData={modalloadData}
                                defaultColDef={defaultColDef}
                                onGridReady={onGridReady}
                                pagination={true}
                                paginationPageSize={50}
                                enableRangeSelection={true}
                                enableCellContextMenu={true}
                                stopEditingWhenGridLosesFocus={true}
                                onCellValueChanged={onCellValueChanged}
                                sideBar={{
                                    toolPanels: [
                                        {
                                            id: "columns",
                                            labelDefault: "Columns",
                                            labelKey: "columns",
                                            iconKey: "columns",
                                            toolPanel: "agColumnsToolPanel",
                                            toolPanelParams: {
                                                suppressPivotMode: true,
                                                suppressRowGroups: true,
                                                suppressValues: true,
                                            }
                                        },
                                        {
                                            id: "filters",
                                            labelDefault: "Filters",
                                            labelKey: "filters",
                                            iconKey: "filter",
                                            toolPanel: "agFiltersToolPanel"
                                        }
                                    ]
                                }}
                                statusBar={{
                                    statusPanels: [
                                        {
                                            statusPanel: "agTotalAndFilteredRowCountComponent",
                                            align: "left"
                                        },
                                        {
                                            statusPanel: "agTotalRowCountComponent",
                                            align: "center"
                                        },
                                        { statusPanel: "agFilteredRowCountComponent" },
                                        { statusPanel: "agSelectedRowCountComponent" },
                                        { statusPanel: "agAggregationComponent" }
                                    ]
                                }} />
                        </div>
                        <br />
                        <div className="form-group" id='button-group'>
                            <button type="button" onClick={closeBulkUploadModal} className="btn btn-default">Cancel</button>
                            {activeTab == 'valid' ? <button type="submit" className="btn btn-success" onClick={saveConsignments}>Submit</button> : <button className='btn btn-success' onClick={invalidExcelExport}>Export</button>}
                        </div>
                        <br />
                        <br />
                    </div> : <></>}
                </div>
            </div>
            {<CheckList
                visible={checklist}
                onClose={handleCloseModal}
                data={checklistData}
            />}
            {<OtrView
                showOtr={showOtr}
                onClose={() => { setShowOtr(false) }}
                data={otrData}
            />}
            <div className={"overlay-part " + (overly)} style={{ zIndex: "10" }}
                onClick={onClickHideAll}
            ></div>
            <div className={"dataLoadpage " + (loadshow)}></div>
            <div className={"dataLoadpageimg " + (loadshow)} style={{ top: "21em" }}>
                <div className="loader-box"><div className="loader-box"><div className="rotate dashed colored"></div></div></div>
            </div>
        </div>
    );
}

export default memo(ActiveConsignments);

function loadScript(url) {
    var index = window.document.getElementsByTagName("script")[0]
    var script = window.document.createElement("script")
    script.src = url
    script.async = true
    script.defer = true
    index.parentNode.insertBefore(script, index)
}
function secondsToString(seconds) {
    if (isNaN(seconds))
        return "N/A"
    var numdays = Math.floor(seconds / 86400);
    var numhours = Math.floor((seconds % 86400) / 3600);
    var numminutes = Math.floor(((seconds % 86400) % 3600) / 60);
    var numseconds = ((seconds % 86400) % 3600) % 60;
    return numdays + " days " + numhours + " hours " + numminutes + " minutes ";
}

function secondsToDays(seconds) {
    var numdays = Math.floor(seconds / 86400);
    var numhours = Math.floor((seconds % 86400) / 3600);
    var numminutes = Math.floor(((seconds % 86400) % 3600) / 60);
    var numseconds = ((seconds % 86400) % 3600) % 60;
    return numdays;
}

function isEmpty(obj) {
    for (var key in obj) {
        if (obj.hasOwnProperty(key))
            return false;
    }
    return true;
}
function parseJSONSafely(data, key) {
    try {
        if (data[key] == undefined)
            return []
        return JSON.parse(data[key]);
    } catch (error) {
        console.error(`Error parsing JSON for key "${key}":`, error);
        return []; // Return a default value, e.g., null or an empty object
    }
}
